module.exports = {
	"fi": {
		"moet-core": {
			"select_language": {
				"title": "Valitse kieli",
				"paragraph": "Tämä on nyt oletuskielesi.",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Sisältyy aina",
				"kco": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Tarjoa kaikkia maksutapojamme."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Maksa heti"
							},
							"description": {
								"default": "Tarjoa maksua välittömästi kortilla tai pankkisiirrolla."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Maksa myöhemmin"
							},
							"description": {
								"default": "Tarjoa 30 päivää maksuaikaa. Ei korkoa."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Pilko maksut"
							},
							"description": {
								"default": "Tarjoa maksuaikaa 6–36 kuukautta.",
								"DE": "Tarjoa maksuaikaa 6–24 kuukautta",
								"AT": "Tarjoa maksuaikaa 6–24 kuukautta."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "erään"
							},
							"description": {
								"default": "Tarjoa 3 korotonta erää.",
								"GB": "Tarjoa 3 korotonta erää."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Pilko maksut 4",
								"US": "erään",
								"AU": "Maksa 4 erässä"
							},
							"description": {
								"default": "Tarjoa 4 korotonta erää.",
								"GB": "Tarjoa 4 korotonta erää."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Maksutavat"
					},
					"description": {
						"default": "Valitse yksittäisistä maksuratkaisuistamme. Valitse yksi tai yhdistä useampi. Yksinkertainen, kertaluonteinen integrointi huolimatta siitä, mitä valitset."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Maksa heti"
							},
							"description": {
								"default": "Tarjoa maksua välittömästi kortilla tai pankkisiirrolla."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Maksa myöhemmin"
							},
							"description": {
								"default": "Tarjoa 30 päivää maksuaikaa. Ei korkoa."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Pilko maksut"
							},
							"description": {
								"default": "Tarjoa maksuaikaa 6–36 kuukautta.",
								"DE": "Tarjoa maksuaikaa 6–24 kuukautta",
								"AT": "Tarjoa maksuaikaa 6–24 kuukautta."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "erään"
							},
							"description": {
								"default": "Tarjoa 3 korotonta erää.",
								"GB": "Tarjoa 3 korotonta erää."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Pilko maksut 4",
								"US": "4 maksuerää",
								"CA": "4 maksua",
								"AU": "Maksa 4 erässä"
							},
							"description": {
								"default": "Tarjoa 4 korotonta erää.",
								"GB": "Tarjoa 4 korotonta erää.",
								"US": "Arvoltaan 35–1 000 $:n tilaukset voidaan pilkkoa neljään korottomaan maksuerään, jotka erääntyvät kahden viikon välein.",
								"CA": "Arvoltaan 35–1 000 $:n tilaukset voidaan pilkkoa neljään korottomaan maksuerään, jotka erääntyvät kahden viikon välein."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Vaihda kauppasi kassa Klarnan kattaviin kassapalveluihin."
					},
					"description_expanded": {
						"default": "Vaihda kauppasi kassa Klarnan kattaviin kassapalveluihin."
					}
				},
				"kp_one": {
					"name": {
						"default": "Maksutapa"
					},
					"description": {
						"default": "Lisää Klarnan maksutavat nykyiseen kassaasi"
					},
					"description_expanded": {
						"default": "Klarna-maksutapojen tarjoaminen nostaa konversiota keskimäärin 30 %, tilauksen keskimääräistä arvoa 41 % ja ostojen toistuvuutta 36 %."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Tämä kenttä on pakollinen, jotta voit jatkaa",
					"generic": "Antamasi arvo ei kelpaa",
					"required_suffix": "on pakollinen, jotta voit jatkaa",
					"generic_suffix": "on virheellinen",
					"min_one": "Sinun tulee valita vähintään yksi elementti",
					"min": "Sinun tulee valita vähintään {min} elementtiä",
					"max": "Et voi valita yli {max} elementtiä",
					"given_name": "Etunimi puuttuu",
					"family_name": {
						"general": "Sukunimi puuttuu",
						"too_short": "Anna kelvollinen sukunimi"
					},
					"date_of_birth": {
						"general": {
							"default": "Syntymäaika puuttuu (PP/KK/VVVV)",
							"US": "Syntymäaika puuttuu (PP/KK/VVVV)"
						},
						"too_young": "Kaikkien sidosryhmäläisten tulee olla vähintään 16-vuotiaita",
						"too_young_eighteen": "Sinun tulee olla vähintään 18-vuotias"
					},
					"street_address": "Anna osoite",
					"street_address2": "Anna kelvollinen osoite osoiteriville 2",
					"postal_code": "Anna postinumero",
					"country": "Anna maa",
					"region": "Anna alue",
					"state": "Anna maakunta",
					"iban": "Anna tilinumero (IBAN)",
					"companyName": "Anna yrityksen nimi",
					"email": "Anna kelvollinen sähköposti",
					"contact_email": "Anna kelvollinen sähköposti yhteydenottoja varten",
					"support_email": "Anna kelvollinen sähköposti asiakkaan tukemista varten",
					"support_phone": "Anna kelvollinen tukipuhelinnumero",
					"selling_countries": "Sinun tulee valita vähintään yksi maa",
					"store_category": "Sinun tulee valita yksi vaihtoehdoista",
					"name": "Anna kaupan nimi",
					"legal_form": "Valitse yksi luetteloiduista liiketoiminnan tyypeistä",
					"generic_toggle_undefined": "Valitse yksi vaihtoehdoista",
					"website": "Anna kelvollinen verkkosivun osoite",
					"bankAccounts": "Anna vähintään yksi pankkitili",
					"product": "Valitse tuote",
					"platform": "Valitse alusta",
					"password": "Luo vahva salasana",
					"currency_code": "Anna valuuttakoodi",
					"account_holder": "Anna pankkitilin haltijan nimi",
					"account_type": "Anna pankkitilin tyyppi",
					"routing_number": "Anna kelvollinen reititysnumero",
					"account_number": {
						"first": "Anna kelvollinen tilinumero oletusarvoiseksi pankkitiliksi",
						"second": "Anna kelvollinen tilinumero ensimmäiseksi ylimääräiseksi pankkitiliksi",
						"third": "Anna kelvollinen tilinumero toiseksi ylimääräiseksi pankkitiliksi",
						"fourth": "Anna kelvollinen tilinumero kolmanneksi ylimääräiseksi pankkitiliksi",
						"general": "Anna kelvollinen tilinumero"
					},
					"role": "Anna rooli",
					"address": "Anna osoite",
					"political_exposed_person": "Anna tiedot poliittisesti vaikutusvaltaisesta henkilöstä",
					"pep_position": "Anna aseman tiedot",
					"pep_relationship": "Anna tiedot suhteesta poliittisesti vaikutusvaltaiseen henkilöön",
					"goodsCategory": "Anna tuoteluokka",
					"registered": "Anna liiketoimintasi rekisteröintitiedot",
					"subjectToVat": "Anna ALV-tunnus",
					"registrationCourt": "Anna rekisteröintituomioistuin",
					"registrationId": {
						"general": {
							"default": "Anna kelvollinen Y-tunnus",
							"AT": "Anna kelvollinen Y-tunnus",
							"AU": "Kirjoita kelvollinen ACN",
							"ES": "Kirjoita kelvollinen yrityksen NIF-/NIE-/DNI-numero",
							"GB": "Kirjoita kelvollinen organisaatiotunnus",
							"GR": "Kirjoita voimassa oleva G.E.MI.-numero (Γ.Ε.ΜΗ.)",
							"CA": "Kirjoita kelvollinen yritystunnus",
							"NZ": "Kirjoita voimassa oleva yritystunnus",
							"US": "Kirjoita kelvollinen työnantajan tunnistenumero"
						},
						"missing_leading_0_GB": "Anna 8-numeroinen organisaatiotunnus. Organisaatiotunnuksestasi saattaa puuttua alusta 0 (esim. 03452678)",
						"invalid": {
							"default": "Anna kelvollinen Y-tunnus",
							"AT": "Rekisterinumeron tulee olla 5–11-numeroinen. Huomaathan, että kyseessä ei ole ALV-tunnuksesi eikä kauppiastunnuksesi.",
							"AU": "ACN-numeron tulee olla 9-numeroinen. Välilyönnit eivät ole sallittuja. Esim. 123456789",
							"BE": "Rekisterinumeron tulee olla 10-numeroinen. Esim. 1234567890",
							"CA": "Yritystunnuksen tulee olla 9-numeroinen. Esim. 123456789",
							"CZ": "Y-tunnuksen tulee olla 8-numeroinen. Esim. 12345678",
							"DE": "Rekisterinumeron tulee olla 6–11-numeroinen, ja sen tulee alkaa kirjaimilla HRA, HRB, GnR, VR tai PR, jota seuraa välilyönti. Huomaathan, että kyseessä ei ole ALV-tunnuksesi eikä kauppiastunnuksesi.",
							"ES": "NIF-/NIE-/DNI-numeron tulee olla 8 tai 9 merkkiä pitkä, ja sen tulee alkaa 1 kirjaimella/numerolla, jonka jälkeen on 6 tai 7 numeroa ja 1 kirjain/numero",
							"FI": "Y-tunnuksen tulee olla 8-numeroinen, ja siinä tulee olla yhdysmerkki ennen viimeistä numeroa. Välilyönnit eivät ole sallittuja. Esim. 1234567-8",
							"FR": "Rekisteröintinumeron tulee olla 9 numeron pituinen, esim. 123 456 789 tai 123456789 (SIREN), tai 14 numeron pituinen, esim. 123 456 789 12345 tai 12345678912345 (SIRET).",
							"IE": "Rekisterinumeron tulee olla 2 kirjainta, joita seuraa 6 numeroa tai vain 6 numeroa, jos olet yksityisyrittäjä (esim. AB123456).",
							"IT": "Rekisterinumeron tulee olla 11-numeroinen (esim. 01234567890) tai 16 numeron ja suuraakkosen yhdistelmä (esim. ABCABC12A12A123A)",
							"GB": "Organisaatiotunnuksen tulee olla 8-numeroinen. Esim. 12345678 tai 2 kirjainta sekä 6 numeroa (SC123456) tai 1 kirjain ja 7 numeroa (S1234567)",
							"GR": "G.E.MI.-numeron pitäisi olla pituudeltaan 12 numeroa, esim. 012345678901",
							"NL": "Y-tunnuksen tulee olla 8-numeroinen. Esim. 12345678",
							"NO": "Rekisterinumeron tulee olla 9-numeroinen. Välilyönnit eivät ole sallittuja. Esim. 123456789",
							"NZ": "Yritystunnuksen tulee olla 13-numeroinen. Esim. 1234567890123",
							"PL": "Rekisterinumeron tulee olla 10-numeroinen. Välilyönnit eivät ole sallittuja. Esim. 1234561234",
							"PT": "Rekisterinumeron tulee olla 9-numeroinen. Välilyönnit eivät ole sallittuja. Esim. 123123123",
							"SE": "Rekisterinumeron tulee olla 10-numeroinen, ja siinä tulee olla yhdysmerkki. Välilyönnit eivät ole sallittuja. Esim. 123456-1234",
							"US": "Työnantajan tunnistenumeron tulee olla 9-numeroinen, ja kahden ensimmäisen jälkeen tulee\"-\". Esim. 12-3456789",
							"MX": "RFC-numeron tulee olla 12 merkin pituinen. Sen tulee alkaa yrityksen alkukirjaimilla, jonka jälkeen tulee 6-numeroinen yrityksen rekisteröintipäivä ja tarkistusnumero. Esim. ABC921010H20"
						}
					},
					"tocLink": "Ehdoissa tapahtui virhe. Yritä myöhemmin uudelleen tai ota yhteyttä asiakastukeen {supportEmail}",
					"vat": {
						"general": {
							"default": "Kirjoita voimassa oleva ALV-tunnus",
							"AU": "Kirjoita voimassa oleva ABN-numero",
							"ES": "Kirjoita kelvollinen yrityksen NIF-/NIE-/DNI-numero",
							"NZ": "Kirjoita voimassa oleva GST-numero"
						},
						"invalid": {
							"default": "Virheellinen ALV-tunnus",
							"AT": "ALV-tunnuksen tulee alkaa kirjaimilla ATU, joita seuraa kahdeksan numeroa. Esim. ATU12345678",
							"AU": "ABN-numeron tulee olla 11-numeroinen.",
							"CZ": "ALV-tunnuksen tulee alkaa kirjaimilla CZ, joita seuraa 8, 9 tai 10 numeroa. Esim.: CZ123456789",
							"GR": "ALV-tunnuksen tulee olla pituudeltaan 9 numeroa, ja sen tulee alkaa kirjaimilla EL. Esim.: EL123456789",
							"DE": "ALV-tunnuksen tulee alkaa kirjaimilla DE, joita seuraa yhdeksän numeroa. Esim. DE123456789",
							"ES": "NIF-/NIE-/DNI-numeron tulee olla 8 tai 9 merkkiä pitkä, ja sen tulee alkaa 1 kirjaimella/numerolla, jonka jälkeen on 6 tai 7 numeroa ja 1 kirjain/numero",
							"FR": "ALV-koodin tulee olla FR, jonka jälkeen on 2 kirjainta/numeroa ja 9 numeroa (SIREN), esim. FRXX123456789",
							"GB": "ALV-tunnuksen tulee olla 6–15-numeroinen.",
							"IE": "ALV-tunnuksessa tulee olla ensin IE, jonka jälkeen 8 tai 9 merkkiä, joista 1 tai 2 on kirjaimia. Esim. IE1234567WA, IE1234567A",
							"IT": "ALV-tunnuksen tulee alkaa kirjaimilla IT, joita seuraa 11 numeroa. Esim. IT12345678912",
							"NL": "ALV-tunnuksen tulee alkaa kirjaimilla NL, joita seuraa yhdeksän numeroa sekä B ja kaksi numeroa. Esim. NL123456789B12",
							"NZ": "GST-numeron tulee olla 8-numeroinen (12345678) tai 9-numeroinen, yhdysmerkki aina kolmen numeron välein tai ilman yhdysmerkkiä (123-123-123 tai 123123123)",
							"PL": "ALV-tunnuksen tulee alkaa kirjaimilla PL, joita seuraa 10 numeroa. Esim. PL1234567890",
							"PT": "ALV-tunnuksen tulee alkaa kirjaimilla PT, joita seuraa yhdeksän numeroa. Esim. PT123123123",
							"MX": "RFC-numeron tulee alkaa yrityksen alkukirjaimilla, jonka jälkeen tulee 6-numeroinen yrityksen rekisteröintipäivä ja tarkistusnumero. Esim. ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Anna henkilötunnuksesi neljä viimeistä merkkiä",
							"format": "Kirjoita henkilötunnuksesi neljä viimeistä merkkiä"
						},
						"US_FULL_SSN": {
							"general": "Anna henkilötunnuksesi kaikki numerot (9)",
							"format": "Kirjoita henkilötunnuksesi kaikki numerot (9)"
						},
						"CA": {
							"general": "Anna kelvollinen sosiaalivakuutusnumero (SIN) tai passin numero",
							"format": "SIN: XXX-XXX-XXX / Passin numero: ABXXXXXX"
						},
						"SE": {
							"general": "Anna kelvollinen henkilökohtainen tunnistenumero (PNO)",
							"format": "Kirjoita PNO muodossa: VVVVKKPP-XXXX"
						},
						"FI": {
							"general": "Kelvollinen henkilötunnus puuttuu (HETU)",
							"format": "Kirjoita HETU muodossa: PPKKVVSXXXX"
						},
						"NO": {
							"general": "Anna kelvollinen kansallinen henkilötunnus",
							"format": "Kirjoita muodossa: PPKKVVXXXXX"
						},
						"DK": {
							"general": "Anna kelvollinen henkilökohtainen tunnistenumero (CPR)",
							"format": "Kirjoita CPR muodossa: PPKKVV-XXXX"
						},
						"IT": {
							"general": "Kirjoita voimassa oleva verotunnus",
							"format": "Kirjoita verotunnus muodossa: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Kirjoita voimassa oleva henkilötunnus (DNI tai NIE)",
							"format": "Kirjoita DNI tai NIE, esim. 12345678A"
						},
						"PL": {
							"general": "Kelvollinen henkilötunnus puuttuu (PESEL)",
							"format": "Kirjoita PESEL muodossa: VVKKPPZZZXQ"
						},
						"default": {
							"general": "Anna kelvollinen passin numero"
						}
					},
					"store_name": "Anna kaupan nimi"
				},
				"errors_keys": {
					"correlationIdLabel": "Korrelaatio ID: {correlationId}",
					"decisionTaken": "Ennakkoarvioinnin päätös on jo tehty. Lataa sivu uudelleen.",
					"maintenanceMode": "Sovellus on tällä hetkellä poissa käytöstä huollon vuoksi. Palaa myöhemmin takaisin",
					"validation": {
						"storeName": {
							"invalidType": "Anna kelvollinen kaupan nimi."
						},
						"email": {
							"invalidType": "Anna kelvollinen sähköposti."
						},
						"goodsCategory": {
							"invalidType": "Anna tuoteluokka."
						},
						"website": {
							"invalidType": "Anna kelvollinen verkkosivu."
						}
					}
				}
			},
			"general": {
				"yes": "Kyllä",
				"no": "Ei",
				"encrypted_text": "*******",
				"pricing_link_eu": "Näytä kaikki hinnat maakohtaisesti",
				"pricing_link_us": "Näytä hinnat",
				"formFieldOptional": "Valinnainen",
				"buttons": {
					"next": "Seuraava",
					"back": "Takaisin",
					"continue": "Jatka",
					"submit_application": {
						"default": "Aloita heti",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Aloita"
					},
					"add_aditional_item": "+ Lisää ylimääräinen tuote"
				},
				"unknown_step_title": "Anna vaaditut tiedot",
				"selected": "Valittu",
				"clear_all": "Tyhjennä kaikki"
			},
			"errors": {
				"general": "Tapahtui virhe. Ota yhteyttä tukeen.",
				"salesforce": "Yritä päivittää sivua. Mikäli virhe jatkuu, lähetä virhetunnus #smooothforce-tukikanavalle, jotta voimme auttaa sinua.",
				"managed_kyc": "Yritä päivittää sivua. Mikäli virhe jatkuu, ota yhteyttä kauppiastukeen tai myynnin yhteyshenkilöösi.",
				"copy": "Kopio",
				"noTermsAccepted": "Lue ja hyväksy kaikki listalla olevat sopimukset",
				"termsAlreadyAccepted": "Olet jo hyväksynyt kaikki listalla olevat sopimukset",
				"mandatoryField": " on pakollinen"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Yksityisyrittäjä",
					"PARTNERSHIP": "Kumppanuus",
					"PUBLIC_LISTED_COMPANY": "Julkinen pörssiyhtiö",
					"PRIVATE_COMPANY": "Yksityisyritys"
				},
				"organization_entity_types": {
					"C_CORP": "C-yritys",
					"S_CORP": "S-yritys",
					"PARTNERSHIP": "Kumppanuus",
					"TRUST_ESTATE": "Säätiö/kiinteistö",
					"INDIVIDUAL": "Yksittäinen",
					"SOLE_PROPRIETORSHIP": "Yksityinen elinkeinonharjoittaja",
					"SOLE_TRADER": "Yksityisyrittäjä",
					"LIMITED_LIABILITY_COMPANY": "Osakeyhtiö",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Yksijäseninen osakeyhtiö"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Vaatteet ja kengät – Aikuisten kengät ja vaatteet",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Autoalan tuotteet – Autoalan osat ja lisävarusteet",
					"BAGS_AND_WALLETS": "Korut ja somisteet – Laukut ja lompakot",
					"BODY_AND_HAIR_CARE": "Terveys ja kauneudenhoito – Vartalon- ja hiustenhoito",
					"BOOK_AND_MAGAZINES": "Viihde – Kirjat ja lehdet",
					"CANDY": "Ruoka ja juoma - Makeiset",
					"CAR_ELECTRONICS": "Elektroniikka – Autoelektroniikka",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Lasten tuotteet – Lasten vaatteet ja lastenhoitotuotteet",
					"CHILDREN_TOYS": "Lasten tuotteet – Lelut",
					"CLEANING_AND_SANITARY": "Koti ja puutarha – Siivous ja puhdistaminen",
					"COLLECTIBLES": "Vapaa-aika, urheilu ja harrastukset – Keräilytuotteet",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Vapaa-aika, urheilu ja harrastukset – Merkkiliikkeet ja sekalaiset",
					"COSMETICS": "Terveys ja kauneudenhoito – Kosmetiikka",
					"COSTUMES_AND_PARTY_SUPPLIES": "Vapaa-aika, urheilu ja harrastukset – Asut ja juhlatarvikkeet",
					"DATING_SERVICES": "Aineettomat tuotteet – Treffipalvelut",
					"DECORATION_AND_ART": "Koti ja puutarha – Sisustus ja taide",
					"DIETARY_SUPPLEMENTS": "Terveys ja kauneudenhoito – Ravinnelisät",
					"DIGITAL_SERVICES": "Aineettomat tuotteet – Digitaaliset palvelut",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Lasten tuotteet – Monialaiset lasten tuotteet",
					"DIVERSIFIED_ELECTRONICS": "Elektroniikka – Monialainen elektroniikka",
					"DIVERSIFIED_ENTERTAINMENT": "Viihde – Monialainen viihde",
					"DIVERSIFIED_EROTIC_MATERIAL": "Eroottinen materiaali – Monialainen eroottinen materiaali",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Terveys ja kauneudenhoito – Monialaiset terveys- ja kauneudenhoitotuotteet",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Koti ja puutarha – Monialaiset koti- ja puutarhatuotteet",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Korut ja somisteet – Monialaiset korut ja somisteet",
					"EDUCATION": "Aineettomat tuotteet – Koulutus",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektroniikka – Elektroniset laitteet ja lisävarusteet",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Eroottinen materiaali – Eroottiset vaatteet ja somisteet",
					"EVENT_TICKETS": "Aineettomat tuotteet – Tapahtumaliput",
					"FOOD_AND_BEVERAGE": "Ruoka ja juoma – Ruoka ja juoma",
					"FRAGRANCES": "Terveys ja kauneudenhoito – Tuoksut",
					"FURNITURE": "Koti ja puutarha – Huonekalut",
					"GENERAL_SHOES_AND_CLOTHING": "Vaatteet ja kengät – Yleiset kengät ja vaatteet",
					"HOBBY_ARTICLES": "Vapaa-aika, urheilu ja harrastukset – Harrastustarvikkeet",
					"HOUSEHOLD_ELECTRONICS": "Elektroniikka – Kodin elektroniikka",
					"JEWELRY_AND_WATCHES": "Korut ja somisteet – Korut ja kellot",
					"KITCHENWARE": "Koti ja puutarha – Keittiötarvikkeet",
					"MARKETPLACES": "Aineettomat tuotteet – Markkinapaikat",
					"MUSIC_AND_MOVIES": "Viihde – Musiikki ja elokuvat",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Vapaa-aika, urheilu ja harrastukset – Soittimet ja varusteet",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Korut ja somisteet – Käsikaupalla myytävät aurinkolasit ja linssit",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektroniikka – Toimiston koneet ja varusteet",
					"OTHER_SERVICES": "Aineettomat tuotteet – Muut palvelut",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Terveys ja kauneudenhoito – Henkilökohtainen hyvinvointi ja kehonhuolto",
					"PET_SUPPLIES": "Koti ja puutarha – Lemmikkieläintarvikkeet",
					"PHARMACEUTICAL_PRODUCTS": "Terveys ja kauneudenhoito – Farmaseuttiset tuotteet",
					"PLANTS_AND_FLOWERS": "Koti ja puutarha – Kasvit ja kukat",
					"PRESCRIPTION_OPTICS": "Terveys ja kauneudenhoito – Reseptioptiikka",
					"PRINTS_AND_PHOTOS": "Vapaa-aika, urheilu ja harrastukset – Tulosteet ja valokuvat",
					"SAFETY_PRODUCTS": "Koti ja puutarha – Turvallisuustuotteet",
					"SEX_TOYS": "Eroottinen materiaali – Seksilelut",
					"SPORTS_GEAR_AND_OUTDOOR": "Vapaa-aika, urheilu ja harrastukset – Urheiluvälineet ja ulkoilu",
					"TOBACCO": "Ruoka ja juoma – Tupakka",
					"TOOLS_AND_HOME_IMPROVEMENT": "Koti ja puutarha – Työkalut ja kodinparannus",
					"TRAVEL_SERVICES": "Aineettomat tuotteet – Matkailupalvelut",
					"UNDERWEAR": "Vaatteet ja kengät – Alusvaatteet",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Viihde – Videopelit ja lisävarusteet",
					"WHEELS_AND_TIRES": "Autoalan tuotteet – Renkaat ja pyörät",
					"WINE_BEER_AND_LIQUOR": "Ruoka ja juoma – Viini, olut ja liköörit",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Vaatteet ja kengät – Nuorten kengät ja vaatteet",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Ikärajoitus – Uhkapelit, vedonlyönti, kasinot ja arvonnat",
					"CHARITIES_AND_NGO": "Aineettomat tuotteet – Hyväntekeväisyys ja voittoa tavoittelemattomat palvelut",
					"EROTIC_SERVICES": "Eroottinen materiaali – Eroottiset palvelut",
					"FINANCIAL_SERVICES_CRYPTO": "Rahoituspalvelut – Kryptovaluuttaan liittyvä toiminta",
					"FINANCIAL_SERVICES_MSB": "Rahoituspalvelut – Rahoituspalveluliiketoiminta",
					"FINANCIAL_SERVICES_E_WALLETS": "Rahoituspalvelut – E-lompakot",
					"FINANCIAL_SERVICES_TRADING": "Rahoituspalvelut – Trading",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Aineettomat tuotteet – Sosiaalisten alustojen yhteisöt",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Matkailu – Lentomatkustaminen ja risteilyoperaattorit",
					"TRAVEL_BROKER_AND_AGENCIES": "Matkailu – Matkanvälittäjät ja matkatoimistot",
					"TRAVEL_GROUND_TRANSPORTATION": "Matkailu – Matkustaminen maata pitkin",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Matkailu – Majoitus ja lomakohteet",
					"EVENT_ORGANIZER": "Tapahtuma – Järjestäjä",
					"EVENT_BROKER_AND_AGENCIES": "Tapahtuma – Tapahtumavälittäjät ja -toimistot"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "Kalifornia",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "District of Columbia",
					"DE": "Delaware",
					"FL": "Florida",
					"GA": "Georgia",
					"HI": "Havaiji",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "New Mexico",
					"NY": "New York",
					"NC": "Pohjois-Carolina",
					"ND": "Pohjois-Dakota",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pennsylvania",
					"RI": "Rhode Island",
					"SC": "Etelä-Carolina",
					"SD": "Etelä-Dakota",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginia",
					"WA": "Washington",
					"WV": "Länsi-Virginia",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Henkilö",
						"COMPANY": "Yritys"
					},
					"roles": {
						"OWNER": "Omistaja",
						"ULTIMATE_BENEFICIAL_OWNER": "Tosiasiallinen edunsaaja",
						"CONTROL_OVER_MANAGEMENT": "Johtohenkilö",
						"APPLICANT": "Valtuutettu allekirjoittaja",
						"SOLE_TRADER": "Yksityisyrittäjä",
						"PARTNER": "Kumppani"
					}
				},
				"payment_intervals": {
					"DAILY": "Päivittäin",
					"WEEKLY": "Viikoittain"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Perinteinen irtaimen tavaran myynti",
						"description": "Kauppias myy tuotteita tai palveluita perinteiseen tapaan: tavara katsotaan kulutetuksi, kun se on toimitettu. Tyypillisesti tilauksen ja toimituksen välissä ei ole pidennettyä ajanjaksoa"
					},
					"VOUCHER": {
						"label": "Kuponki",
						"description": "Yli 10 % myynnistä koostuu kupongeista ja/tai lahjakorteista"
					},
					"MEMBERSHIP": {
						"label": "Jäsenyys",
						"description": "Yli 10 % myynnistä koostuu jäsenyyksistä"
					},
					"SUBSCRIPTION": {
						"label": "Tilaus",
						"description": "Yli 10 % myynnistä koostuu tilauksista"
					},
					"PHARMACIES": {
						"label": "Apteekit",
						"description": "Kauppias myy resepti- tai käsikauppalääkkeitä"
					},
					"US_PHARMACIES": {
						"label": "Apteekit Yhdysvalloissa",
						"description": "Kauppias myy resepti- tai käsikauppalääkkeitä Yhdysvalloissa"
					},
					"MEDICAL_SERVICES": {
						"label": "Terveydenhuoltopalvelut",
						"description": "Kauppias myy terveydenhuoltopalveluita, kuten testausta, tutkimuksia ja terveydenhoitopalveluita"
					},
					"MARKETPLACES": {
						"label": "Markkinapaikat",
						"description": "Kauppiaalla on alikauppiassuhde"
					},
					"FIREARM_DEALERS": {
						"label": "Tuliaseiden myyjät",
						"description": "Kauppias myy aseita, ampumatarvikkeita, jotka edellyttävät lisenssiä"
					},
					"AUCTIONS": {
						"label": "Huutokaupat",
						"description": "Kauppias toimii huutokauppakamarina"
					},
					"ALCOHOL": {
						"label": "Alkoholi",
						"description": "Kauppias myy alkoholia"
					},
					"TOBACCO": {
						"label": "Tupakka",
						"description": "Kauppias myy tupakkaa, sisältäen tai pois lukien nikotiinituotteet, tai kauppias myy sähkötupakkatuotteita"
					},
					"HEMP_CBD_THC": {
						"label": "Hamppu, CBD tai THC",
						"description": "Kauppias myy tuotteita, jotka sisältävät hamppua, CBD:tä tai THC:tä"
					},
					"DONATIONS_CHARITY": {
						"label": "Lahjoitukset ja hyväntekeväisyys",
						"description": "Kauppias toimii lahjoitus- tai hyväntekeväisyysorganisaationa, joka harjoittaa ”tilitysten jälkeistä maksua”"
					},
					"TRAVEL": {
						"label": "Matkailu",
						"description": "Yli 10 % myynnistä koostuu matkailusta"
					},
					"EVENTS": {
						"label": "Tapahtumat",
						"description": "Yli 10 % myynnistä koostuu tapahtumista"
					},
					"COURSES": {
						"label": "Kurssit",
						"description": "Yli 10 % myynnistä koostuu kursseista"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Kurssit",
						"description": "Tämä kauppias myy kursseja, jotka kestävät tietyn ajan."
					},
					"FOOD_DELIVERY": {
						"label": "Ruokatoimitukset",
						"description": "Kauppias tarjoaa ruoan toimituspalveluja."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Mukautettu ennakkotilaus/Kalusteet",
						"description": "Kauppias myy ennakkotilaustuotteita, kuten kalusteita."
					},
					"DIGITAL_CONTENT": {
						"label": "Digitaalinen sisältö",
						"description": "Kauppias myy digitaalista sisältöä, kuten e-kirjoja ja online-pelejä."
					},
					"GAMING_INDUSTRY": {
						"label": "Peliteollisuus (uhkapelit, vedonlyönti, kasinot ja arvonnat)",
						"description": "Kauppias tarjoaa peliteollisuuteen, kuten uhkapeleihin, vedonlyöntiin, kasinoihin ja arvontoihin, liittyviä palveluita."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Hei, {firstName}",
						"primary_title_without_name": "Hei,",
						"sub_title": "Enemmän Klarnaa on enemmän Klarnaa, Shakespeare sanoi.",
						"sub_title_no_products": "Aloita Klarna-kokemuksesi valitsemalla jokin jäljempänä olevista tuotteista",
						"sub_title_kp_products": "Valitse toinen Klarna-tuote",
						"sub_title_ongoing_product": "Jatka tuotteen {productName} asennusta"
					},
					"sidebar_left": {
						"products": {
							"title": "Maksutuotteet",
							"text_blocks": [
								{
									"text": "Lisää asennukseesi ratkaisu"
								}
							]
						}
					},
					"buttons": {
						"start": "Aloita",
						"continue": "Jatka",
						"view_summary": "Näytä yhteenveto",
						"add_another_product": "Lisää toinen tuote"
					},
					"goodie_bags": {
						"playground": {
							"title": "Playground",
							"text": "Vaihda Playground-käyttöympäristöön tutustuaksesi ja luodaksesi API-testitunnukset ja testataksesi alustaasi.",
							"link": "Playground"
						},
						"marketing_assets": {
							"title": "Markkinointimateriaalit",
							"text": "Klarnan käyttäminen tarkoittaa smooothia elämää asiakkaillesi. Saat asiakkaasi innostumaan käyttämällä markkinointimateriaalejamme.",
							"link": "Hanki materiaalit"
						},
						"your_application": {
							"title": "Hakemuksesi",
							"text": "Klikkaa tästä viimeistelläksesi asennuksesi tai nähdäksesi hakemuksesi tiedot, mukaan lukien ehdot.",
							"link": "Avaa"
						},
						"invite_more_users": {
							"title": "Kutsu lisää käyttäjiä",
							"text": "Kutsu työkumppanisi Kauppiasportaaliin. Voit määrittää heille jokaiselle räätälöidyt luvat.",
							"link": "Kutsu käyttäjiä"
						}
					},
					"footer": {
						"title": "Klarna sisältää aina",
						"list": {
							"merchant_portal": {
								"title": "Kauppiasportaalin",
								"text_blocks": [
									{
										"text": "Hallitse kaikkea Klarnalla täydellä käyttöoikeudella taustapalveluihin."
									}
								]
							},
							"global_products": {
								"title": "Globaalit tuotteet, paikalliset kasvot",
								"text_blocks": [
									{
										"text": "Kaikki tuotteemme rakennetaan vastaamaan paikallisia vaatimuksia ja lainsäädäntöä."
									}
								]
							},
							"local_support": {
								"title": "Paikallista tukea sinulle ja asiakkaillesi",
								"text_blocks": [
									{
										"text": "Meillä on tuhansia ihmisiä auttamassa asiakkaitasi, kun he tarvitsevat henkilökohtaista apua."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna markkinointityökaluna",
								"text_blocks": [
									{
										"text": "Tarjoamme sinulle pääsyn Klarnan materiaaleihin, joita voit käyttää markkinoinnissasi."
									}
								]
							},
							"single_integration": {
								"title": "Yksinkertainen integrointi, automaattiset päivitykset",
								"text_blocks": [
									{
										"text": "Yksi integrointi, ei päivityksiä. Koskaan."
									},
									{
										"text": "Kun olet integroinut Klarnan, muuta ei tarvita. Se on aina ajan tasalla – eikä sinun tarvitse tehdä mitään."
									}
								]
							},
							"no_risk": {
								"title": "Ei riskiä sinulle tai asiakkaillesi",
								"text_blocks": [
									{
										"text": "Maksusi ovat aina taattuja, ja asiakkaitasi suojaa Klarnan ostajan turva."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Klarnan API-tunnukset",
							"text_blocks": [
								{
									"text": "Klarnan API-tunnusten avulla tuotteesi yhdistetään kauppaasi, jotta voit aloittaa myynnin."
								}
							]
						},
						"toc_key": {
							"title": "Ehdot",
							"text_blocks": [
								{
									"text": "Sinun tulee päivittää verkkokauppasi ehdot."
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Integrointiohjeet",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Miten Klarnan API-tunnuksia käytetään",
							"ordered_list": {
								"one": "Luo ja lataa tunnuksesi",
								"two": "Liitä tunnuksesi (Klarnan API-käyttäjänimi ja salasana) alustallesi jäljempänä esitettyjen ohjeiden mukaan"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "Yhteensä 5 Klarnan API-tunnusta",
							"text": "Voit luoda yhteensä 5 Klarnan API-tunnusta. Ensimmäisen saat täältä, ja loput voit luoda asetuksista.",
							"button": "Luo Klarnan API-tunnukset"
						},
						"how_to_update_toc": {
							"title": "Miten ehdot päivitetään",
							"ordered_list": {
								"one": "Vieraile linkissä",
								"two": "Lue ohjeet ja kopioi teksti",
								"three": "Sisällytä se verkkokauppasi ehtoihin"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Muista päivittää teksti tuotteilla, joihin olet rekisteröitynyt.",
							"linkText": "Siirry päivittämään ehdot >"
						},
						"buttons": {
							"back": "Takaisin"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Hakemustasi arvioidaan…",
						"TRANSACTION_DETAILS_STARTED": "Tiimimme arvioi hakemustasi. Otamme sinuun yhteyttä mahdollisimman pian.",
						"TRANSACTIONS_REVIEW_MANUAL": "Tiimimme arvioi hakemustasi. Otamme sinuun yhteyttä mahdollisimman pian.",
						"TRANSACTIONS_ENABLED": "Onneksi olkoon. Olet valmis myymään Klarnalla.",
						"PAYOUTS_REVIEW_AUTOMATED": "Maksupyyntöäsi arvioidaan…",
						"PAYOUTS_REVIEW_MANUAL": "Tiimimme arvioi maksupyyntöäsi… Otamme sinuun yhteyttä mahdollisimman pian.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Odotetaan ensimmäistä myyntiäsi Klarnalla…",
						"TRANSACTIONS_DISABLED": "Tilisi on poistettu käytöstä, kunnes viimeistelet maksujen käyttöönottovaiheen.",
						"SUSPENDED": "Tilisi on keskeytetty.",
						"notice": "Hakemusten arvioinnissa kestää tällä hetkellä keskimääräistä pidempään. Ei hätää, hakemuksesi arvioidaan, ja otamme sinuun yhteyttä lisätietojen antamiseksi seuraavia vaiheita koskien. Arvostamme kärsivällisyyttäsi ja kiitämme ymmärryksestä."
					},
					"statuses": {
						"pending": "Odottava",
						"done": "Valmis"
					},
					"in_review": {
						"title": "Hakemuksesi on käsittelyssä.",
						"subtitle": "Käsittely tehdään manuaalisesti, joten käsittelyajat saattavat vaihdella. Hoidamme asian kuitenkin mahdollisimman nopeasti.",
						"content": {
							"title": "Jotta tarkistus sujuu mahdollisimman nopeasti, varmistathan, että verkkosivullasi näkyvät seuraavat tiedot:",
							"list": {
								"default": {
									"item_1": "Yrityksen virallinen nimi",
									"item_2": "Yrityksen Y-tunnus",
									"item_3": "Yrityksen virallinen osoite",
									"item_4": "Palautuskäytäntö",
									"item_5": "Asiakaspalvelun sähköposti"
								},
								"US": {
									"item_1": "Yrityksen rekisteröity nimi",
									"item_2": "Palautuskäytäntö",
									"irem_3": "Asiakaspalvelun sähköposti tai puhelinnumero"
								},
								"AU": {
									"item_1": "ABN (yritystunnus) tai yrityksen rekisteröity nimi.",
									"item_3": "Yrityksesi rekisteröity osoite",
									"item_4": "Vähintään 14 päivän palautuskäytäntö",
									"item_5": "Asiakaspalvelun sähköposti tai puhelinnumero"
								}
							}
						},
						"footer": "Lähetämme sinulle sähköpostin, kun tarkistus on valmis tai jos tarvitsemme sinulta lisätietoja."
					},
					"suspended": {
						"title": "Valitettavasti…",
						"subtitle": "Tarkistettuamme sopimustietosi meidän oli hylättävä hakemuksesi. Syitä hakemuksesi hylkäämiseen voi olla monia. Alla on joitakin yleisimpiä syitä:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Kauppasi ei ole Klarnan eettisten käytäntöjen mukainen.",
								"item_2": "Lähettämääsi yhteyshenkilöön ei saa yhteyttä.",
								"item_3": "Muut tekniset tai hallinnolliset tekijät."
							}
						},
						"footer": "Kiitos mielenkiinnostasi Klarnaa kohtaan. Otathan meihin yhteyttä, jos sinulla on kysyttävää tai jos haluat rekisteröidä tulevaisuudessa jonkin toisen kaupan."
					},
					"disabled": {
						"title": "Hakemuksesi on poistettu käytöstä.",
						"subtitle": "Tilisi on poistettu käytöstä automaattisesti, sillä sieltä puuttuu lakisääteisesti vaadittavia tietoja.",
						"content": {
							"title": "Näin käy yleensä silloin, jos Klarna on pyytänyt sinua antamaan joitakin tietoja etkä ole vastannut ilmoitettuun määräaikaan mennessä."
						},
						"footer": "Jos uskot näin käyneen vahingossa tai haluat lähettää tiedot uudelleen, otathan yhteyttä Kauppiastukeen käyttämällä tämän sivun alatunnisteesta löytyviä yhteystietoja."
					},
					"ready_to_connect": {
						"title": "Yhdistä kauppasi",
						"subtitle": "Sopimuksesi on valmis ja voit nyt integroida Klarnan kauppaasi. Suorita integrointi noudattamalla alla olevia ohjeita.",
						"status_messsage": {
							"title": "Integrointi ei ole vielä valmis",
							"subtitle": "Yhdistä kauppasi noudattamalla integrointiohjeita. Tämä tila muuttuu vihreäksi, kun maksutapahtuma on suoritettu Klarnan avulla."
						},
						"content": {
							"title": "Ohjeet",
							"options": {
								"label_1": "Luo ja tallenna Klarnan API-tunnukset",
								"description_1": "Luo uudet API-tunnukset ja lataa ne tietokoneellesi. Tarvitset näitä API-tunnuksia seuraavassa kohdassa.",
								"label_2": "Asenna Klarna Shopify-kauppaasi"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Melkein valmista",
						"subtitle": "Olet askeleen lähempänä smooothin ostokokemuksen tarjoamista asiakkaillesi! Sopimuksesi on valmis, ja kauppasi on valmis integroitavaksi.",
						"buttons": {
							"connect": "Yhdistä kauppasi"
						},
						"additional_info": "Huomaathan, että integrointi merkitään täysin valmiiksi vasta, kun vastaanotamme ensimmäisen oston. Tässä saattaa kestää jonkin aikaa alustastasi riippuen."
					},
					"store_connected": {
						"title": "Kauppasi on yhdistetty",
						"subtitle": "Kauppasi Klarna-integrointi on valmis, ja asiakkaasi voivat nyt maksaa Klarnalla.",
						"status_messsage": {
							"title": "Integrointi onnistui",
							"subtitle": "Klarna-maksutapahtuman käsittely kauppasi kautta onnistui.",
							"button_text": {
								"shown": "Näytä integrointiohjeet",
								"hidden": "Piilota integrointiohjeet"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Hakemuksesi",
							"subtitle": "Tarkista hakemuksesi tiedot.",
							"button_text": "Näytä yhteenveto"
						},
						"connect_store": {
							"title": "Klarnan API-tunnuksesi",
							"subtitle": "Luo Klarnan API-tunnukset integroidaksesi kauppasi.",
							"button_text": "Luo Klarnan API-tunnukset"
						},
						"add_product": {
							"title": "Tuotteet",
							"subtitle": "Klikkaa tästä, jos haluat lisätä tuotteen tähän asennukseen.",
							"button_text": "Lisää tuotteita"
						}
					},
					"timeline": {
						"application": {
							"title": "Hakemuksesi",
							"alert": {
								"view_summary": "Näytä yhteenveto",
								"rejected": "Meidän oli hylättävä hakemuksesi.",
								"review": "Tarkista hakemuksesi tiedot napsauttamalla alla olevaa linkkiä."
							}
						},
						"payouts": {
							"title": "Tilitykset otettu käyttöön"
						},
						"integration": {
							"title": "Integrointi ei ole vielä valmis",
							"alert": "Yhdistä kauppasi noudattamalla integrointiohjeita."
						},
						"integration_complete": {
							"title": "Integrointi on valmis!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Onnittelut, asennuksesi on valmis!",
						"rejection": "Emme valitettavasti pystyneet viimeistelemään asennustasi."
					},
					"header_new": {
						"title": "Tervetuloa, Klarna-kauppias",
						"subtitle": "Yhteenveto",
						"rejection": "Hakemus hylätty"
					},
					"joy_section": {
						"approved": {
							"title": "Hyväksytty!",
							"content": "Hakemuksesi on arvioitu ja hyväksytty. Klarnan palveluiden täysi käyttöoikeus on nyt saatavillasi. Olemme innoissamme yhteistyöstä kanssasi!",
							"button_title": "Katso tilauksesi",
							"link": "tai markkinointimateriaalisi"
						},
						"rejected": {
							"title": "Valitettavasti…",
							"content_1": "Hakemuksesi arvioinnin jälkeen emme valitettavasti voineet hyväksyä kauppiassopimustasi.",
							"content_2": "Otathan yhteyttä tukeemme, jos sinulla on kysyttävää."
						}
					},
					"sidebar_left": {
						"application_details": "Hakemuksesi tiedot",
						"store_details": {
							"title": "Kaupan tiedot",
							"text_blocks": [
								{
									"text": "Yhteenveto tiedoistasi"
								}
							]
						},
						"credentials": {
							"title": "Klarnan API-tunnuksesi",
							"text_blocks": [
								{
									"text": "Omat Klarnan API-tunnuksesi"
								}
							]
						},
						"payouts": {
							"title": "Maksut",
							"text_blocks": [
								{
									"text": "Lähettämäsi pankkitiedot"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Ylimääräiset pankkitilit",
							"text_block": null
						},
						"business_owners": {
							"title": "Yrityksen omistajat",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Materiaaliset vaikuttajat",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Osakkaat",
							"text_blocks": [
								{
									"text": "Lähettämäsi tiedot"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Yrityksen omistajat",
								"no_elements": "Et ole lähettänyt yhtään yrityksen omistajaa"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Oletuspankkitili",
								"no_elements": "Oletuspankkitiliä ei ole saatavilla"
							},
							"additional_bank_accounts": {
								"title": "Ylimääräiset pankkitilit",
								"no_elements": "Et ole lähettänyt yhtään ylimääräistä pankkitiliä"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Omistajat",
								"no_elements": "Et ole lähettänyt yhtään omistajaa"
							},
							"ultimate_beneficial_owner": {
								"title": "Edunsaajat",
								"no_elements": "Et ole lähettänyt yhtään edunsaajaa"
							},
							"applicant": {
								"title": "Hakijat",
								"no_elements": "Et ole lähettänyt yhtään hakijaa"
							},
							"control_over_management": {
								"title": "Johtoa hallitsevat henkilöt",
								"no_elements": "Et ole lähettänyt yhtään johdon osakkaita hallitsevaa henkilöä"
							}
						},
						"buttons": {
							"back": "Takaisin",
							"next_step": "Seuraava"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Meillä on jo tietosi",
							"text_blocks": [
								{
									"text": "Nämä ovat meille aiemmin antamasi tiedot."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Et ole lähettänyt yhtään yrityksen omistajaa"
						},
						"buttons": {
							"submit": "Lähetä",
							"back": "Takaisin"
						}
					}
				},
				"checking_page": {
					"title": "Tarkistetaan…",
					"subtitle": "Kiitos hakemuksen lähettämisestä. Odotathan, kun tarkistamme sitä…"
				},
				"success_page": {
					"title": "Voit nyt yhdistää kauppasi",
					"subtitle": "Kiitos hakemuksen lähettämisestä.",
					"buttons": {
						"next": "Seuraava"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Perusteet",
						"business": "Liiketoiminta",
						"stakeholders": "Osakkaat",
						"bank_accounts": "Pankkitilit"
					}
				},
				"app_error": {
					"title": "Tuotteet-sovellus ei ole tällä hetkellä käytettävissä",
					"message": "Meillä on parhaillaan sovellukseen liittyviä ongelmia ja tutkimme asiaa. Pyrimme ratkaisemaan ongelmat mahdollisimman pian. Yritä myöhemmin uudelleen."
				},
				"temporarily_down": {
					"title": "Meillä on parhaillaan teknisiä ongelmia",
					"message": "Pahoittelemme tästä aiheutuvaa vaivaa ja vakuutamme tekevämme parhaamme ongelman ratkaisemiseksi. Palaa myöhemmin takaisin."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Tuotteet-sovelluksemme on tällä hetkellä poissa käytöstä huollon vuoksi",
						"signup_app": "Rekisteröitymissovelluksemme on tällä hetkellä poissa käytöstä huollon vuoksi"
					},
					"message": "Pyrimme parantamaan käyttökokemustasi. Toivomme huollon valmistuvan mahdollisimman pian. Palaa myöhemmin takaisin."
				},
				"unknown_merchant": {
					"before_link": "Jos olet jo tehnyt sopimuksen kanssamme, vieraile",
					"link_text": "tällä sivulla",
					"after_link": "saadaksesi lisätietoja tuotteistamme!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Tapahtui virhe.",
						"invalid_token": "Linkki on vanhentunut"
					},
					"message": {
						"invalid_token_risk": "Ota yhteyttä #smooothforce-support-kanavaan, ja autamme sinua mielellämme.",
						"invalid_token": "Otathan yhteyttä myynnin yhteyshenkilöösi.",
						"invalid_flow_type": "Tämä kauppiaan alkuprosessin tyyppi ja tila eivät vastaa toisiaan. Jos uskot, että kyseessä on virhe, otathan yhteyttä kauppiastukeen."
					}
				},
				"topbar": {
					"title": "Asetusten määrittäminen",
					"widget_type": {
						"MANAGED_KYC": "KYC-tietojen kerääminen",
						"MANAGED_RISK": "Ennakkoarvioinnin tietojen kerääminen",
						"MANAGED_SME_RISK": "SME-ennakkoarvioinnin tietojen kerääminen"
					}
				},
				"product_card": {
					"incompatible_description": "Ei saatavilla maassasi/alustallasi",
					"kco_footer_text": "Klarna Checkout -kassalle saatavilla olevat maksutavat riippuvat rekisteröintimaastasi sekä myynnin kohdemaastasi.",
					"products_link_text": "Lisää"
				},
				"product_prices_card": {
					"title": "Tuotteet",
					"subtitle": "{country}",
					"pricing": "Hinnoittelu maassa {country}",
					"monthly_fee": "kuukausimaksu",
					"transaction_fee": "maksutapahtuman maksu",
					"before_link": "Hyväksyn Klarnan",
					"link_text": "Ehdot",
					"after_link_one_product": "tämän tuotteen osalta",
					"after_link_more_than_one_product": "näiden tuotteiden osalta",
					"product_not_available_in_your_country": "* Tämä tuote ei ole saatavilla kotimarkkina-alueellasi, mutta se toimii muissa maissa.",
					"edit_link": "Muokkaa",
					"merchant_agreement": {
						"before_link": "Hyväksyn",
						"link_text": "Kauppiassopimuksen",
						"after_link_one_product": "tämän tuotteen osalta",
						"after_link_more_than_one_product": "näiden tuotteiden osalta"
					},
					"pricing_annex": {
						"before_link": "Hyväksyn",
						"link_text": "Hinnoitteluehdot",
						"after_link_one_product": "tämän tuotteen osalta"
					}
				},
				"support_footer": {
					"text": "Tuki englanniksi",
					"copyright": {
						"eu": "Tekijänoikeus © 2005-{currentYear} Klarna Bank AB (publ). Kaikki oikeudet pidätetään.",
						"ap": "Tekijänoikeus © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Tekijänoikeus © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Ehdot.",
					"privacy_policy": "Tietosuojakäytäntö",
					"merchant_id": "Kauppiastunnus {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Kauppiastuki",
					"recaptcha": {
						"1_main_text": "Tämä sivu on reCAPTCHA-suojattu, ja Googlen",
						"2_privacy_policy": "Tietosuojakäytännön",
						"3_and": "että",
						"4_terms_of_service": "palveluehtoja",
						"5_apply": "sovelletaan."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Kaikkien markkina-alueidemme hinnat",
					"title_us": "Hinnat",
					"subtitle": "Sinulta veloitetaan vain maksutapahtumakohtainen maksu, niin smooothia se on!",
					"table": {
						"country": "Maa",
						"price_column_heading": "Maksutapahtumakohtainen maksu",
						"global": "Globaali",
						"title": {
							"kp": "Maksutavat",
							"kco": "Klarna Checkout",
							"kco_one": "Klarna Checkout",
							"kp_one": "Klarna Payment Method"
						},
						"headers": {
							"kp_one": "Palvelumaksu"
						}
					},
					"buttons": {
						"back": "Takaisin"
					},
					"foot_notes": {
						"global_price": "* Kauppiaan paikallinen valuutta, muussa tapauksessa "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Ensimmäinen maksutapahtuma",
						"content": "Ennen kuin voimme arvioida maksutietojasi, tarvitsemme ensimmäisen tilauksen. Etkö halua hukata omia rahojasi? Ei hätää!",
						"button": "Teeskentele!"
					},
					"transactions": {
						"title": "Hyväksy maksutapahtumat",
						"content": "Voit vain teeskennellä myyntihenkilöstön maksutapahtuman hyväksynnän",
						"button": "Hyväksy"
					},
					"payouts": {
						"title": "Hyväksy maksut",
						"content": "Voit vain teeskennellä myyntihenkilöstön maksujen hyväksynnän",
						"button": "Hyväksy"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Oletuspankkitili",
						"additional": "Ylimääräinen pankkitili {index}",
						"normal": "Pankkitili {index}"
					},
					"currency_code": {
						"label": "Valuutta"
					},
					"country_of_bank_account": {
						"label": "Maa"
					},
					"account_number": {
						"label": {
							"default": "Tilinumero",
							"MX_LOCAL": "CLABE-numero"
						}
					},
					"account_holder": {
						"label": "Tilinhaltijan nimi"
					},
					"routing_number": {
						"label": "Reititysnumero"
					},
					"transit_number": {
						"label": "Reititysnumero"
					},
					"institution_number": {
						"label": "Instituutiotunnus"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Voit muokata pankkitilitietoja alkuprosessin jälkeen"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Yrityksen virallinen nimi"
					},
					"country": {
						"label": "Maa"
					},
					"registrationId": {
						"label": {
							"default": "Y-tunnus",
							"AT": "Y-tunnus",
							"AU": "ACN",
							"CA": "Yritystunnus",
							"ES": "Yrityksen NIF/NIE/DNI",
							"GB": "Organisaatiotunnus",
							"GR": "G.E.MI.-numero (Γ.Ε.ΜΗ.)",
							"US": "Työnantajan tunnistenumero"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Rekisteröintituomioistuin"
					},
					"goodsCategory": {
						"label": "Tuotekategoria"
					},
					"registered": {
						"label": {
							"default": "Rekisteröity yritys",
							"AU": "Yrityksellä on ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Yritys on ALV-velvollinen",
							"AU": "Yritys on ABT-velvollinen",
							"ES": "Yrityksellä on NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "ALV-tunnus",
							"AU": "ABN",
							"ES": "Yrityksen NIF/NIE/DNI"
						}
					},
					"storeName": {
						"label": "Kaupan nimi"
					},
					"website": {
						"label": "Verkkosivu"
					},
					"email": {
						"label": "Asiakaspalvelun sähköpostiosoite"
					},
					"entityType": {
						"label": "Yksikön tyyppi"
					},
					"toc_data": {
						"label": "Ehdot",
						"toc_approval_text": {
							"before_link": "Sinun",
							"link_text": "ehdot",
							"after_link": "Hyväksymispäivä {date}",
							"merchant_agreement": {
								"before_link": "Sinun",
								"link_text": "Kauppiassopimuksesi",
								"after_link": "hyväksymispäivä {date}"
							},
							"pricing_annex": {
								"before_link": "Sinun",
								"link_text": "hinnoitteluliitteesi",
								"after_link": "hyväksymispäivä {date}"
							}
						}
					},
					"companyName": {
						"label": "Yhteistyökumppanin nimi"
					},
					"registeredCompanyName": {
						"label": "Yrityksen nimi"
					},
					"address": {
						"label": "Osoite"
					},
					"operatingAddress": {
						"label": "Operatiivinen osoite"
					},
					"organizationEntityType": {
						"label": "Veroluokka"
					}
				},
				"api_key_dialog": {
					"title": "Klarnan API-tunnukset luotu",
					"subtitle": "Tunnukset näytetään vain yhden kerran. Lataa tunnuksesi klikkaamalla alla olevaa painiketta ennen kuin suljet tämän ikkunan.",
					"key_box": {
						"username": {
							"label": "Klarnan API-käyttäjänimi"
						},
						"password": {
							"label": "Klarnan API-salasana"
						},
						"file_name": "Klarna_tunnukset"
					},
					"buttons": {
						"download": "Lataa .txt-tiedostona"
					}
				},
				"platform_instructions": {
					"step": "Vaihe{current}/{max}",
					"next": "Seuraava",
					"back": "Takaisin",
					"shopify": [
						{
							"title": "Luo ja tallenna Klarnan API-tunnukset",
							"step_instructions": [
								[
									{
										"text": "Luo uudet API-tunnukset ja lataa tiedosto tietokoneellesi. Avaa tiedosto ja pidä se auki, sillä tarvitset näitä API-tunnuksia seuraavassa kohdassa."
									}
								]
							],
							"alternate": [
								{
									"text": "Lisätietoja Shopify-integroinnista saat"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "kattavasta integrointioppaasta."
								}
							]
						},
						{
							"title": "Asenna Klarna Shopify-kauppaasi",
							"step_instructions": [
								[
									{
										"text": "Siirry"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Klarna Payment Method Shopify -asennuksesi avustaja."
									}
								],
								[
									{
										"text": "Suorita integrointi noudattamalla ohjeita."
									}
								]
							],
							"alternate": [
								{
									"text": "Lisätietoja Shopify-integroinnista saat"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "kattavasta integrointioppaasta."
								}
							]
						},
						{
							"title": "Tee testiostos",
							"step_instructions": [
								[
									{
										"text": "Tarkista että integrointi on asennettu oikein tekemällä kauppaasi testiostos."
									}
								],
								[
									{
										"text": "Tilauksen jättämisen jälkeen siirry kohtaan"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Tilaukset Kauppiasportaalissa,"
									},
									{
										"text": "etsi tilauksesi ja peruuta se, jotta sinun ei tarvitse maksaa sitä itse."
									}
								],
								[
									{
										"text": "Kun integrointi on onnistunut, tämän sivun yläreunassa oleva banneri muuttuu vihreäksi ja siinä lukee ”Integration Completed” (integrointi valmis)."
									}
								]
							],
							"alternate": [
								{
									"text": "Lisätietoja Shopify-integroinnista saat"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "kattavasta integrointioppaasta."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Ota Klarna Payment Method -lisäosa käyttöön Plentymarketsilla",
							"step_instructions": [
								[
									{
										"text": "Pystyäksesi asentamaan Klarna-lisäosan Plentymarkets CERES -järjestelmän tulee olla käynnissä. N/A"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Ceres-lisäosa"
									},
									{
										"text": "on ladattavissa plentyMarketplacella. Täältä sinut ohjataan"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "asennusohjeisiin."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Klarna-integrointiin Plentymarkets Ceresiin liittyen saat"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "tästä linkistä."
									}
								]
							]
						},
						{
							"title": "Asennus ja asetusten määritys",
							"step_instructions": [
								[
									{
										"text": "Klarna-lisäosa asennetaan"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplacen kautta."
									},
									{
										"text": "Sinut ohjataan plentyMarketplaceen plentymarkets-järjestelmän taustapalvelusta. N/A"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "ohjeet lisäosien asentamiseen plentymarketsissa"
									},
									{
										"text": "löytyy plentyKnowledgesta."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Klarna-integrointiin Plentymarkets Ceresiin liittyen saat"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "tästä linkistä."
									}
								]
							]
						},
						{
							"title": "Lisäosan konfigurointi",
							"step_instructions": [
								[
									{
										"text": "Lisäosa on konfiguroitu suoraan asianmukaisissa asetuksissa. Klikkaamalla"
									},
									{
										"bold": "Klarna-lisäosan riviä"
									},
									{
										"text": "kokoonpanosivu avautuu."
									}
								],
								[
									{
										"text": "Konfigurointi on jaettu kahteen osaan:"
									},
									{
										"list": [
											[
												{
													"bold": "Tunnistus:"
												},
												{
													"text": "Tätä tilaa käytetään määrittämään, onko lisäosa testi- vai tuotantotilassa. Tilasta riippuen käyttäjätunnus ja salasana on tallennettava."
												}
											],
											[
												{
													"bold": "Yleisasetukset:"
												},
												{
													"text": "Täällä valitset, mitä tuotetta haluat käyttää. Joko Klarnan yksittäisiä maksutapoja (Klarna Payments) tai Klarnan koko kassaa (Klarna Checkout). Jos valitset Klarna Checkoutin, kaupan kassa korvataan automaattisesti Klarna Checkout -kassalla."
												}
											]
										]
									},
									{
										"text": "Muita asetuksia ei tarvita, ja mikäli poistat tämän lisäosan käytöstä, toiminto perutaan."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Klarna-integrointiin Plentymarkets Ceresiin liittyen saat"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "tästä linkistä."
									}
								]
							]
						},
						{
							"title": "Viimeiset tiedot",
							"step_instructions": [
								[
									{
										"text": "Järjestelmävaatimukset ovat seuraavat:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets versio 7"
											},
											{
												"text": "Ceres- ja IO-lisäosat asennettuina"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Klarna-integrointiin Plentymarkets Ceresiin liittyen saat"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "tästä linkistä."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Ota Klarna Checkout -lisäosa käyttöön WooCommercella",
							"step_instructions": [
								[
									{
										"text": "Varmista ensin, että olet asentanut Klarna Checkout -lisäosan WooCommercelle. Mikäli sinulla ei vielä ole lisäosaa, voit"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "hankkia sen"
									},
									{
										"text": "tältä sivulta."
									}
								],
								[
									{
										"text": "Saatuasi Klarnan API-tunnukset siirry ”Asetuksiin” ja sitten kohtaan ”Checkout” WooCommerce-paneelissasi. Valitse Klarna Checkout -kassa."
									}
								],
								[
									{
										"text": "Ota Klarna Checkout -kassa käyttöön merkitsemällä valintaruutu Ota Klarna Checkout -kassa käyttöön."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja WooCommerce-integroinnista saat"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "kattavasta oppaasta."
									}
								]
							]
						},
						{
							"title": "Määritä asetuksesi",
							"step_instructions": [
								[
									{
										"text": "Määritä Klarna Checkout -kassan asetukset. Huomaathan, että ”Nimike”-kenttää käytetään määrittämään nimike kassallasi sekä tilausvahvistussähköposteissasi näytettävälle maksutavalle (eli Klarna Checkout -kassa)."
									}
								],
								[
									{
										"text": "Merkitse valintaruutu ”Testitila”, jos haluat luoda tilauksia käyttämällä testitunnuksia."
									}
								],
								[
									{
										"text": "Nyt on aika täyttää maakohtaiset asetukset. Jos sijaintisi on Euroopassa, klikkaa Euroopan alueella ”laajenna”. Jos sijaintisi on Yhdysvalloissa, klikkaa Yhdysvaltojen alueella ”laajenna”."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja WooCommerce-integroinnista saat"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "kattavasta oppaasta."
									}
								]
							]
						},
						{
							"title": "Lisää omat Klarnan API-tunnuksesi",
							"step_instructions": [
								[
									{
										"text": "Lisää omat Klarnan API-tunnuksesi kenttiin Klarnan API-käyttäjänimi ja Klarnan API-salasana."
									}
								],
								[
									{
										"text": "Tallenna asetuksesi."
									}
								],
								[
									{
										"text": "Lopuksi aseta Klarna Checkout -kassa oletusmaksutavaksi. Siirry ”Asetuksiin” ja sitten kohtaan ”Maksut” WooCommerce-paneelissasi. Etsi kohta ”Maksutavat” ja aseta Klarna Checkout -kassa oletusmaksutavaksi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja WooCommerce-integroinnista saat"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "kattavasta oppaasta."
									}
								]
							]
						},
						{
							"title": "Viimeiset vaiheet",
							"step_instructions": [
								[
									{
										"text": "Muista ottaa käyttöön"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "permalinkit"
									},
									{
										"text": "WordPress-asennuksessasi. Muussa tapauksessa takaisinkutsut Klarnalta kauppaasi eivät toimi, eikä tilauksiin päivitetä oikeita tilaustietoja tai tiloja."
									}
								],
								[
									{
										"text": "Mikäli haluat käsitellä Klarna-tilauksesi suoraan WooCommercessa, sinun tulee asentaa"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Klarnan tilausten hallinta"
									},
									{
										"text": "-lisäosa."
									}
								],
								[
									{
										"text": "Varmista, että Klarna Checkout -kassa näkyy oikein lisäämällä tuote ostoskoriin ja etenemällä kassalle. Älä kuitenkaan oikeasti tee tilausta."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja WooCommerce-integroinnista saat"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "kattavasta oppaasta."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Luo ja tallenna Klarnan API-tunnukset",
							"step_instructions": [
								[
									{
										"text": "Luo uudet API-tunnukset ja lataa tiedosto tietokoneellesi. Avaa tiedosto ja pidä se auki, sillä tarvitset näitä API-tunnuksia seuraavassa kohdassa."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja WooCommerce-integroinnista saat"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "kattavasta integrointioppaasta."
									}
								]
							]
						},
						{
							"title": "Asenna ja ota käyttöön Klarna Payment Method -lisäosa",
							"step_instructions": [
								[
									{
										"text": "Asenna"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Klarna Payment Method -lisäosa WooCommercella."
									}
								],
								[
									{
										"text": "Siirry WooCommerce-tililläsi kohtaan"
									},
									{
										"bold": "Asetukset → Maksut → Klarna Payment Method."
									}
								],
								[
									{
										"text": "Ota Klarna Payment Method käyttöön merkitsemällä valintaruutu Ota Klarna Payment Method käyttöön."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja WooCommerce-integroinnista saat"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "kattavasta integrointioppaasta."
									}
								]
							]
						},
						{
							"title": "Määritä maa-asetuksesi",
							"step_instructions": [
								[
									{
										"text": "Täytä maa-asetukset. Jokaisella Klarna-maalla on omat maakohtaiset asetuksensa. Lisäämällä kauppiastunnuksen tiettyyn maahan pystyt tarjoamaan Klarna Payment Method -maksutapaa kyseisessä maassa."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja WooCommerce-integroinnista saat"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "kattavasta integrointioppaasta."
									}
								]
							]
						},
						{
							"title": "Kirjoita omat Klarnan API-tunnuksesi",
							"step_instructions": [
								[
									{
										"text": "Kirjoita omat Klarnan API-tunnuksesi kenttiin Klarnan API-käyttäjänimi ja Klarnan API-salasana."
									}
								],
								[
									{
										"text": "Tallenna asetuksesi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja WooCommerce-integroinnista saat"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "kattavasta integrointioppaasta."
									}
								]
							]
						},
						{
							"title": "Tee testiostos",
							"step_instructions": [
								[
									{
										"text": "Tarkista että integrointi on asennettu oikein tekemällä kauppaasi testiostos."
									}
								],
								[
									{
										"text": "Tilauksen jättämisen jälkeen siirry kohtaan"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Tilaukset Kauppiasportaalissa,"
									},
									{
										"text": "etsi tilauksesi ja peruuta se, jotta sinun ei tarvitse maksaa sitä itse."
									}
								],
								[
									{
										"text": "Kun integrointi on onnistunut, tämän sivun yläreunassa oleva banneri muuttuu vihreäksi ja siinä lukee ”Integration Completed” (integrointi valmis)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja WooCommerce-integroinnista saat"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "kattavasta integrointioppaasta."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Määritä asetukset Klarna Checkout -kassan käyttöön ottamiseksi.",
							"step_instructions": [
								[
									{
										"text": "Varmista ensin, että olet asentanut Klarna Checkout -moduulin Magentolle. Mikäli sinulla ei vielä ole moduulia, voit"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "hankkia sen"
									},
									{
										"text": "tältä sivulta."
									}
								],
								[
									{
										"text": "Saatuasi Klarnan API-tunnukset avaa Magento-paneeli. Siirry kohtaan ”Kaupat” → ”Kokoonpano” → ”Myynti” → ”Maksutavat” → ”Klarna” → ”Klarna API”."
									}
								],
								[
									{
										"text": "Laajenna ”Klarna API” -osiota ja täytä API-versiosi, Klarnan API-käyttäjänimesi ja Klarnan API-salasanasi. Poistathan testitilan käytöstä, jos olet valmis siirtämään verkkosivusi live-tilaan."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Magento-integroinnista saat"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "kattavasta oppaasta."
									}
								]
							]
						},
						{
							"title": "Viimeiset vaiheet",
							"step_instructions": [
								[
									{
										"text": "Kun asetukset on määritetty, sinun tulee tarkistaa, että Klarna Checkout -kassa on otettu käyttöön kassavalinnoissasi."
									}
								],
								[
									{
										"text": "Siirry Magento-paneelissasi kohtaan ”Kaupat” → ”Kokoonpano” → ”Myynti” → ”Kassa” → ”Klarna Checkout -valinnat”."
									}
								],
								[
									{
										"text": "Klarna Checkout -kassa tulee ottaa oletusarvoisesti käyttöön. Jos näin ei ole, vaihda"
									},
									{
										"bold": "Ota käyttöön"
									},
									{
										"text": "kohdasta ”Ota Klarna Checkout -kassa käyttöön”."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Luo ja tallenna Klarnan API-tunnukset",
							"step_instructions": [
								[
									{
										"text": "Luo uudet API-tunnukset ja lataa tiedosto tietokoneellesi. Avaa tiedosto ja pidä se auki, sillä tarvitset näitä API-tunnuksia seuraavassa kohdassa."
									}
								]
							]
						},
						{
							"title": "Asenna ja aktivoi Klarna Payment Method -moduuli",
							"step_instructions": [
								[
									{
										"text": "Vieraile"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Klarnan asetusten määrittäminen Magentolla -käyttöoppaassa"
									},
									{
										"text": "ja noudata siellä annettuja ohjeita asentaaksesi moduulin ja määrittääksesi sen asetukset Magento-tililläsi."
									}
								]
							]
						},
						{
							"title": "Tee testiostos",
							"step_instructions": [
								[
									{
										"text": "Tarkista että integrointi on asennettu oikein tekemällä kauppaasi testiostos."
									}
								],
								[
									{
										"text": "Tilauksen jättämisen jälkeen siirry kohtaan"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Tilaukset Kauppiasportaalissa,"
									},
									{
										"text": "etsi tilauksesi ja peruuta se, jotta sinun ei tarvitse maksaa sitä itse."
									}
								],
								[
									{
										"text": "Kun integrointi on onnistunut, tämän sivun yläreunassa oleva banneri muuttuu vihreäksi ja siinä lukee ”Integration Completed” (integrointi valmis)."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Ota Klarna Payment Method -lisäosa käyttöön Shopwarella",
							"step_instructions": [
								[
									{
										"text": "Varmista ensin, että olet asentanut Klarna Payment Method -lisäosan Shopwarelle. Mikäli sinulla ei vielä ole lisäosaa, voit"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "hankkia sen"
									},
									{
										"text": "tältä sivulta."
									}
								],
								[
									{
										"text": "Seuraavassa vaiheessa sinun tulee tuoda Klarna Payment Method -lisäosa Shopwareen klikkaamalla"
									},
									{
										"bold": "Kokoonpano → Lisäosan hallinta → Asennetut → Lataa lisäosa."
									},
									{
										"text": "Klikkaa"
									},
									{
										"bold": "Valitse"
									},
									{
										"text": "ja valitse Klarna Payment Method -lisäosan ZIP-tiedosto. Vahvista klikkaamalla"
									},
									{
										"bold": "Lataa lisäosa."
									},
									{
										"text": "Lisäosa löytyy nyt lisäosan hallinta kohdasta."
									}
								],
								[
									{
										"text": "Asenna lisäosa klikkaamalla"
									},
									{
										"bold": "vihreää ”+”"
									},
									{
										"text": "-kuvaketta."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Konfiguroi Klarna Payment Method -lisäosa Shopwarella",
							"step_instructions": [
								[
									{
										"text": "Navigoi lisäosan asetuksiin klikkaamalla"
									},
									{
										"bold": "Kokoonpano → Perusasetukset → Hae Klarna Payment Method"
									}
								],
								[
									{
										"text": "Kirjoita kenttiin omat Klarnan API-tunnuksesi"
									},
									{
										"bold": "Klarnan API-käyttäjänimi"
									},
									{
										"text": "että"
									},
									{
										"bold": "Klarnan API-salasana"
									},
									{
										"text": "ja tallenna muutoksesi."
									}
								],
								[
									{
										"text": "Muistathan käyttää live-tilaa sekä Klarnan API-tunnuksiasi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Konfiguroi Klarna Payment Method -yhdyskäytävä(t)",
							"step_instructions": [
								[
									{
										"text": "Ennen Klarnan käyttämistä sinun tulee aktivoida Klarna Payment Method -yhdyskäytävä(t). Löydät ne klikkaamalla"
									},
									{
										"bold": "Kokoonpano → Maksutavat"
									}
								],
								[
									{
										"text": "Kaikki Klarna Payment Method -yhdyskäytävät on asennettu oletusarvoisesti. Avaa Klarna Payment Method -yhdyskäytävät, joihin olet rekisteröitynyt ja aktivoi ne merkitsemällä"
									},
									{
										"bold": "Aktivoitu"
									},
									{
										"text": "-valintaruutu. Tallenna muutoksesi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Konfiguroi toimituskulusi",
							"step_instructions": [
								[
									{
										"text": "Konfiguroi toimituskulusi Klarna Payment Method -yhdyskäytävällesi/-käytävillesi klikkaamalla"
									},
									{
										"bold": "Kokoonpano → Toimituskulut"
									}
								],
								[
									{
										"text": "Valitse toimitustavat, joiden tulisi olla saatavilla Klarnalla, klikkaamalla"
									},
									{
										"bold": "kynä-kuvaketta."
									}
								],
								[
									{
										"text": "Valitse välilehti maksutavan valinta ja siirrä Klarna Payment Method -yhdyskäytäväsi tilasta"
									},
									{
										"bold": "Saatavilla"
									},
									{
										"text": "tilaan"
									},
									{
										"bold": "Valittu."
									},
									{
										"text": "Tallenna asetuksesi"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Aktivoi Klarna Payment Method -lisäosa",
							"step_instructions": [
								[
									{
										"text": "Seuraavaksi sinun tulee aktivoida Klarna Payment Method -lisäosa. Klikkaa"
									},
									{
										"bold": "Kokoonpano → Lisäosan hallinta → Asennetut"
									},
									{
										"text": "päästäksesi lisäosan hallintaan."
									}
								],
								[
									{
										"text": "Aktivoi lisäosa klikkaamalla"
									},
									{
										"bold": "punaista ”X”"
									},
									{
										"text": "-kuvaketta."
									}
								],
								[
									{
										"text": "Sinulta kysytään, haluatko tyhjentää välimuistin. Klikkaa"
									},
									{
										"bold": "Kyllä."
									},
									{
										"text": "Huomaathan, että sinun tulee tyhjentää välimuisti ja laatia teemat joka kerta, kun muutat jotakin moduulin asetuksissa tai Klarnan maksutavoissa."
									}
								],
								[
									{
										"text": "Aktivoidaksesi Klarna Payment Method -lisäosan kokonaan, kaupan teema tulee laatia uudelleen. Klikkaa"
									},
									{
										"bold": "Laadi teemat"
									},
									{
										"text": "pyydettäessä."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Viimeiset vaiheet",
							"step_instructions": [
								[
									{
										"text": "Pyöristysvirheiden välttämiseksi varmistathan, että palvelimellesi on asennettu PHP-laajennus bcmath. Oppaan löydät täältä"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "Tästä löydät"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Käynnistä taustapalvelusi kertaalleen uudelleen varmistaaksesi, että kaikki kokoonpanot ovat kaupassasi saatavilla."
									}
								],
								[
									{
										"text": "Varmista, että Klarna Payment -tuotteesi näkyy/näkyvät oikein lisäämällä tuote ostoskoriin, valitsemalla maksutavaksi Klarna ja etenemällä kassalle. Älä kuitenkaan oikeasti tee tilausta."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Ota Klarna Checkout -lisäosa käyttöön Shopwarella",
							"step_instructions": [
								[
									{
										"text": "Varmista ensin, että olet asentanut Klarna Checkout -lisäosan Shopwarelle (versio 5.2.17 tai uudempi). Mikäli sinulla ei vielä ole lisäosaa, voit"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "hankkia sen"
									},
									{
										"text": "tältä sivulta."
									}
								],
								[
									{
										"text": "Seuraavassa vaiheessa sinun tulee tuoda Klarna Checkout -lisäosa Shopwareen klikkaamalla"
									},
									{
										"bold": "Kokoonpano → Lisäosan hallinta → Asennetut → Lataa lisäosa."
									},
									{
										"text": "Klikkaa"
									},
									{
										"bold": "Valitse"
									},
									{
										"text": "ja valitse Klarna Checkout -lisäosan ZIP-tiedosto. Vahvista klikkaamalla"
									},
									{
										"bold": "Lataa lisäosa."
									},
									{
										"text": "Lisäosa löytyy nyt lisäosan hallinta kohdasta."
									}
								],
								[
									{
										"text": "Asenna lisäosa klikkaamalla"
									},
									{
										"bold": "vihreää ”+”"
									},
									{
										"text": "-kuvaketta."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Konfiguroi Klarna Checkout -lisäosa Shopwarella",
							"step_instructions": [
								[
									{
										"text": "Navigoi lisäosan asetuksiin klikkaamalla"
									},
									{
										"bold": "Kokoonpano → Perusasetukset → Hae Klarna Checkout -kassa"
									}
								],
								[
									{
										"text": "Kirjoita kenttiin omat Klarnan API-tunnuksesi"
									},
									{
										"bold": "Klarnan API-käyttäjänimi"
									},
									{
										"text": "että"
									},
									{
										"bold": "Klarnan API-salasana"
									},
									{
										"text": "ja tallenna muutoksesi."
									}
								],
								[
									{
										"text": "Muistathan käyttää live-tilaa sekä Klarnan API-tunnuksiasi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Aktivoi Klarna Checkout -maksun yhdyskäytävä",
							"step_instructions": [
								[
									{
										"text": "Ennen Klarnan käyttämistä sinun tulee aktivoida Klarna Payments -yhdyskäytävä. Löydät ne klikkaamalla"
									},
									{
										"bold": "Kokoonpano → Maksutavat"
									}
								],
								[
									{
										"text": "Avaa Klarna Checkout -yhdyskäytävä ja aktivoi se merkitsemällä"
									},
									{
										"bold": "Aktivoitu"
									},
									{
										"text": "-valintaruutu. Tallenna muutoksesi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Konfiguroi toimituskulusi",
							"step_instructions": [
								[
									{
										"text": "Konfiguroi toimituskulusi Klarna Checkout -kassalle klikkaamalla"
									},
									{
										"bold": "Kokoonpano → Toimituskulut"
									}
								],
								[
									{
										"text": "Valitse toimitustavat, joiden tulisi olla saatavilla Klarnalla, klikkaamalla"
									},
									{
										"bold": "kynä-kuvaketta."
									}
								],
								[
									{
										"text": "Valitse välilehti maksutavan valinta ja siirrä Klarna Checkout -kassa tilasta"
									},
									{
										"bold": "Saatavilla"
									},
									{
										"text": "tilaan"
									},
									{
										"bold": "Valittu."
									},
									{
										"text": "Tallenna asetuksesi"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Aktivoi Klarna Checkout -lisäosasi",
							"step_instructions": [
								[
									{
										"text": "Seuraavaksi sinun tulee aktivoida Klarna Checkout -lisäosa. Klikkaa"
									},
									{
										"bold": "Kokoonpano → Lisäosan hallinta → Asennetut"
									},
									{
										"text": "päästäksesi lisäosan hallintaan."
									}
								],
								[
									{
										"text": "Aktivoi lisäosa klikkaamalla"
									},
									{
										"bold": "punaista ”X”"
									},
									{
										"text": "-kuvaketta."
									}
								],
								[
									{
										"text": "Sinulta kysytään, haluatko tyhjentää välimuistin. Klikkaa"
									},
									{
										"bold": "Kyllä."
									}
								],
								[
									{
										"text": "Aktivoidaksesi Klarna Checkout -lisäosan kokonaan, kaupan teema tulee laatia uudelleen. Klikkaa"
									},
									{
										"bold": "Laadi teemat"
									},
									{
										"text": "pyydettäessä."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Viimeiset vaiheet",
							"step_instructions": [
								[
									{
										"text": "Pyöristysvirheiden välttämiseksi varmistathan, että palvelimellesi on asennettu PHP-laajennus bcmath. Oppaan löydät täältä"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "Tästä löydät"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Varmistathan, ettei ”Ylimääräinen osoiterivi 1” ja ”Ylimääräinen osoiterivi 2” ole merkitty pakollisiksi."
									}
								],
								[
									{
										"text": "Käynnistä taustapalvelusi kertaalleen uudelleen varmistaaksesi, että kaikki kokoonpanot ovat kaupassasi saatavilla."
									}
								],
								[
									{
										"text": "Varmista, että Klarna Checkout -kassa näkyy oikein lisäämällä tuote ostoskoriin, valitsemalla maksutavaksi Klarna ja etenemällä kassalle. Älä kuitenkaan oikeasti tee tilausta."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Ota Klarna Payment Method -lisäosa käyttöön Shopwarella",
							"step_instructions": [
								[
									{
										"text": "Pystyäksesi asentamaan Klarna-lisäosan Shopware 6 -järjestelmän tulee olla käynnissä. Asennusohjeet löydät"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "täältä."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Asennus ja asetusten määritys. Klarna-lisäosan voi asentaa usealla tapaa.",
							"step_instructions": [
								[
									{
										"text": "Käynnistä ensin avustaja."
									}
								],
								[
									{
										"text": "Asennus ylläpidon kautta."
									}
								],
								[
									{
										"text": "Asennus Community Store Direct Downloadin kautta."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Aktivoi Klarna Payment Method -lisäosa Shopwarella",
							"step_instructions": [
								[
									{
										"text": "Siirry lisäosiesi yleiskuvaan Shopwaren ylläpidossa. Pääset tähän polkua"
									},
									{
										"bold": "Asetukset > Järjestelmä > Lisäosat."
									}
								],
								[
									{
										"text": "Valitse"
									},
									{
										"bold": "Asenna"
									},
									{
										"text": "kontekstivalikosta (\"...\"). Saat Shopwarelta viestin, jossa kerrotaan lisäosan asennuksen onnistumisesta."
									}
								],
								[
									{
										"text": "Turvallisuussyistä lisäosa on nyt asennettu, mutta sitä ei ole vielä aktivoitu. Sinun tulee optimoida se ensin käyttöoikeustietojesi ja yksilöllisten asetustesi avulla."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Avustaja",
							"step_instructions": [
								[
									{
										"text": "Kun lisäosa on aktivoitu, siirry"
									},
									{
										"bold": "kontekstivalikkoon (\"...\") > avustaja.",
										"text": "Sen jälkeen sinut ohjataan eteenpäin työnkulkuun."
									}
								],
								[
									{
										"text": "Työnkulku ohjaa sinut koko asetusprosessin läpi, ja siellä voit rekisteröityä Klarnalla, jos sinulla ei ole vielä myyjätiliä."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Lisäosan konfigurointi",
							"step_instructions": [
								[
									{
										"bold": "Myyntikanavat."
									},
									{
										"text": "Täällä voit määrittää, haluatko seuraavien asetusten koskevan \"kaikkia myyntikanavia\" vai vain tiettyjä yksittäisiä myyntikanavia."
									}
								],
								[
									{
										"bold": "API-asetukset."
									},
									{
										"text": "API-käyttäjänimi ja API-salasana: Kirjoita live- ja testitilan API-käyttöoikeustietosi täällä asianmukaisiin osioihin."
									}
								],
								[
									{
										"text": "Voit testata Klarnan API-tunnuksiasi klikkaamalla"
									},
									{
										"bold": "API-testitunnukset",
										"text": "-painiketta, joka sijaitsee otsikossa. Saat sitten viestin onnistumisesta tai ilmoituksen siitä, mitkä tiedot vaikuttavat olevan virheellisiä."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Aktivoi/deaktivoi lisäosa",
							"step_instructions": [
								[
									{
										"text": "Jos haluat aktivoida/deaktivoida Klarna Payment Method -lisäosan tai haluat vain tarkastella nykyistä aktivointitilaa, siirry Shopware-ylläpitoon ja valitse"
									},
									{
										"bold": "Asetukset > Järjestelmä > Lisäosat."
									}
								],
								[
									{
										"text": "Täältä löydät nykyisen tilan taulukosta kohdasta"
									},
									{
										"bold": "\"Omat lisäosat\"."
									}
								],
								[
									{
										"text": "Tila voidaan vaihtaa klikkaamalla liukusäädintä."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						},
						{
							"title": "Viimeiset vaiheet",
							"step_instructions": [
								[
									{
										"text": "Pyöristysvirheiden välttämiseksi varmistathan, että sinulla on PHP-versio  >= 7.2."
									}
								],
								[
									{
										"text": "Viimeistele Shopware-asennus"
									},
									{
										"bold": "(Storefront + Administration, not headless)."
									}
								],
								[
									{
										"text": "Järjestelmään tulee päästä ulkopuolelta maksutilan päivittämiseksi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja Shopware-integroinnista saat"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "kattavasta oppaastamme (saksaksi)."
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Luo ja tallenna Klarnan API-tunnukset",
							"step_instructions": [
								[
									{
										"text": "Luo uudet API-tunnukset ja lataa tiedosto tietokoneellesi. Avaa tiedosto ja pidä se auki, sillä tarvitset näitä API-tunnuksia seuraavassa kohdassa."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja 3dcart-integroinnista saat"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "kattavasta integrointioppaasta."
									}
								]
							]
						},
						{
							"title": "Aktivoi Klarna Payment Method Online Store Managerilla",
							"step_instructions": [
								[
									{
										"text": "Kirjaudu sisään"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "3dcart Online Store Manageriin"
									},
									{
										"text": "ja siirry kohtaan"
									},
									{
										"bold": "Asetukset → Maksu."
									}
								],
								[
									{
										"text": "Napsauta Maksu-sivulla"
									},
									{
										"bold": "Valitse maksutavat"
									},
									{
										"text": "-painiketta."
									}
								],
								[
									{
										"text": "Näet luettelon esiasennetuista moduuleista. Etsi Klarna-moduuli ja aktivoi se käyttämällä valintakytkintä."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja 3dcart-integroinnista saat"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "kattavasta integrointioppaasta."
									}
								]
							]
						},
						{
							"title": "Kirjoita omat Klarnan API-tunnuksesi",
							"step_instructions": [
								[
									{
										"text": "Moduulin aktivoinnin jälkeen kirjoita Klarna API -käyttäjätunnuksesi (UID) asianmukaiseen kenttään. Löydät tunnuksesi aiemmin lataamastasi tiedostosta."
									}
								],
								[
									{
										"text": "Klikkaa seuraavaksi"
									},
									{
										"bold": "Vaihda salasana"
									},
									{
										"text": "-linkkiä ja kirjoita Klarnan API-salasanasi salasanakenttään."
									}
								],
								[
									{
										"text": "Kohdasta"
									},
									{
										"bold": "Kieli Maa"
									},
									{
										"text": "valitse maan kieli, jota käytetään kauppasi Klarna-maksutapavaihtoehdoissa."
									}
								],
								[
									{
										"text": "Käyttäjänimikentän yläpuolella on valintaruutu, jonka nimi on"
									},
									{
										"bold": "\"Testitila\"."
									},
									{
										"text": "Ota testitila käyttöön merkitsemällä tämä valintaruutu. Näin voit tehdä tilauksia ilman veloituksia tai maksutoimintoja moduulin testaamisen yhteydessä."
									}
								],
								[
									{
										"text": "Kun olet määrittänyt asetuksesi, klikkaa oikeasta yläkulmasta ”Tallenna”."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja 3dcart-integroinnista saat"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "kattavasta integrointioppaasta."
									}
								]
							]
						},
						{
							"title": "Tee testiostos",
							"step_instructions": [
								[
									{
										"text": "Tarkista että integrointi on asennettu oikein tekemällä kauppaasi testiostos."
									}
								],
								[
									{
										"text": "Tilauksen jättämisen jälkeen siirry kohtaan"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Tilaukset Kauppiasportaalissa,"
									},
									{
										"text": "etsi tilauksesi ja peruuta se, jotta sinun ei tarvitse maksaa sitä itse."
									}
								],
								[
									{
										"text": "Kun integrointi on onnistunut, tämän sivun yläreunassa oleva banneri muuttuu vihreäksi ja siinä lukee ”Integration Completed” (integrointi valmis)."
									}
								],
								[
									{
										"text": "Jos otit testitilan käyttöön edellisessä vaiheessa, palaa takaisin, poista valintamerkki ja tallenna ennen kaupan asettamista livetilaan. Näin todelliset tilaukset menevät läpi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Lisätietoja 3dcart-integroinnista saat"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "kattavasta integrointioppaasta."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Luo ja tallenna Klarnan API-tunnukset",
							"step_instructions": [
								[
									{
										"text": "Luo uudet API-tunnukset ja lataa tiedosto tietokoneellesi. Avaa tiedosto ja pidä se auki, sillä tarvitset näitä API-tunnuksia seuraavassa kohdassa."
									}
								]
							],
							"alternate": [
								{
									"text": "Lisätietoja BigCommerce-integroinnista saat"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "kattavasta integrointioppaasta."
								}
							]
						},
						{
							"title": "Määritä BigCommerce-asetuksesi",
							"step_instructions": [
								[
									{
										"text": "Siirry BigCommercessa kohtaan"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Kaupan asetusten määrittäminen › Maksut"
									},
									{
										"text": "ja laajenna Verkkomaksutavat-osiota. Klikkaa sitten"
									},
									{
										"bold": "Asetusten määrittäminen"
									},
									{
										"text": "Klarna Payment Methodin vierestä."
									}
								],
								[
									{
										"text": "Sinut ohjataan Klarna Payment Methodin Asetukset-välilehdelle. Siirry edellisessä kohdassa tallentamaasi API-tunnukset sisältävään tiedostoon ja kopioi käyttäjänimi ja salasana asianmukaisiin kenttiin."
									}
								],
								[
									{
										"text": "Kun olet valmis, tallenna muutokset."
									}
								]
							],
							"alternate": [
								{
									"text": "Lisätietoja BigCommerce-integroinnista saat"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "kattavasta integrointioppaasta."
								}
							]
						},
						{
							"title": "Tee testiostos",
							"step_instructions": [
								[
									{
										"text": "Tarkista että integrointi on asennettu oikein tekemällä kauppaasi testiostos."
									}
								],
								[
									{
										"text": "Tilauksen jättämisen jälkeen siirry kohtaan"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Tilaukset Kauppiasportaalissa,"
									},
									{
										"text": "etsi tilauksesi ja peruuta se, jotta sinun ei tarvitse maksaa sitä itse."
									}
								],
								[
									{
										"text": "Kun integrointi on onnistunut, tämän sivun yläreunassa oleva banneri muuttuu vihreäksi ja siinä lukee ”Integration Completed” (integrointi valmis)."
									}
								]
							],
							"alternate": [
								{
									"text": "Lisätietoja BigCommerce-integroinnista saat"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "kattavasta integrointioppaasta."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Aktivoi Klarna Checkout -moduuli",
							"step_instructions": [
								[
									{
										"text": "Varmista ensin, että olet asentanut virallisen Klarna-moduulin Prestashopille. Mikäli sinulla ei ole sitä vielä, voit"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "hankkia sen"
									},
									{
										"text": "tältä sivulta."
									}
								],
								[
									{
										"text": "1.1.2023 alkaen näitä Prestaworks AB (SI) -yhtiön kehittämiä ja omistamia lisäosia ei jaeta enää ilmaiseksi. Jos olet kiinnostunut Klarnasta, voit ostaa lisäosan tai odottaa, kunnes Klarnan omistamat lisäosat julkaistaan vuoden 2023 toisella vuosineljänneksellä."
									}
								],
								[
									{
										"text": "Kirjaudu Prestashop-ylläpitosivulle ja siirry kohtaan"
									},
									{
										"bold": "Moduulit → Moduulit."
									}
								],
								[
									{
										"text": "Hae hakuruudusta ”Klarna” löytääksesi Prestaworks AB:n Klarna-moduulin. Klikkaa"
									},
									{
										"bold": "Konfiguroi."
									}
								]
							]
						},
						{
							"title": "Konfiguroi Klarna-moduulin asetukset",
							"step_instructions": [
								[
									{
										"text": "Olet nyt moduulin asetussivulla. ”Yleisten asetusten” yläreunassa näet painikkeen"
									},
									{
										"bold": "Aktivoi KCO tässä kaupassa"
									},
									{
										"text": "(Klarna Checkout -kassa V3). Valitse"
									},
									{
										"bold": "Kyllä."
									}
								],
								[
									{
										"text": "Klikkaa"
									},
									{
										"bold": "Tallenna"
									},
									{
										"text": "asetusten tallentamiseksi."
									}
								],
								[
									{
										"text": "Klikkaa nyt myyntimaatasi vasemmanpuoleisesta valikosta ja kirjoita Klarnan API-tunnukset kohtaan"
									},
									{
										"bold": "Klarnan API-käyttäjänimi"
									},
									{
										"text": "että"
									},
									{
										"bold": "Klarnan API-salasana."
									}
								],
								[
									{
										"text": "Klikkaa"
									},
									{
										"bold": "Tallenna."
									}
								]
							]
						},
						{
							"title": "Viimeiset vaiheet",
							"step_instructions": [
								[
									{
										"text": "Tarkista, että testitila on poissa päältä, jos olet valmis siirtämään sivustosi livetilaan. Voit tehdä tämän"
									},
									{
										"bold": "Yleisasetukset-kohdasta."
									},
									{
										"text": "Painike"
									},
									{
										"bold": "Testiajo"
									},
									{
										"text": "tulisi asettaa:"
									},
									{
										"bold": "Ei."
									}
								],
								[
									{
										"text": "Ollessasi"
									},
									{
										"bold": "Yleisasetuksissa"
									},
									{
										"text": "varmista, että olet määrittänyt asetuksesi liittyen tilausten käsittelyyn, laskujen lähetykseen jne."
									}
								],
								[
									{
										"text": "Varmista, että Klarna Checkout -kassa näkyy oikein lisäämällä tuote ostoskoriin ja etenemällä kassalle. Älä kuitenkaan oikeasti tee tilausta."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Luo ja tallenna Klarnan API-tunnukset",
							"step_instructions": [
								[
									{
										"text": "Luo uudet API-tunnukset ja lataa tiedosto tietokoneellesi. Avaa tiedosto ja pidä se auki, sillä tarvitset näitä API-tunnuksia seuraavassa kohdassa."
									}
								]
							]
						},
						{
							"title": "Asenna ja aktivoi Klarna Payment Method -moduuli",
							"step_instructions": [
								[
									{
										"text": "Avaa"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Klarna Payment Method Prestashop -ohjesivu"
									},
									{
										"text": "ja noudata siellä annettuja ohjeita asentaaksesi moduulin ja määrittääksesi sen asetukset Prestashop-tililläsi."
									}
								]
							]
						},
						{
							"title": "Tee testiostos",
							"step_instructions": [
								[
									{
										"text": "Tarkista että integrointi on asennettu oikein tekemällä kauppaasi testiostos."
									}
								],
								[
									{
										"text": "Tilauksen jättämisen jälkeen siirry kohtaan"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Tilaukset Kauppiasportaalissa,"
									},
									{
										"text": "etsi tilauksesi ja peruuta se, jotta sinun ei tarvitse maksaa sitä itse."
									}
								],
								[
									{
										"text": "Kun integrointi on onnistunut, tämän sivun yläreunassa oleva banneri muuttuu vihreäksi ja siinä lukee ”Integration Completed” (integrointi valmis)."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Luo Klarnan API-tunnukset.",
							"step_instructions": [
								[
									{
										"text": "Tarvitset näitä tunnuksia Klarnan integroimiseksi kauppaasi."
									}
								]
							]
						},
						{
							"title": "Lisää Klarna uudeksi maksutavaksi.",
							"step_instructions": [
								[
									{
										"text": "Jumpseller Admin Panel -paneelissa siirry kohtaan Asetukset > Maksut, etsi luettelosta ”Klarna” ja napsauta ”Lisää maksutapa”."
									}
								]
							]
						},
						{
							"title": "Määritä uusi maksutapamme.",
							"step_instructions": [
								[
									{
										"text": "Klarnan määrityspaneelissa (Jumpseller Admin Panel ja siirry kohtaan Asetukset > Maksut > Klarna), (i) lisää ensimmäisessä vaiheessa luodut Klarna API-tunnukset, (ii) valitse EMD-paketit, jotka haluat / sinun tarvitsee jakaa Klarnan kanssa ja (iii) valitse, tarvitseeko sinun aktivoida tilauksia automaattisesti (oletusarvoisesti ei)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integroi Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Katso integrointiopas"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Englanti"
									},
									{
										"text": "sekä"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Hollanti"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Integroi Shoper",
							"step_instructions": [
								[
									{
										"text": "Katso integrointiopas"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "Shoper-verkkosivustolla"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Integroi Timma",
							"step_instructions": [
								[
									{
										"text": "Katso integrointiopas"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "Timma-verkkosivustolla"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Luo ja tallenna Klarnan API-tunnukset",
							"step_instructions": [
								[
									{
										"text": "Luo uudet API-tunnukset ja lataa tiedosto tietokoneellesi. Avaa tiedosto ja pidä se auki, sillä tarvitset näitä API-tunnuksia seuraavassa kohdassa."
									}
								]
							]
						},
						{
							"title": "SmartEtailing-integrointi",
							"step_instructions": [
								[
									{
										"text": "Noudata Workstand-verkkosivustolla"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "olevia ohjeita."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Luo ja tallenna Klarnan API-tunnukset",
							"step_instructions": [
								[
									{
										"text": "Luo uudet API-tunnukset ja lataa tiedosto tietokoneellesi. Avaa tiedosto ja pidä se auki, sillä tarvitset näitä API-tunnuksia seuraavassa kohdassa."
									}
								]
							]
						},
						{
							"title": "Workstand-integrointi",
							"step_instructions": [
								[
									{
										"text": "Noudata Workstand-verkkosivustolla"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "olevia ohjeita."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Lue lisäosaa koskevat dokumentit",
							"step_instructions": [
								[
									{
										"text": "Siirry"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "dokumentaatiosivulle"
									}
								]
							]
						},
						{
							"title": "Aktivoi Klarna Checkout -moduuli JTL-Shop 5:lle",
							"step_instructions": [
								[
									{
										"text": "Varmista, että olet asentanut virallisen Klarna-lisäosan. Mikäli sinulla ei ole sitä vielä,"
									},
									{
										"text": "siirry"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "tällä sivulla"
									},
									{
										"text": "tältä sivulta."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Lue lisäosaa koskevat dokumentit",
							"step_instructions": [
								[
									{
										"text": "Siirry"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "dokumentaatiosivulle"
									}
								]
							]
						},
						{
							"title": "Aktivoi Klarna Payments -moduuli JTL-Shop 5:lle",
							"step_instructions": [
								[
									{
										"text": "Varmista, että olet asentanut virallisen Klarna-lisäosan. Mikäli sinulla ei ole sitä vielä,"
									},
									{
										"text": "siirry"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "tällä sivulla"
									},
									{
										"text": "tältä sivulta."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Toimi näin",
							"step_instructions": [
								[
									{
										"bold": "Luo Klarnan API-tunnukset."
									},
									{
										"text": "Tarvitset näitä tunnuksia Klarnan integroimiseksi kauppaasi."
									}
								],
								[
									{
										"bold": "Lisää Klarnan API-tunnukset taustapalvelujärjestelmääsi ottaaksesi Klarnan käyttöön."
									},
									{
										"text": "Katso"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Kehittäjäportaali"
									},
									{
										"text": "saadaksesi lisätukea."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Etunimi",
							"error": "Kirjoita etunimi"
						},
						"last_name": {
							"label": "Sukunimi",
							"error": "Kirjoita sukunimi"
						},
						"dateOfBirth": {
							"label": {
								"default": "Syntymäaika (PP/KK/VVVV)",
								"without_format": "Syntymäaika",
								"US": "Syntymäaika (KK/PP/VVVV)"
							},
							"error": "Kirjoita kelvollinen päivämäärä",
							"error_too_young": "Sinun tulee olla vähintään 18-vuotias myydäksesi Klarnalla"
						},
						"address": {
							"label": "Kotiosoite",
							"error": "Virallinen kotiosoite puuttu"
						},
						"city": {
							"label": "Kaupunki",
							"error": "Kaupunki puuttuu"
						},
						"country": {
							"label": "Maa",
							"error": "Valitse maa"
						},
						"postal_code": {
							"label": {
								"default": "Postinumero",
								"US": "Postinumero"
							},
							"error": {
								"default": "Kirjoita kelvollinen postinumero",
								"US": "Kirjoita kelvollinen postinumero"
							}
						},
						"region": {
							"label": "Maakunta/alue (valinnainen)",
							"label_summary": "Maakunta/alue"
						},
						"state": {
							"label": "Maakunta",
							"error": "Kirjoita maakunta"
						},
						"role_question": {
							"OWNER": "Onko tämä henkilö omistaja?",
							"BENEFICIAL_OWNER": "Hallitseeko tämä henkilö yli 25 % osakkeista tai äänioikeuksista?",
							"ULTIMATE_BENEFICIAL_OWNER": "Tämä henkilö omistaa tai hallitsee yli 25 % osakkeista tai äänioikeuksista"
						},
						"is_person_pep": [
							{
								"text": "Onko tämä henkilö"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "poliittisesti vaikutusvaltainen henkilö"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "läheisessä perhesuhteessa"
							},
							{
								"text": "tai"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "läheisessä työsuhteessa"
							},
							{
								"text": "poliittisesti vaikutusvaltaiseen henkilöön?"
							}
						],
						"pep_relationship": {
							"label": "Suhde",
							"error": "Valitse tämän henkilön ja poliittisesti vaikutusvaltaisen henkilön välinen suhde"
						},
						"pep_position": {
							"label": "Poliittisesti vaikutusvaltaisen henkilön asema",
							"error": "Valitse asema, jossa poliittisesti vaikutusvaltainen henkilö on"
						},
						"personal_id_question": "Tällä henkilöllä ei ole henkilökohtaista tunnistenumeroa",
						"personal_id": {
							"US": {
								"label": "Sosiaaliturvatunnus (4 viimeistä merkkiä)",
								"label_summary": "Sosiaaliturvatunnus"
							},
							"US_FULL_SSN": {
								"label": "Sosiaaliturvatunnus",
								"label_summary": "Sosiaaliturvatunnus"
							},
							"CA": {
								"label": "Sosiaalivakuutusnumero (SIN) tai passin numero",
								"label_summary": "Sosiaalivakuutusnumero (SIN) tai passin numero"
							},
							"SE": {
								"label": "Henkilökohtainen tunnistenumero (PNO)",
								"label_summary": "Henkilökohtainen tunnistenumero (PNO)"
							},
							"FI": {
								"label": "Henkilötunnus (HETU)",
								"label_summary": "Henkilötunnus (HETU)"
							},
							"NO": {
								"label": "Kansallinen henkilötunnus",
								"label_summary": "Kansallinen henkilötunnus"
							},
							"DK": {
								"label": "Henkilökohtainen tunnistenumero",
								"label_summary": "Henkilökohtainen tunnistenumero (CPR)"
							},
							"IT": {
								"label": "Verotunnus",
								"label_summary": "Verotunnus"
							},
							"ES": {
								"label": "Henkilökohtainen tunnistenumero",
								"label_summary": "Henkilötunnus (DNI)"
							},
							"PL": {
								"label": "Henkilökohtainen tunnistenumero",
								"label_summary": "Henkilötunnus (PESEL)"
							},
							"default": {
								"label": "Passin numero",
								"label_summary": "Passin numero"
							},
							"value": "Luottamuksellinen"
						},
						"registration_number": {
							"label": "Yrityksen tunnistenumero",
							"error": "Kirjoita yrityksen tunnistenumero (EIN) muodossa: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Kaupan nimi",
							"error": "Anna kelvollinen yrityksen nimi"
						},
						"legal_company_name": {
							"label": "Yrityksen virallinen nimi",
							"error_label": "Anna yrityksen virallinen nimi"
						},
						"add_person": "Lisää henkilö",
						"remove": "Poista",
						"edit": "Muokkaa"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "Kauppiastunnus: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Markkinointimateriaalit",
						"text": "Kuulut nyt Klarna-perheeseen. Tässä on sinulle materiaaleja ja muuta, jotta pääset alkuun.",
						"link": "Lataus"
					},
					"invite_more_users": {
						"title": "Kutsu lisää käyttäjiä",
						"text": "Kutsu työkumppanisi Kauppiasportaaliin. Voit määrittää heille jokaiselle räätälöidyt luvat.",
						"link": "Kutsu käyttäjiä"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Tuotteet ja hinnoittelu",
					"subtitle": "{country}",
					"pricing": "Hinnoittelu maassa {country}",
					"monthly_fee": "kuukausimaksu",
					"transaction_fee": "maksutapahtuman maksu",
					"before_link": "Hyväksyn Klarnan",
					"link_text": "ehdot",
					"after_link_one_product": "tämän tuotteen osalta",
					"after_link_more_than_one_product": "näiden tuotteiden osalta",
					"product_not_available_in_your_country": "* Tämä tuote ei ole saatavilla kotimarkkina-alueellasi, mutta se toimii muissa maissa."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Asennettu"
						},
						"in_progress": {
							"text": "Käsitellään"
						}
					}
				},
				"phone_collection_block": {
					"title": "Onko sinulla ongelmia Klarna-integrointisi kanssa?",
					"description": "Jätä numerosi alla olevaan kenttään ja edustajamme soittaa sinulle ja auttaa sinua Klarnan lisäämisessä verkkokauppaasi.",
					"success_banner": "Kiitos! Tiimimme ottaa sinuun yhteyttä mahdollisimman pian.",
					"submit": "Lähetä",
					"fields": {
						"phone": {
							"label": "Puhelinnumero",
							"tooltip": "Sinun tulee lisätä maakoodi, esim. +1 541 754 3010",
							"errors": {
								"required": "Puhelinnumero on pakollinen",
								"invalid": "Virheellinen puhelinnumero"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Kuka on valtuutettu allekirjoittamaan sopimuksia yrityksen puolesta?",
						"managed": "Kuka allekirjoittaa sopimukset yrityksessä?",
						"recollection": "Ketkä ovat yrityksenne lailliset edustajat?"
					},
					"subtitle": {
						"unmanaged": "Yrityksesi on solmimassa sopimuksen Klarnan kanssa. Meidän tulee vahvistaa, kuka on laillisesti valtuutettu allekirjoittamaan sopimuksia.",
						"managed": "Anna sopimuksen solmivan yrityksen kaikki valtuutettujen allekirjoittajien tiedot. Laki edellyttää meitä vahvistamaan näiden edustajien valtuudet allekirjoittajina. Mikäli kukaan luettelossa mainittu ei allekirjoittanut sopimusta, klikkaa ”Lisää henkilö” ja anna vaaditut tiedot.",
						"recollection": "Yrityksellänne on voimassa oleva sopimus Klarna AB:n kanssa, joten olemme laillisesti velvoitettuja keräämään ja vahvistamaan yrityksen laillisten edustajien tiedot."
					},
					"form_title": "Kirjoita tiedot",
					"robot_message": {
						"unmanaged": "Yleensä kyse on hallituksen puheenjohtajista tai muista johtajista, kuten toimitusjohtajasta, talousjohtajasta tai operatiivisesta johtajasta. Huomaathan, että tietojen on vastattava kaupparekisteriin ilmoitettuja tietoja.",
						"managed": "Yleensä kyse on hallituksen puheenjohtajista tai muista johtajista, kuten toimitusjohtajasta, talousjohtajasta tai operatiivisesta johtajasta. Huomaathan, että tietojen on vastattava kaupparekisteriin ilmoitettuja tietoja."
					},
					"error_tooltip": {
						"too_young": "Tämä henkilö ei voi lähettää hakemusta, sillä hän on alle {minAge}-vuotias."
					},
					"alert_all_too_young": "Kaikkien sopimuksen solmivien henkilöiden tulee olla vähintään {minAge}-vuotiaita. Jatka lisäämällä ja valitsemalla hakija, joka on vähintään {minAge}-vuotias.",
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin",
						"add_person": "+ Lisää henkilö"
					},
					"role": {
						"recollection": "Laillinen edustaja"
					}
				},
				"application_summary": {
					"title": "Tarkista ja lähetä hakemuksesi.",
					"subtitle": {
						"unmanaged": "Varmista, että hakemukseen annetut tiedot ovat oikein.",
						"managed": "Tarkastele tietoja ennen lähettämistä."
					},
					"stakeholders": {
						"title": "Yrityksen johto",
						"subtitle": "Osakas {index}"
					},
					"businessDetailsCard": {
						"title": "Yrityksen tiedot"
					},
					"businessDetailsCardFields": {
						"companyName": "Yrityksen nimi",
						"organizationEntityType": "Veroluokka",
						"organizationRegistrationAuthority": "Rekisteröintituomioistuin",
						"goodsCategory": "Tuotekategoria",
						"registrationId": {
							"default": "Y-tunnus",
							"AT": "Y-tunnus",
							"AU": "ACN",
							"CA": "Yritystunnus",
							"ES": "Yrityksen NIF/NIE/DNI",
							"GB": "Organisaatiotunnus",
							"GR": "G.E.MI.-numero (Γ.Ε.ΜΗ.)",
							"NZ": "Yritystunnus",
							"US": "Työnantajan tunnistenumero"
						},
						"registered": {
							"default": "Rekisteröity yritys",
							"AU": "Yrityksellä on ACN"
						},
						"subjectToVat": {
							"default": "Yritys on ALV-velvollinen",
							"AU": "Yritys on ABT-velvollinen"
						},
						"vatId": {
							"default": "ALV-tunnus",
							"AU": "ABN",
							"NZ": "GST-numero",
							"ES": "Yrityksen NIF/NIE/DNI"
						},
						"storeName": "Kaupan nimi",
						"storeName_us": "Brändin nimi / DBA",
						"website": "Verkkosivu",
						"email": "Asiakaspalvelun sähköpostiosoite",
						"entityType": "Yksikön tyyppi"
					},
					"companyRegistrationAddressCard": {
						"title": "Yrityksen rekisteröity osoite"
					},
					"companyAddressCard": {
						"title": "Yrityksen osoite"
					},
					"operatingAddressCard": {
						"title": "Yrityksen operatiivinen osoite"
					},
					"documentsCard": {
						"title": "Ladatut asiakirjat"
					},
					"buttons": {
						"edit": "Muokkaa",
						"back": "Takaisin",
						"submit": "Lähetä"
					},
					"noTermsAccepted": "Lue ja hyväksy ehdot",
					"noTermsAcceptedWithPricingAnnex": "Lue ja hyväksy Kauppiassopimus ja Hinnoitteluehdot"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Kuka johtaa yritystä?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Rahanpesun torjunnasta annetun EU:n lainsäädännön ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") mukaan meidän on kerättävä nämä tiedot."
							}
						],
						"US": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						],
						"CA": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						],
						"AU": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						]
					},
					"infobox": {
						"default": "Kirjoita yrityksen toimitusjohtajan henkilötiedot ja kotiosoite.",
						"US": "Kirjoita enemmistöosakkaan tai korkean tason liiketoiminnallisen johtajan, kuten toimitusjohtajan, talousjohtajan tai operatiivisen johtajan, henkilötiedot ja kotiosoite.",
						"CA": "Kirjoita enemmistöosakkaan tai korkean tason liiketoiminnallisen johtajan, kuten toimitusjohtajan, talousjohtajan tai operatiivisen johtajan, henkilötiedot ja kotiosoite."
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Onko tämä yritys julkinen yhtiö tai julkisen yhtiön yksityisomistuksessa oleva yhtiö?",
					"title_stakeholder": "Kuka johtaa yritystä?",
					"subtitle": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot.",
					"subtitle_stakeholder": "Kirjoita yrityksen toimitusjohtajan henkilötiedot ja kotiosoite.",
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"bank_account": {
					"title": {
						"default": "Mitkä ovat pankkitilitietosi?"
					},
					"subtitle": {
						"US": "Klarna-maksutapahtumat siirretään tälle pankkitilille.",
						"default": "Käytämme näitä pankkitilitietoja tilitykseen"
					},
					"no_more_bank_accounts": "Olet jo lisännyt pankkitilit kaikille tuetuille valuutoille. Hienoa!",
					"robot_message_general": "Oletuspankkitilin tulee olla rekisteröity samassa maassa kuin yritys. Sinulla tulee olla myös pankkitili kaikille niille valuutoille, mitä aiot hyväksyä.",
					"robot_message": "IBAN-tilinumero (International Bank Account Number) on kansainvälinen tilinumero. Tunnistat IBAN-tilinumeron numerosarjan alussa olevasta kaksikirjaimisesta maatunnuksesta. IBAN-tilinumeron pituus vaihtelee maittain, Suomessa se on aina 18 merkkiä pitkä ja alkaa maatunnuksella FI.",
					"robot_message_account_number": {
						"AU": "Tilinumeron tarjoaa pankkisi, ja se on 6–10 numeroa, esim. 12345678",
						"US": "Tilinumeron tarjoaa pankkisi, ja se on 5–17 numeroa, esim. 12345678",
						"GB": "Tilinumero on pankkisi myöntämä, ja siinä on 8 numeroa. Esim.: 12345678. Jotkin brittiläiset pankit tarjoavat lyhyempiä tilinumeroita (esim. 7 numeroa). Tässä tapauksessa lisää noll(i)a tilinumerosi alkuun niin, että tilinumero on kokonaisuudessaan 8 merkin pituinen."
					},
					"robot_message_revolut": "Antamasi IBAN ei pysty vastaanottamaan kotimaan GBP-maksuja. Sinun tulee ottaa yhteyttä pankkiisi ja pyytää tiedot, jotka tukevat kotimaan GBP-maksuja.",
					"robot_message_local": "Antamasi IBAN-numero on pankkisi paikallinen IBAN-numero, jota emme tue. Ota yhteyttä pankkiisi ja pyydä henkilökohtaista IBAN-numeroasi tai yhdistä Klarnaan jokin toinen tili.",
					"buttons": {
						"add_bank_account": "+ Lisää pankkitili",
						"skip": "Ohita (toistaiseksi)",
						"remove": "Poista",
						"submit": "Lähetä",
						"next": "Seuraava",
						"back": "Takaisin"
					},
					"fields": {
						"currency_code": {
							"label": "Valuutta",
							"disable_reason": {
								"account_in_merchant_currency_required": "Oletusvaluutta on {currency} yrityksesi rekisteröintimaan vuoksi."
							},
							"errors": {
								"general": "Valitse valuutta"
							}
						},
						"country_of_bankaccount": {
							"label": "Maa",
							"errors": {
								"general": "Valitse maa"
							}
						},
						"iban_account_number": {
							"label": "Tilinumero (IBAN)",
							"errors": {
								"general": "Kirjoita pankkitilinumero (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Käytä tätä tiliä määrittämättömien valuuttojen osalta",
							"tooltip": "Tilaukset, joiden valuuttaa ei ole lueteltu tällä sivulla, maksetaan tälle tilille. Pankkisi saattaa veloittaa lisämaksun joidenkin valuuttojen käsittelystä."
						},
						"local_account_number": {
							"label": {
								"default": "Tilinumero",
								"MX": "CLABE-numero"
							},
							"errors": {
								"general": {
									"default": "Kirjoita pankkitilinumero",
									"MX": "Kirjoita kelvollinen CLABE-numero"
								}
							}
						},
						"account_holder": {
							"label": "Tilinhaltijan nimi",
							"errors": {
								"general": "Kirjoita tilinhaltijan nimi (enintään 70 merkkiä.)."
							}
						},
						"transit_number": {
							"label": "Reititysnumero",
							"errors": {
								"general": "Kirjoita kelvollinen reititysnumero"
							}
						},
						"institution_number": {
							"label": "Instituutiotunnus",
							"errors": {
								"general": "Kirjoita kelvollinen instituutiotunnus"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Kirjoita kelvollinen BSB-koodi (pankin tunnus)"
								}
							},
							"tooltip": {
								"AU": "BSB-koodin tulee olla 6 numeroa, joiden välissä on -. Esim.: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Reititysnumero",
								"GB": "Lajittelukoodi"
							},
							"errors": {
								"general": {
									"default": "Kirjoita kelvollinen reititysnumero",
									"GB": "Kirjoita kelvollinen lajittelukoodi"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Kuka johtaa yritystä?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Rahanpesun torjunnasta annetun EU:n lainsäädännön ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") mukaan meidän on kerättävä nämä tiedot."
							}
						],
						"GB": [
							{
								"text": "Laki edellyttää meitä keräämään nämä tiedot. Varmistathan, että tietosi Companies Housessa on ajan tasalla."
							}
						]
					},
					"infobox": "Kirjoita yrityksesi johtoasemassa olevien henkilöiden, kuten toimitusjohtajan tai hallituksen jäsenten, henkilötiedot ja kotiosoite.",
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin",
						"add_person": "+ Lisää henkilö"
					},
					"messages": {
						"lookup": "Johtavatko nämä henkilöt yritystäsi? Tarkista ja vahvista, ovatko tiedot oikein."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Onko yrityksesi rekisteröity yritys?",
						"managed": "Onko tämä yritys rekisteröity yritys?"
					},
					"subtitle": {
						"unmanaged": "Tarvitsemme Y-tunnuksesi vahvistaaksemme liiketoimintasi tiedot",
						"managed": "Tarvitsemme yrityksen rekisterinumeron vahvistaaksemme yrityksen liiketoiminnan tiedot."
					},
					"question": {
						"title": {
							"unmanaged": "Kirjoita rekisterinumerosi ja rekisteröintituomioistuin",
							"managed": "Kirjoita rekisterinumero ja rekisteröintituomioistuin"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Rekisterinumero"
						},
						"registration_court": {
							"label": "Rekisteröintituomioistuin",
							"errors": {
								"general": {
									"unmanaged": "Valitse rekisteröintituomioistuimesi",
									"managed": "Valitse rekisterituomioistuin"
								}
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"documents": {
					"title": "Lataa asiakirjasi",
					"subtitle": "Henkilöllisyytesi vahvistamiseksi sinun on lähetettävä meille joitakin lisäasiakirjoja. Lataa vain <strong>JPG-</strong>, <strong>PNG-</strong> tai <strong>PDF-</strong>tiedostoja (tiedoston enimmäiskoko 10 Mt).",
					"subheadline": {
						"default": "Lataa lisäasiakirjoja henkilöllisyytesi vahvistamiseksi. Lataa vain <strong>JPG-, PNG- tai PDF</strong>-tiedostoja (tiedoston enimmäiskoko 10 MB).",
						"US": "Koska Klarna on pankki, jonka pääkonttori sijaitsee Ruotsissa, ja olemme siksi Ruotsin rahoitusvalvontaviranomaisen sääntelemä yhtiö, Klarnan tulee noudattaa EU-direktiiviä EU 2015/849. Klarnan tulee kerätä tietoa yritystä hallitsevista henkilöistä Klarnan palveluiden käytön aloittamiseksi. Annathan meille seuraavat asiakirjat henkilöllisyytesi vahvistamiseksi. Lataa vain JPG-, PNG- tai PDF-tiedostoja (tiedoston enimmäiskoko 10 Mt).",
						"IT": "Koska Klarna on pankki, jonka pääkonttori sijaitsee Ruotsissa, ja olemme siksi Ruotsin rahoitusvalvontaviranomaisen sääntelemä yhtiö, Klarnan tulee noudattaa EU-direktiiviä EU 2015/849. Klarnan tulee kerätä tietoa yritystä hallitsevista henkilöistä Klarnan palveluiden käytön aloittamiseksi. Huomaathan, että jatkaaksesi hakemista yrityksesi tulee olla rekisteröity kauppakamariin. Lataa vain JPG-, PNG- tai PDF-tiedostoja (tiedostojen enimmäiskoko 10 Mt)."
					},
					"header_title": "Asiakirjat",
					"stakeholder": "Osakkaat",
					"business_documents": "Kaupparekisteriote",
					"browse_files": "Selaa tiedostoja",
					"optional": "(valinnainen)",
					"upload_area": {
						"title": {
							"before_link": "Pudota tiedostot tänne tai",
							"link_text": "Valitse tiedostot"
						},
						"description": "{acceptedFileFormats} - Koko enintään {maxFileSizeMB} Mt/tiedosto"
					},
					"description": {
						"APPROVAL": "Lataa <strong>hyväksyntä</strong>",
						"CONTRACT": "Lataa <strong>sopimus</strong>",
						"CORRECTION_NOTE": "Lataa <strong>huomautus korjaamisesta</strong>",
						"COUNTERSIGNED_CONTRACT": "Lataa <strong>allekirjoitettu sopimus</strong>",
						"ID_DOCUMENT": "Lataa <strong>henkilökortti</strong> tai <strong>passi</strong>",
						"LICENSE": "Lataa <strong>lisenssi</strong>",
						"PROOF_OF_ADDRESS": "Lataa <strong>todiste osoitteesta</strong>",
						"SPECIAL_AGREEMENT": "Lataa <strong>erikoissopimus</strong>",
						"SUPPORTING_DOCUMENT": "Lataa <strong>lisäasiakirja</strong>",
						"TAX_OFFICE_REGISTRATION": "Lataa <strong>verohallinnon rekisteröinti</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Hyväksyntä"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Sopimus"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Huomautus korjaamisesta"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Allekirjoitettu sopimus"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Virallinen henkilöllisyystodistus",
								"IT": "Henkilökortti"
							},
							"subtitle": {
								"default": "Lataa kuvan henkilöllisyystodistuksen molemista puolista",
								"AT": "Näytäthän meille henkilökorttisi kummatkin puolet. Jos henkilökorttisi ei sisällä osoitettasi, tarvitsemme lisää asiakirjoja, kuten sähkölaskun, josta voimme vahvistaa osoitteesi.",
								"AU": "Hakemuksen käsittelyn nopeuttamiseksi annathan kopion voimassa olevasta kuvallisesta henkilöllisyystodistuksesta, kuten passista tai australialaisesta ajokortista. Tämä koskee yrityksen seuraavia toimihenkilöitä: Yksityisyrittäjä/kumppani – omistajat. Yhtiö – valtuutettu, kaikki johtajat ja mahdolliset osakkaat, joilla on osakkeista yli 25 %.",
								"BE": "Näytäthän henkilökortin kummatkin puolet. Varmista, että kuvanlaatu on riittävä ja että tiedot ovat selkeästi luettavissa.",
								"DE": "Näytäthän meille henkilökorttisi kummatkin puolet. Jos henkilökorttisi ei sisällä osoitettasi, tarvitsemme lisää asiakirjoja, kuten sähkölaskun, josta voimme vahvistaa osoitteesi.",
								"FR": "Näytäthän henkilökortin kummatkin puolet. Varmista, että kuvanlaatu on riittävä ja että tiedot ovat selkeästi luettavissa.",
								"GB": "Anna henkilöllisyystodistus, ja jos kyseessä on henkilökortti, kummatkin puolet.",
								"IT": "Jokaisen hakemuksessa mainitun henkilön voimassa oleva henkilökortti edestä/takaa. Ajokorttia, passia, kelakorttia/sosiaaliturvatunnusta ei voida hyväksyä.",
								"NL": "Näytäthän henkilökortin kummatkin puolet. Varmista, että kuvanlaatu on riittävä ja että tiedot ovat selkeästi luettavissa.",
								"US": "Ajokortti tai passi – Näytäthän henkilökortin kummatkin puolet."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Lisenssi"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Osoitetodistus",
								"BE": "Osoitetodistus",
								"CZ": "Osoitetodistus",
								"ES": "Osoitetodistus",
								"FI": "Osoitetodistus",
								"FR": "Osoitetodistus",
								"GR": "Osoitetodistus",
								"IT": "Osoitetodistus",
								"NL": "Osoitetodistus",
								"PL": "Osoitetodistus",
								"PT": "Osoitetodistus"
							},
							"subtitle": {
								"default": "Hyväksymme todisteeksi kotiosoitteesta seuraavat enintään kolme kuukautta vanhat asiakirjat: Sähkölasku, vesilasku, kaasulasku, internetlasku, veroilmoitus ja vuokrasopimus. Jos sinulla ei ole mitään näistä asiakirjoista, lataa mikä tahansa muu asiakirja todisteeksi kotiosoitteestasi ja lisää syy huomioihin.",
								"AU": "Hakemuksesi arvioinnin nopeuttamiseksi annathan kotiosoitteesi todistamiseksi jonkin seuraavista asiakirjoista viimeisten 90 päivän ajalta: Sähkölasku, internetlasku, veroilmoitus tai vuokrasopimus. *Jos annat henkilöllisyystodistukseksesi passin tai jos nykyinen osoitteesi ei vastaa henkilöllisyystodistuksessasi olevaa osoitetta, tämä vaihe on pakollinen.",
								"BE": "Hyväksymme todisteeksi kotiosoitteesta seuraavat enintään kolme kuukautta vanhat asiakirjat: Sähkölasku, vesilasku, kaasulasku, veroilmoitus ja vuokrasopimus. Jos sinulla ei ole mitään näistä asiakirjoista, lataa mikä tahansa muu asiakirja todisteeksi kotiosoitteestasi ja lisää syy huomioihin.",
								"FR": "Hyväksymme todisteeksi kotiosoitteesta seuraavat enintään kolme kuukautta vanhat asiakirjat: Sähkölasku, vesilasku, kaasulasku, veroilmoitus ja vuokrasopimus. Jos sinulla ei ole mitään näistä asiakirjoista, lataa mikä tahansa muu asiakirja todisteeksi kotiosoitteestasi ja lisää syy huomioihin.",
								"NL": "Hyväksymme todisteeksi kotiosoitteesta seuraavat enintään kolme kuukautta vanhat asiakirjat: Sähkölasku, vesilasku, kaasulasku, veroilmoitus ja vuokrasopimus. Jos sinulla ei ole mitään näistä asiakirjoista, lataa mikä tahansa muu asiakirja todisteeksi kotiosoitteestasi ja lisää syy huomioihin.",
								"US": "Hyväksymme sähkö-, kaasu-, vesi-, internet- ja puhelinlaskut, vuokrasopimuksen tai asuntolainan todisteeksi osoitteesta. Asiakirjan päiväyksen tulee olla hakemushetkellä enintään 90 päivää vanha.",
								"IT": "Jos henkilökortissasi on eri osoite kuin osoite, jossa parhaillaan asut, tarvitsemme ylimääräisen asiakirjan todisteeksi nykyisestä asuinpaikastasi. Hyväksymme seuraavat enintään kolme kuukautta vanhat asiakirjat hakemuksessa mainittujen henkilöiden kotiosoitteen todistamiseksi:"
							},
							"list": {
								"IT": [
									{
										"text": "Asuinpaikkatodistus, joka on myönnetty verkossa (SPID:n kautta) tai jonka kotikunta on myöntänyt"
									},
									{
										"text": "Sähkö-/vesi-/kaasu-/internetlaskut"
									},
									{
										"text": "Vuokrasopimus"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Erikoissopimus"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Lisäasiakirja",
								"GB": "Kuva itsestäsi"
							},
							"subtitle": {
								"default": null,
								"AU": "Jos myyt arvokkaita brändituotteita, annathan 2–3 laskua kyseisten tuotteiden toimittajilta tänne. Varmista, että lasku sisältää ostetut tuotteet, toimittajan nimen, vastaanottajan nimen ja toimitusosoitteen.",
								"GB": "Anna kuva itsestäsi näyttämässä henkilöllisyystodistusta."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "ALV-rekisteriote",
								"AT": "Rekisteröintitodistus verohallinnolta",
								"AU": "Perustamiskirja",
								"BE": "Rajat ylittävät maksutapahtumat salliva VAT-numero (VIES).",
								"DE": "Rekisteröintitodistus verohallinnolta",
								"FR": "Rajat ylittävät maksutapahtumat salliva VAT-numero (VIES).",
								"IT": "Rajat ylittävät maksutapahtumat salliva VAT-numero (VIES).",
								"NL": "Rajat ylittävät maksutapahtumat salliva VAT-numero (VIES).",
								"NO": "Verohallinnon rekisteröinti",
								"US": "EIN-kirje"
							},
							"subtitle": {
								"default": null,
								"AT": "Hyväksymme seuraavat asiakirjat yritysasiakirjoiksi: Kaupparekisteriote / yksityisyrittäjän todistus",
								"AU": "Jos ABN-numerosi liittyy säätiöön, annathan kopion säätiön omaisuusluettelon sisältävästä säätiöasiakirjasta. Huomaathan, että tämä vaihe on säätiöille pakollinen.",
								"BE": "Varmista, että VAT-numero sallii rajat ylittävät maksutapahtumat. Tämä on tarpeen, vaikka kävisitkin kauppaa ainoastaan kotimaassasi, sillä Klarna on ulkomainen yhtiö. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Voit ottaa yhteyttä oman maasi verovirastoon ja pyytää VAT-numerosi maksutonta VIES-aktivointia.",
								"CZ": "Hyväksymme seuraavat asiakirjat yritysasiakirjoiksi: Julkisen rekisterin liittymistodistus tai elinkeinoharjoittajan kaupparekisteriote.",
								"DE": "Hyväksymme seuraavat asiakirjat yritysasiakirjoiksi: Kaupparekisteriote / yksityisyrittäjän todistus",
								"ES": "Hyväksymme seuraavat asiakirjat yritysasiakirjoiksi: Rekisteröidyn yrityksen; yksityisyrittäjän yhtiöjärjestys - Selvitys yrityksen henkilöstömäärästä / Malli 036 / Malli 037",
								"FI": "Hyväksymme seuraavat asiakirjat yritysasiakirjoiksi: Yksityisyrittäjän yhtiöjärjestys - Selvitys yrityksen henkilöstömäärästä / Malli 036 / Malli 037",
								"FR": "Varmista, että VAT-numero sallii rajat ylittävät maksutapahtumat. Tämä on tarpeen, vaikka kävisit kauppaa ainoastaan kotimaassasi, sillä Klarna on ulkomainen yhtiö. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Voit ottaa yhteyttä oman maasi verovirastoon ja pyytää VAT-numerosi maksutonta VIES-aktivointia.",
								"GR": "Hyväksymme seuraavat asiakirjat yritysasiakirjoiksi: Verohallinnon rekisteröintitodistus / Todistus liiketoiminnan aloittamisesta / Yrityksen rekisteröintiasiakirja, jonka on myöntänyt Competent Service GEMI (Keskuskauppakamari)",
								"IT": "Voit ottaa yhteyttä verohallitukseen (Agenzia delle Entrate) ja pyytää VAT-numerosi ilmaista VIES-aktivointia. Tämä on tarpeen, vaikka kävisitkin kauppaa ainoastaan Italiassa, sillä Klarna on ulkomainen yhtiö.",
								"NL": "Varmista, että VAT-numero sallii rajat ylittävät maksutapahtumat. Tämä on tarpeen, vaikka kävisit kauppaa ainoastaan kotimaassasi, sillä Klarna on ulkomainen yhtiö. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Voit ottaa yhteyttä oman maasi verovirastoon ja pyytää VAT-numerosi maksutonta VIES-aktivointia.",
								"NO": "Hyväksymme seuraavat asiakirjat yritysasiakirjoiksi: Yrityksen asiakirjat",
								"PL": "Hyväksymme seuraavat asiakirjat yritysasiakirjoiksi: CEIDG-yritysrekisterin liittymistodistus, kansallinen kaupparekisteriote (KRS)",
								"PT": "Hyväksymme seuraavat asiakirjat yritysasiakirjoiksi:  Certidão Permanente (pakollinen), perustamisasiakirja. Yksityisyrittäjiltä itsenäisen ammatinharjoittajan rekisteröintiasiakirja (Declaração de Início de Atividade).",
								"US": "Tämä on kirje, jonka olet saanut verohallinnolta ja jossa sinulle on määritetty EIN-numero (ERS CP575 EIN-kirje). Jos olet yksityisyrittäjä ja täytät hakemusta omalla sosiaaliturvatunnuksellasi, annathan kopion tässä kohtaa sen sijaan henkilökortistasi."
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Hyväksytty tunnistusasiakirja"
							},
							"subtitle": {
								"default": "Hyväksymme seuraavat asiakirjat: Henkilökortti, passi, ajokortti. Asiakirjojen on täytettävä seuraavat kriteerit:"
							},
							"list": [
								{
									"text": "Toimivaltaisen viranomaisen myöntämä (esim. notaarin, asianajajan, juristin ja/tai auktorisoidun tilintarkastajan)."
								},
								{
									"text": "Allekirjoitettu ja leimattu. Leiman tulee olla näkyvissä ja siinä tulee näkyä todistuksen antajan tiedot, kuten nimi, osoite ja rekisteröintinumero (mikäli soveltuu)."
								},
								{
									"text": "Päivätty – todistus ei saa olla kuutta kuukautta vanhempi."
								},
								{
									"text": "Oikeaksi todistettu kopio alkuperäisestä asiakirjasta; selkeä merkintä alkuperäisasiakirjan näkemisestä."
								}
							]
						}
					},
					"modal": {
						"title": "Miksi tarvitsemme asiakirjojasi?",
						"close": "Sulje",
						"content": [
							{
								"title": "Prosessin kuvaus",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Tiedostovaatimukset",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Miten asiakirjat skannataan?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Lataus epäonnistui",
						"too_large_file": "Tiedosto on liian suuri <strong>(enint. {maxFileSizeMB} Mt)</strong>",
						"max_num_files_exceeded": "Voit ladata enintään {number} tiedostoa.",
						"invalid_file_format": "Tiedostomuoto on virheellinen. Vain {acceptedFileFormats}-tiedostot kelpaavat.",
						"duplicate_file_name": "Tämän niminen tiedosto on jo olemassa. Kaikilla ladatuilla tiedostoilla tulee olla yksilöllinen nimi.",
						"try_again": "Yritä uudelleen tai <u>valitse toinen tiedosto</u>"
					},
					"buttons": {
						"modal": "Miksi tarvitsemme asiakirjojasi?",
						"next": "Seuraava",
						"back": "Takaisin",
						"submit": "Lähetä asiakirjat"
					}
				},
				"document_upload_success": {
					"title": "Lataus valmis.",
					"message": "Kiitos! Asiakirjojesi lataus onnistui."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Saisimmeko Y-tunnuksesi?",
							"AT": "Saisimmeko Y-tunnuksesi?",
							"CA": "Kirjoittaisitko liittovaltion BN-numerosi?",
							"GR": "Kirjoittaisitko G.E.MI.-numerosi (Γ.Ε.ΜΗ.)?",
							"NZ": "Kirjoittaisitko yritystunnuksesi?"
						},
						"managed": {
							"default": "Kirjoittaisitko yrityksen rekisterinumeron?",
							"AT": "Kirjoittaisitko yrityksen rekisterinumeron?",
							"CA": "Kirjoittaisitko liittovaltion BN-numerosi?",
							"GR": "Kirjoittaisitko yrityksen G.E.MI.-numeron (Γ.Ε.ΜΗ.)?",
							"NZ": "Kirjoittaisitko yrityksen yritystunnuksen?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Tarvitsemme Y-tunnuksesi vahvistaaksemme liiketoimintasi tiedot",
							"AT": "Tarvitsemme Y-tunnuksesi vahvistaaksemme liiketoimintasi tiedot",
							"CA": "Tarvitsemme CRA:n (Canada Revenue Agency) yrityksellesi myöntämän liittovaltion yritystunnuksen yrityksesi tietojen vahvistamiseksi.",
							"GR": "Tarvitsemme G.E.MI.-numerosi liiketoiminnan tietojen vahvistamiseen.",
							"NZ": "Tarvitsemme yritystunnuksesi vahvistaaksemme liiketoimintasi tiedot."
						},
						"managed": {
							"default": "Tarvitsemme yrityksen rekisterinumeron vahvistaaksemme yrityksen tiedot.",
							"AT": "Tarvitsemme yrityksen rekisterinumeron vahvistaaksemme yrityksen tiedot.",
							"CA": "Tarvitsemme CRA:n (Canada Revenue Agency) yrityksellesi myöntämän liittovaltion yritystunnuksen yrityksesi tietojen vahvistamiseksi.",
							"GR": "Tarvitsemme G.E.MI.-numeron liiketoiminnan tietojen vahvistamiseen.",
							"NZ": "Tarvitsemme yrityksen yritystunnuksen vahvistaaksemme yrityksen tiedot."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Huomaa, ettei Klarna pysty tällä hetkellä tarjoamaan maksupalveluitaan yksityisille kanadalaisille elinkeinonharjoittajille. Hakemuksen seuraavaan vaiheeseen siirtyminen johtaa hakemuksen hylkäämiseen."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Rekisterinumero",
								"AT": "Rekisterinumero",
								"CA": "Yritystunnus",
								"GR": "G.E.MI.-numero (Γ.Ε.ΜΗ.)",
								"NZ": "Yritystunnus"
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Mikä on veroluokkasi?",
						"managed": "Kirjoittaisitko yrityksen veroluokituksen?"
					},
					"subtitle": {
						"unmanaged": "Kysymme sinulta erilaisia tietoja yrityksen oikeudellisesta asemasta riippuen.",
						"managed": "Kysymme sinulta erilaisia tietoja yrityksen oikeudellisesta asemasta riippuen."
					},
					"info": {
						"unmanaged": "Löydät yrityksesi EIN-numeron (työnantajan tunnistenumero) veroilmoituksista, luottoraporteista, palkkakuiteista, lisensseistä ja luvista",
						"managed": "Löydät yrityksen EIN-numeron (työnantajan tunnistenumero) veroilmoituksista, luottoraporteista, palkkakuiteista, lisensseistä ja luvista"
					},
					"fields": {
						"registration_number": {
							"label": "Työnantajan tunnistenumero",
							"errors": {
								"general": "Kirjoita kelvollinen työnantajan tunnistenumero",
								"invalid": "Työnantajan tunnistenumeron tulee olla 9-numeroinen, ja kahden ensimmäisen jälkeen tulee\"-\". Esim. 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Liittovaltion veroluokitus",
								"managed": "Liiketoiminnan tyyppi"
							},
							"errors": {
								"is_one_of": "Valitse yksi luetteloiduista liiketoiminnan tyypeistä"
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Kirjoittaisitko ALV-tunnuksesi?",
							"AU": "Kirjoittaisitko ABN-numerosi?",
							"ES": "Mikä on verotustunnuksesi?",
							"NZ": "Kirjoittaisitko GST-numerosi?"
						},
						"managed": {
							"default": "Kirjoittaisitko ALV-tunnuksen?",
							"AU": "Kirjoittaisitko ABN-numeron?",
							"ES": "Mikä on verotustunnuksesi?",
							"NZ": "Kirjoittaisitko GST-tunnuksen?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "ALV-tunnuksesi avulla pystymme vahvistamaan yritystietosi helpommin.",
							"AU": "ABN-numerosi avulla pystymme vahvistamaan yritystietosi helpommin.",
							"NZ": "GST-numerosi avulla pystymme vahvistamaan yritystietosi helpommin.",
							"ES": "NIF-, NIE- tai DNI-numerosi avulla pystymme vahvistamaan yritystietosi helpommin."
						},
						"managed": {
							"default": "Käytämme ALV-tunnusta yrityksesi tietojen vahvistamiseen.",
							"AU": "Käytämme ABN-numeroa yrityksesi tietojen vahvistamiseen.",
							"NZ": "Käytämme GST-numeroa yrityksen tietojen vahvistamiseen.",
							"ES": "Käytämme NIF-, NIE- tai DNI-numeroa yrityksesi tietojen vahvistamiseen."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "ALV-tunnus",
								"AU": "ABN",
								"NZ": "GST-numero",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Minkä tyyppistä liiketoimintasi on?",
						"managed": "Minkä tyyppistä liiketoimintaa tällä yrityksellä on?"
					},
					"subtitle": {
						"unmanaged": "Meitä edellytetään kysymään tiettyjä kysymyksiä liiketoimintatyyppisi perusteella.",
						"managed": "Meitä edellytetään kysymään tiettyjä kysymyksiä liiketoimintatyypin perusteella."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Oikeussubjektityyppi",
							"errors": {
								"is_one_of": "Valitse yksi luetteloiduista liiketoiminnan tyypeistä"
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Onko yrityksesi rekisteröity yritys?",
							"AU": "Onko yritykselläsi ACN-numero?",
							"ES": "Onko yrityksesi rekisteröity Registro Mercantil -rekisteriin?"
						},
						"managed": {
							"default": "Onko tämä yritys rekisteröity yritys?",
							"AU": "Onko tällä yrityksellä ACN-numero?",
							"ES": "Onko yrityksesi rekisteröity Registro Mercantil -rekisteriin?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Tarvitsemme Y-tunnuksesi vahvistaaksemme liiketoimintasi tiedot",
							"AT": "Tarvitsemme Y-tunnuksesi vahvistaaksemme liiketoimintasi tiedot",
							"AU": "Mikäli sinulla on ACN-numero, kirjoitathan sen. Muussa tapauksessa valitse ei ja etene seuraavaan vaiheeseen.",
							"ES": "Vastaa Kyllä, jos olet SL, SA, SCP jne. Vastaa Ei, jos olet autónomo, freelancer jne.",
							"GB": "Tarvitsemme yrityksesi organisaatiotunnuksen vahvistaaksemme liiketoimintasi tiedot.",
							"GR": "Tarvitsemme G.E.MI.-numerosi liiketoiminnan tietojen vahvistamiseen."
						},
						"managed": {
							"default": "Tarvitsemme yrityksen rekisterinumeron vahvistaaksemme yrityksen liiketoiminnan tiedot.",
							"AT": "Tarvitsemme yrityksen rekisterinumeron vahvistaaksemme yrityksen liiketoiminnan tiedot.",
							"AU": "Mikäli tällä yrityksellä on ACN-numero, kirjoitathan sen. Muussa tapauksessa valitse ei ja etene seuraavaan vaiheeseen.",
							"ES": "Vastaa Kyllä, jos olet SL, SA, SCP jne. Vastaa Ei, jos olet autónomo, freelancer jne.",
							"GB": "Tarvitsemme yrityksen organisaatiotunnuksen vahvistaaksemme yrityksen liiketoiminnan tiedot.",
							"GR": "Tarvitsemme yrityksen G.E.MI.-numeron liiketoiminnan tietojen vahvistamiseen."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Kirjoita rekisterinumerosi",
							"AT": "Kirjoita rekisterinumerosi",
							"AU": "Kirjoita ACN",
							"ES": "Kirjoita yrityksesi NIF-/NIE-/DNI-numero",
							"GB": "Kirjoita organisaatiotunnus",
							"GR": "Kirjoita G.E.MI.-numerosi (Γ.Ε.ΜΗ.)."
						},
						"managed": {
							"default": "Kirjoita rekisterinumero",
							"AT": "Kirjoita rekisterinumero",
							"AU": "Kirjoita ACN",
							"ES": "Kirjoita yrityksesi NIF-/NIE-/DNI-numero",
							"GB": "Kirjoita organisaatiotunnus",
							"GR": "Kirjoita G.E.MI.-numero (Γ.Ε.ΜΗ.)."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Rekisterinumero",
								"AT": "Rekisterinumero",
								"AU": "Australian Company Number (ACN)",
								"ES": "Yrityksen NIF/NIE/DNI",
								"GB": "Organisaatiotunnus",
								"GR": "G.E.MI.-numero (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"mid-selector": {
					"title": "Valitse kauppa",
					"subtitle": "Tämä sähköposti liittyy useaan kauppaan. Jatka valitsemalla kauppa.",
					"mid-selector": "Kauppiastunnus / Kaupan nimi",
					"buttons": {
						"next": "Jatka"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Onko yrityksesi rekisteröity yritys?",
						"managed": "Onko tämä yritys rekisteröity yritys?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Tarvitsemme Y-tunnuksesi vahvistaaksemme liiketoimintasi tiedot",
							"AT": "Tarvitsemme Y-tunnuksesi vahvistaaksemme liiketoimintasi tiedot"
						},
						"managed": {
							"default": "Tarvitsemme yrityksen rekisterinumeron vahvistaaksemme yrityksen liiketoiminnan tiedot.",
							"AT": "Tarvitsemme yrityksen rekisterinumeron vahvistaaksemme yrityksen liiketoiminnan tiedot."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Kirjoita rekisterinumerosi",
							"AT": "Kirjoita rekisterinumerosi"
						},
						"managed": {
							"default": "Kirjoita rekisterinumero",
							"AT": "Kirjoita rekisterinumero"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Rekisterinumero",
								"AT": "Rekisterinumero"
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Onko yrityksesi rekisteröity ALV-rekisteriin?",
							"ES": "Onko yritykselläsi NIF-/NIE-/DNI-numeroa?",
							"NZ": "Onko yrityksesi rekisteröity GST-rekisteriin?"
						},
						"managed": {
							"default": "Onko tämä yritys rekisteröity ALV-rekisteriin?",
							"ES": "Onko yritykselläsi NIF-/NIE-/DNI-numeroa?",
							"NZ": "Onko tämä yritys rekisteröity GST-rekisteriin?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Mikäli sinulla on ALV-tunnus, pystymme vahvistamaan yritystietosi helpommin.",
							"ES": "Mikäli yritykselläsi on NIF-/NIE-/DNI-numero, pystymme vahvistamaan yritystietosi helpommin.",
							"NZ": "Mikäli sinulla on GST-tunnus, pystymme helpommin vahvistamaan yritystietosi."
						},
						"managed": {
							"default": "Käytämme ALV-tunnusta yrityksesi tietojen vahvistamiseen.",
							"ES": "Mikäli yritykselläsi on NIF-/NIE-/DNI-numero, pystymme vahvistamaan yritystietosi helpommin.",
							"NZ": "Käytämme GST-tunnusta yrityksesi tietojen vahvistamiseen."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Kirjoita ALV-tunnuksesi",
							"ES": "Kirjoita yrityksesi NIF-/NIE-/DNI-numero",
							"NZ": "Kirjoita GST-tunnuksesi"
						},
						"managed": {
							"default": "Kirjoita ALV-tunnus",
							"ES": "Kirjoita yrityksesi NIF-/NIE-/DNI-numero",
							"NZ": "Kirjoita GST-tunnuksesi"
						}
					},
					"vat_id": {
						"label": {
							"default": "ALV-tunnus",
							"ES": "Yrityksen NIF/NIE/DNI",
							"NZ": "GST-tunnus"
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Onko yrityksesi rekisteröity ALV-rekisteriin?",
						"managed": "Onko tämä yritys rekisteröity ALV-rekisteriin?"
					},
					"subtitle": {
						"unmanaged": "Mikäli sinulla on ALV-tunnus, pystymme vahvistamaan yritystietosi helpommin.",
						"managed": "Käytämme ALV-tunnusta yrityksesi tietojen vahvistamiseen."
					},
					"form_title": {
						"unmanaged": "Kirjoita ALV-tunnuksesi",
						"managed": "Kirjoita ALV-tunnus"
					},
					"vat_id": {
						"label": {
							"default": "ALV-tunnus",
							"NZ": "GST-tunnus"
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Mikä on yrityksesi osoite?",
						"managed": "Mikä on yrityksesi liiketoiminnallinen osoite?"
					},
					"subtitle": {
						"unmanaged": "Meidän tulee tietää, missä yrityksesi sijaitsee.",
						"managed": "Meidän tulee tietää, missä yritys sijaitsee."
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					},
					"fields": {
						"partnership_name": {
							"label": "Yhteistyökumppanin nimi",
							"errors": {
								"general": "Kirjoita yhteistyökumppanin nimi"
							}
						},
						"street": {
							"label": "Osoite",
							"errors": {
								"general": "Kirjoita kelvollinen osoite"
							}
						},
						"postal_code": {
							"label": "Postinumero",
							"errors": {
								"general": "Kirjoita kelvollinen postinumero"
							}
						},
						"city": {
							"label": "Kaupunki",
							"errors": {
								"general": "Kirjoita kelvollinen kaupunki"
							}
						},
						"country": {
							"label": "Maa",
							"errors": {
								"general": "Kirjoita kelvollinen maa"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Kuka tämän yrityksen omistaa?",
						"GB": "Kuka johtaa yritystä?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Rahanpesun torjunnasta annetun EU:n lainsäädännön ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") mukaan meidän on kerättävä nämä tiedot."
							}
						],
						"AU": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						]
					},
					"infobox": "Kirjoita kaikkien yrityksesi johtoasemassa olevien kumppaneiden ja valtuuttajien henkilötiedot ja kotiosoite.",
					"buttons": {
						"add_person": "+ Lisää henkilö",
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"payouts_summary": {
					"title": "Pankkitilit",
					"default_bank_accounts": {
						"no_elements": "Oletuspankkitiliä ei ole saatavilla"
					},
					"additional_bank_accounts": {
						"no_elements": "Et ole lähettänyt yhtään ylimääräistä pankkitiliä"
					}
				},
				"pre_assessment_company_details": {
					"title": "Täytä lisää vaihtoehtoon liittyviä tietoja.",
					"subtitle": "Anna meille tiedot korttiosuuden määrästä ja kyseisen kauppiaan yritystiedot. Ilmoita myös, toimiiko yritys joltakin muulta markkina-alueelta käsin kuin rekisteröintimaasta, sillä tätä tietoa vaaditaan riskien arvioinnissa.",
					"fields": {
						"volume_by_card": {
							"label": "Korttiosuuden määrä kokonaismäärästä (%)",
							"errors": {
								"invalid": "Korttiosuuden määrän tulee olla jokin luku välillä 0 ja 100",
								"invalid_hint": "Lisää korttimaksutapahtumien määrän osuus Klarnan kokonaismäärästä tämän vaihtoehdon osalta. Kirjoita 0 %, mikäli tässä vaihtoehdossa ei ole korttimaksuja."
							}
						},
						"average_order_value": {
							"label": "Tilauksen keskimääräinen arvo (valuutassa SEK)",
							"tooltip": "Tämä tulee olla positiivinen summa valuutassa SEK",
							"errors": {
								"invalid": "Tämä tulee olla positiivinen summa valuutassa SEK"
							}
						},
						"registration_country": {
							"label": "Rekisteröintimaa",
							"errors": {
								"required": "Rekisteröintimaa on pakollinen"
							}
						},
						"operating_country": {
							"label": "Toimintamaa",
							"errors": {
								"required": "Toimintamaa on pakollinen"
							}
						},
						"registration_number": {
							"label": {
								"default": "Rekisteröintinumero (vaaditaan rekisteröidyiltä yrityksiltä)",
								"AU": "ACN (vaaditaan rekisteröidyiltä yrityksiltä)",
								"ES": "Yrityksen NIF/NIE/DNI (vaaditaan rekisteröidyiltä yrityksiltä)",
								"GR": "G.E.MI.-numero (Γ.Ε.ΜΗ.) (vaaditaan rekisteröidyiltä yrityksiltä)",
								"NZ": "Yritystunnus (vaaditaan rekisteröidyiltä yrityksiltä)",
								"US": "TIN/EIN (vaaditaan rekisteröidyiltä yrityksiltä)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Anna ACN tai ABN",
								"invalid": "ABN-numeron tulee olla 11-numeroinen"
							}
						},
						"registration_authority": {
							"label": "Rekisteröintiviranomainen",
							"errors": {
								"required": "Valitse rekisteröintiviranomainen"
							}
						},
						"company_name": {
							"label": "Oikeussubjektin nimi",
							"errors": {
								"required": "Oikeussubjektin nimi on pakollinen"
							}
						},
						"sales_contact": {
							"label": "Myyntiedustajan sähköpostiosoite",
							"errors": {
								"invalid": "Kirjoita kelvollinen sähköposti"
							}
						},
						"store_url": {
							"label": "Kaupan URL",
							"errors": {
								"required": "Kaupan URL on pakollinen",
								"invalid": "Kirjoita kelvollinen verkkosivun osoite"
							}
						},
						"goods_category": {
							"label": "Myytävän tavaran pääluokka",
							"errors": {
								"invalid": "Sinun tulee valita yksi vaihtoehdoista"
							}
						},
						"is_managed": {
							"label": "Kauppias valmis online-tilaan?"
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"pre_assessment_products": {
					"title": "Luetteloi kaikki tuotteet",
					"subtitle": "Riskien arviointiin vaaditaan kaikki tuotteet myyntimaittain",
					"select": {
						"label": "Hae tuotetta"
					},
					"selected": {
						"label": "Valitut tuotteet:"
					},
					"clear": "Tyhjennä kaikki",
					"errors": {
						"invalid": "Vähintään yksi tuote maata kohden vaaditaan"
					},
					"channels": {
						"ONLINE": "Verkko",
						"IN_STORE": "Kaupassa",
						"TELESALES": "Puhelinmyynti",
						"SELLER_APP": "Myyjäsovellus"
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"wrong_prefill_data": {
					"title": "Annettu virheellisiä tietoja",
					"subtitle": "SalesForce on antanut virheellisiä tai yhteensopimattomia esitäyttötietoja.",
					"details": "Tiedot: ",
					"fields": {
						"goodsCategory": "Tuotekategoria",
						"paymentInterval": "Maksuväli",
						"paymentDelay": "Maksuviive",
						"registrationCountry": "Rekisteröintimaa",
						"storeUrl": "Kaupan URL",
						"mainSellingCountry": "Pääasiallinen myyntimaa",
						"products": "Tuotteet",
						"products_item": "Tuote {index}",
						"products_item_yearlyAcquiredVolume": "Tuote {index} vuotuinen hankintamäärä",
						"products_item_sellingCountry": "Tuote {index} myyntimaa",
						"products_item_productName": "Tuote {index} nimi",
						"products_item_channels": "Tuote {index} kanavat",
						"products_item_channels_item": "Tuote {index} kanava"
					},
					"error_types": {
						"fallback": "on virheellinen",
						"any": {
							"required": "on pakollinen, eikä yhtään ole annettu"
						}
					}
				},
				"selling_countries": {
					"title": "Ilmoita kaikki myyntimaat",
					"subtitle": "Riskien arviointiin vaaditaan täydellinen maaluettelo",
					"select": {
						"label": "Hae maata"
					},
					"selected": {
						"label": "Valitut maat:"
					},
					"fields": {
						"selling_countries": {
							"label": "Valitse maa",
							"errors": {
								"invalid": "Sinun tulee valita vähintään yksi maa"
							}
						}
					},
					"clear": "Tyhjennä kaikki",
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"main_selling_country": {
					"title": "Mikä on kauppiaan pääasiallinen Klarna-markkina-alue?",
					"subtitle": "Valitse markkina-alue, jolla on suurin odotettu Klarna-volyymi",
					"errors": {
						"invalid": "Sinun tulee valita maa"
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"fca_number": {
					"title": "Kirjoita FCA-numero",
					"subtitle": "Laki edellyttää meitä vahvistamaan luotonantajan lisenssin.",
					"fields": {
						"fca_number": {
							"label": "FCA-numero",
							"errors": {
								"general": "Kirjoita kelvollinen FCA-numero"
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"sole_trader": {
					"title": "Kuka tämän yrityksen omistaa?",
					"subtitle": {
						"default": [
							{
								"text": "Rahanpesun torjunnasta annetun EU:n lainsäädännön ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") mukaan meidän on kerättävä nämä tiedot."
							}
						]
					},
					"infobox": {
						"unmanaged": "Kirjoita omat henkilötietosi ja kotiosoitteesi.",
						"managed": "Kirjoita omistajan tiedot ja kotiosoite."
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "Hakemuksen tekijä on sama henkilö kuin yksityisyrittäjä",
							"error": "Pahoittelut, voit edetä vain, jos olet yksityisyrittäjä, joka tekee tämän hakemuksen."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Toimitko toisesta osoitteesta käsin?",
								"managed": "Toimiiko tämä yritys toisesta osoitteesta käsin?"
							},
							"subtitle": {
								"unmanaged": "Valitse Kyllä, jos hoidat liiketoimintaa muusta osoitteesta kuin kotiosoitteestasi.",
								"managed": "Valitse Kyllä, jos tämän yrityksen liiketoimintaa hoidetaan muusta osoitteesta kuin yksityisyrittäjän kotiosoitteesta."
							}
						},
						"title": "Anna yrityksen osoite",
						"fields": {
							"street": {
								"label": "Osoite",
								"errors": {
									"general": "Anna kelvollinen osoite"
								}
							},
							"postal_code": {
								"label": "Postinumero",
								"errors": {
									"general": "Anna kelvollinen postinumero"
								}
							},
							"city": {
								"label": "Kaupunki",
								"errors": {
									"general": "Anna kelvollinen kaupunki"
								}
							},
							"country": {
								"label": "Maa",
								"errors": {
									"general": "Anna kelvollinen maa"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Vahvistaisitko vielä kaksi asiaa?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "OIet yksityisyrittäjä",
							"label": "Hakemuksen tekijä on sama henkilö kuin yksityisyrittäjä"
						},
						"are_you_the_only_with_financial_control": {
							"title": "Sinä hallitset yrityksen talousasioita",
							"label": "Omistaja on ainut henkilö, joka hallitsee yrityksesi pankkitilin/-tilien talousasioita."
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					},
					"robot_message": "Pahoittelut, mutta meidän tulee vahvistaa nämä kaksi asiaa"
				},
				"underwriting_info": {
					"title": "Ilmoita vaihtoehdon volyymi ja maksuviive",
					"subtitle": "Luetteloi odotettu vuotuinen Klarna-volyymi kokonaisuudessaan tämän vaihtoehdon osalta koskien kaikkia markkina-alueita sekä maksuviive. Mikäli maa vaikuttaa maksuviiveeseen, käytä valitun pääasiallisen myyntimaan maksuviivettä.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Vuotuinen markkinavolyymi yhteensä (SEK)",
							"errors": {
								"invalid": "Vuotuisen markkinavolyymin tulee olla positiivinen luku valuutassa SEK",
								"too_long": "Vuotuinen markkinavolyymi ei voi ylittää 16 numeroa"
							}
						},
						"payment_delay": {
							"label": "Maksuviive",
							"errors": {
								"general": "Anna maksuviiveen arvo",
								"invalid": "Maksuviiveen tulee olla jokin luku välillä {min} ja {max}"
							}
						},
						"payment_interval": {
							"label": "Maksuväli",
							"errors": {
								"invalid": "Sinun tulee valita yksi vaihtoehdoista"
							}
						},
						"volume_by_card": {
							"label": "Kassaosuus (%)",
							"errors": {
								"invalid": "Kassaosuuden tulee olla jokin luku välillä 0 ja 100",
								"invalid_hint": "Lisää korttimaksutapahtumien määrän osuus Klarnan kokonaismäärästä tämän vaihtoehdon osalta. Kirjoita 0 %, mikäli tässä vaihtoehdossa ei ole korttimaksuja."
							}
						},
						"average_order_value": {
							"label": "Tilauksen keskimääräinen arvo (valuutassa SEK)"
						}
					},
					"buttons": {
						"back": "Takaisin",
						"next": "Seuraava"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Mitkä ovat kauppasi tiedot?"
						},
						"managed": "Mitkä ovat kaupan tiedot?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Käytämme näitä tietoja yritystilin perustamiseksi.",
							"default": "Käytämme antamiasi tietoja ensisijaisina yhteystietoinasi ja tarkastellaksemme hieman kauppaasi."
						},
						"managed": "Käytämme antamiasi tietoja ensisijaisina kuluttajien yhteystietoina ja tarkastellaksemme hieman kauppaa."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Brändin nimi / DBA",
								"MX": "Brändin nimi / DBA",
								"US": "Brändin nimi / DBA",
								"default": "Kaupan nimi"
							},
							"errors": {
								"required": "Kaupan nimi on pakollinen",
								"required_us": "Brändin nimi / DBA on pakollinen",
								"invalid": "Kirjoita kaupan nimi, joka on vähintään 2 merkkiä",
								"invalid_us": "Kirjoita brändin nimi / DBA, joka on vähintään 2 merkkiä",
								"invalid_characters": "Kaupan nimessä ei voi olla seuraavia merkkejä: < >",
								"invalid_characters_us": "Brändin nimessä / DBA:ssa ei voi olla seuraavia merkkejä: < >"
							}
						},
						"website": {
							"label": "Verkkokaupan verkkosivu",
							"errors": {
								"required": "Verkkosivu on pakollinen",
								"invalid": "Kirjoita kelvollinen verkkosivun osoite"
							}
						},
						"goods_category": {
							"label": "Myytävän tavaran pääluokka",
							"errors": {
								"required": "Tavaraluokka on pakollinen"
							}
						},
						"email": {
							"label": "Asiakaspalvelun sähköpostiosoite",
							"errors": {
								"required": "Asiakastuen sähköposti on pakollinen",
								"invalid": "Kirjoita kelvollinen sähköposti"
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Vaihda tuotteita"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Mikä on yrityksesi rekisteröity osoite?",
						"managed": "Mikä on yrityksen liiketoiminnan rekisteröity osoite?"
					},
					"subtitle": {
						"unmanaged": "Meidän tulee tietää, mihin osoitteeseen yrityksesi on rekisteröity.",
						"managed": "Meidän tulee tietää, mihin osoitteeseen yritys on rekisteröity."
					},
					"question": {
						"title": {
							"unmanaged": "Toimitko toisesta osoitteesta käsin?",
							"managed": "Toimiiko tämä yritys toisesta osoitteesta käsin?"
						},
						"subtitle": {
							"unmanaged": "Valitse Kyllä, jos hoidat liiketoimintaa muusta osoitteesta kuin liiketoiminnan rekisteröidystä osoitteesta.",
							"managed": "Valitse Kyllä, jos tämän yrityksen liiketoimintaa hoidetaan muusta osoitteesta kuin liiketoiminnan rekisteröidystä osoitteesta."
						}
					},
					"toggle": {
						"title": "Lisää yrityksen vakituisen toimipaikan osoite"
					},
					"fields": {
						"company_name": {
							"label": "Yrityksen virallinen nimi",
							"errors": {
								"general": "Anna yrityksen nimi"
							}
						},
						"street": {
							"label": "Osoite",
							"errors": {
								"general": "Anna osoite"
							}
						},
						"postal_code": {
							"label": "Postinumero",
							"errors": {
								"general": "Anna postinumero"
							}
						},
						"city": {
							"label": "Kaupunki",
							"errors": {
								"general": "Anna kaupunki"
							}
						},
						"country": {
							"label": "Maa",
							"errors": {
								"general": "Anna maa"
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					},
					"messages": {
						"lookup": "Onko tämän sinun yrityksesi? Tarkista ja vahvista, ovatko tiedot oikein."
					}
				},
				"uk_sole_trader": {
					"title": "Kuka tämän yrityksen omistaa?",
					"subtitle": {
						"unmanaged": "Olet aikeissa solmia sopimuksen Klarnan kanssa. Näin ollen tarvitsemme henkilötietosi.",
						"managed": "Meidän tulee kerätä ja vahvistaa omistajan henkilötiedot."
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Toimitko toisesta osoitteesta käsin?",
								"managed": "Toimiiko tämä yritys toisesta osoitteesta käsin?"
							},
							"subtitle": {
								"unmanaged": "Valitse Kyllä, jos hoidat liiketoimintaa muusta osoitteesta kuin kotiosoitteestasi.",
								"managed": "Valitse Kyllä, jos tämän yrityksen liiketoimintaa hoidetaan muusta osoitteesta kuin yksityisyrittäjän kotiosoitteesta."
							}
						},
						"title": "Anna yrityksen osoite",
						"fields": {
							"street": {
								"label": "Osoite",
								"errors": {
									"general": "Anna kelvollinen osoite"
								}
							},
							"postal_code": {
								"label": "Postinumero",
								"errors": {
									"general": "Anna kelvollinen postinumero"
								}
							},
							"city": {
								"label": "Kaupunki",
								"errors": {
									"general": "Anna kelvollinen kaupunki"
								}
							},
							"country": {
								"label": "Maa",
								"errors": {
									"general": "Anna kelvollinen maa"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Kuka tämän yrityksen omistaa?",
					"subtitle": {
						"default": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
					},
					"infobox": {
						"unmanaged": "Kirjoita omat henkilötietosi ja kotiosoitteesi.",
						"managed": "Kirjoita omistajan tiedot ja kotiosoite."
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Toimitko toisesta osoitteesta käsin?",
								"managed": "Toimiiko tämä yritys toisesta osoitteesta käsin?"
							},
							"subtitle": {
								"unmanaged": "Valitse Kyllä, jos hoidat liiketoimintaa muusta osoitteesta kuin kotiosoitteestasi.",
								"managed": "Valitse Kyllä, jos tämän yrityksen liiketoimintaa hoidetaan muusta osoitteesta kuin yksityisyrittäjän kotiosoitteesta."
							}
						},
						"title": "Anna yrityksen osoite",
						"fields": {
							"street": {
								"label": "Osoite",
								"errors": {
									"general": "Anna kelvollinen osoite"
								}
							},
							"postal_code": {
								"label": "Postinumero",
								"errors": {
									"general": "Anna kelvollinen postinumero"
								}
							},
							"city": {
								"label": "Kaupunki",
								"errors": {
									"general": "Anna kelvollinen kaupunki"
								}
							},
							"country": {
								"label": "Maa",
								"errors": {
									"general": "Anna kelvollinen maa"
								}
							},
							"region": {
								"label": "Maakunta",
								"errors": {
									"general": "Anna maakunta"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Onko yrityksessä henkilöitä joiden omistusosuus yrityksestä on yli 25%?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						],
						"default": [
							{
								"text": "Tosiasiallisten edunsaajien tiedustelu perustuu Lakiin rahanpesun ja terrorismin rahoittamisen estämisestä ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), jota olemme luottolaitoksena velvollisia noudattamaan. Yrityksesi muoto määrittelee keitä mahdolliset tosiasialliset edunsaajat ovat.Tosiasiallinen edunsaaja on aina luonnollinen henkilö."
							}
						]
					},
					"infobox": {
						"default": "Kirjoita jokaisen edunsaajan henkilötiedot ja virallinen kotiosoite",
						"AU": "Kirjoita jokaisen edunsaajan henkilötiedot ja virallinen kotiosoite. Näiden henkilöiden tulee olla luonnollisia henkilöitä yritysten osalta, joilla on monimutkaiset omistusrakenteet."
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin",
						"add_person": "+ Lisää henkilö"
					},
					"messages": {
						"lookup": "Omistavatko nämä henkilöt yrityksestäsi yli 25 %? Tarkista ja vahvista, ovatko tiedot oikein."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Mikä on yrityksesi osoite?",
						"managed": "Mikä on yrityksen liiketoiminnan rekisteröity osoite?"
					},
					"subtitle": {
						"unmanaged": "Tämä on osoite, johon yrityksesi on virallisesti rekisteröity, ja se näkyy Klarna-asiakkaidesi laskulla.",
						"managed": "Meidän tulee tietää, mihin osoitteeseen yritys on rekisteröity."
					},
					"question": {
						"title": {
							"unmanaged": "Toimitko toisesta osoitteesta käsin?",
							"managed": "Toimiiko tämä yritys toisesta osoitteesta käsin?"
						},
						"subtitle": {
							"unmanaged": "Valitse Kyllä, jos hoidat liiketoimintaa muusta osoitteesta kuin liiketoiminnan rekisteröidystä osoitteesta.",
							"managed": "Valitse Kyllä, jos tämän yrityksen liiketoimintaa hoidetaan muusta osoitteesta kuin liiketoiminnan rekisteröidystä osoitteesta."
						}
					},
					"toggle": {
						"title": "Lisää yrityksen vakituisen toimipaikan osoite"
					},
					"fields": {
						"company_name": {
							"label": "Yrityksen rekisteröity nimi",
							"errors": {
								"general": "Anna yrityksen nimi"
							}
						},
						"street": {
							"label": "Osoite",
							"errors": {
								"general": "Anna osoite"
							}
						},
						"postal_code": {
							"label": "Postinumero",
							"errors": {
								"general": "Anna postinumero"
							}
						},
						"city": {
							"label": "Kaupunki",
							"errors": {
								"general": "Anna kaupunki"
							}
						},
						"country": {
							"label": "Maa",
							"errors": {
								"general": "Anna maa"
							}
						},
						"state_of_incorporation": {
							"label": "State of incorporation (Yrityksen osavaltio Yhdysvalloissa)",
							"errors": {
								"general": "Anna State of incorporation (yrityksen osavaltio Yhdysvalloissa)"
							}
						},
						"state": {
							"label": "Maakunta",
							"errors": {
								"general": "Anna maakunta"
							}
						},
						"region": {
							"label": "Alue",
							"errors": {
								"puerto_rico": "Puerto Rico ei ole sallittu"
							}
						}
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"select_products": {
					"title": "Palvelumme",
					"title_kco_hidden": "Maksutapoja, jotka lisäävät myyntiä.",
					"subtitle": "Valitse palveluistamme itsellesi sopivat.",
					"subtitle_kco_hidden": "Hyödynnä asiakkaasi ostovoimaa. Tarjoa enemmän maksuvaihtoehtoja, jotta asiakkaasi voivat päättää, milloin ja miten he maksavat.",
					"platform_alert": null,
					"buttons": {
						"next": "Seuraava"
					}
				},
				"signup_products": {
					"title_line_1": "Klarna-tuotteet kauppaasi.",
					"title_kco_hidden_line_1": "Maksutapoja, jotka",
					"title_kco_hidden_line_2": "lisäävät myyntiä.",
					"subtitle": "Klarna-maksutapojen tarjoaminen nostaa konversiota keskimäärin 30 %, tilauksen keskimääräistä arvoa 41 % ja ostojen toistuvuutta 36 %.",
					"subtitle_kco_hidden": "Hyödynnä asiakkaasi ostovoimaa. Tarjoa enemmän maksuvaihtoehtoja, jotta asiakkaasi voivat päättää, milloin ja miten he maksavat.",
					"info_block": "Näytetään saatavilla olevat tuotteet",
					"special_offer": "Erikoistarjous: {percentageFee} % + {fixedFee} maksutapahtumaa kohti. Voimassa {validUntil} asti.",
					"buttons": {
						"contact_sales": "Myynnin yhteystiedot",
						"next": "Luo tili",
						"back": "Takaisin"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Takaisin",
						"next": "Seuraava"
					}
				},
				"business_concepts": {
					"title": "Valitse sovellettavat liiketoiminnan konseptit.",
					"subtitle": "Valitse vain ne, jotka koskevat sinua. Voit valita useita.",
					"errors": {
						"select_at_least_one": "Valitse vähintään yksi liiketoiminnan konsepti."
					},
					"buttons": {
						"next": "Seuraava",
						"back": "Takaisin"
					}
				},
				"confirm_copy": {
					"title": "Vahvista kopio",
					"disclaimer": "Mahdolliset olemassa olevat tiedot nykyisellä kauppiastunnuksella korvataan",
					"merchant_id": "{mid}:n tiedoilla",
					"buttons": {
						"skipCopy": "Älä kopioi",
						"confirmCopy": "Kopioi tiedot"
					}
				},
				"pre_assessment_summary": {
					"title": "Yhteenveto",
					"subtitle": "Tarkista tiedot huolellisesti ennen lähettämistä tai allekirjoittamista",
					"banner": {
						"mcc_deal": "Tämä on MCC-tarjous. Noudatathan MCC/ECC-indeksirutiinia"
					},
					"selling_countries": {
						"title": "Valitse markkina-alue, jolla on suurin odotettu volyymi.",
						"main_selling_country": "Pääasiallinen myyntimaa"
					},
					"pre_assessment_products": {
						"title": "Tuotteet"
					},
					"company_details": {
						"title": "Yrityksen tiedot"
					},
					"fca_number": {
						"title": "FCA-numero"
					},
					"high_exposure_questionnaires": {
						"title": "Korkeaan kurssiriskipositioon liittyvät kyselyt"
					},
					"mia_questionnaires": {
						"title": "MIA-kyselyt"
					},
					"buttons": {
						"back": "Takaisin",
						"edit": "Muokkaa",
						"submit": "Lähetä"
					}
				},
				"pre_assessment_overview": {
					"title": "Ennakkoarvioinnin yleiskatsaus",
					"subtitle_APPROVED": "Tämän vaihtoehdon hyväksyntään johtavat ehdot ovat jäljempänä.",
					"subtitle_REJECTED": "Tämän vaihtoehdon hylkäykseen johtavat ehdot ovat jäljempänä.",
					"subtitle_UNRESOLVED": "Voit muokata lähetettyjä tietoja, mikäli huomaat virheitä. Tämä ei käynnistä uutta tapausta.",
					"status": {
						"APPROVED": "Tämä tapaus on hyväksytty",
						"REJECTED": "Tämä tapaus on hylätty",
						"UNRESOLVED": "Odotetaan allekirjoituspäätöstä...",
						"UNRESOLVED_TIMED_OUT": "Tapaus käsitellään manuaalisen allekirjoituksen kautta. Huomaathan, että tässä voi kestää useamman päivän.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Tarkastele tapausta kauppiaan graafisen käyttöliittymän näkymässä",
						"STARTED": "Tämä tapaus on lähetetty arvioitavaksi"
					},
					"buttons": {
						"change": "Muuta",
						"new_case": "Uusi tapaus"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Hei!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Koska Klarna on Ruotsin rahoitusvalvontaviranomaisen säätelemä yhtiö, Klarnaa vaaditaan ehkäisemään rahanpesua EU-direktiivissä EU 2015/849 (mukaan lukien muutetut sekä korvaavat versiot) määritetyllä tavalla. Sinulle kauppiaana direktiivi tarkoittaa, että Klarna kerää tietoja yritystäsi hallitsevista henkilöistä (edunsaajat) ennen Klarnan palveluiden käytön aloittamista. Nykyisten kauppiaiden tulee antaa kyseiset tiedot säännöllisesti tietojen ajantasaisuuden varmistamiseksi. Lisätietoja saat "
							},
							{
								"text": "EU-direktiivistä",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Seuraava"
					}
				},
				"recollection_confirmation": {
					"title": "Vahvistus",
					"subtitle": "Tarkista tiedot huolellisesti ennen lähettämistä tai allekirjoittamista",
					"stakeholder": "Osakas {index}",
					"buttons": {
						"back": "Takaisin",
						"submit": "Lähetä"
					}
				},
				"recollection_overview": {
					"title": "Kiitos!",
					"subtitle": "Tässä yhteenveto tiedoista, jotka lähetit.",
					"stakeholder": "Osakas {index}",
					"notice": " Tietosi on lähetetty onnistuneesti."
				},
				"volume_separation": {
					"title_line_1": "Mikä on verkkoyrityksesi koko?",
					"subtitle": "Klarnalla on parhaat ratkaisut yrityksellesi sen koosta riippumatta.",
					"selector_title": "Vuotuinen liikevaihto",
					"below": "Alle {threshold}",
					"between": "Välillä {belowThreshold}–{aboveThreshold}",
					"over": "Yli {threshold}",
					"buttons": {
						"back": "Takaisin"
					}
				},
				"basic_info": {
					"title_line_1": "Aloita yhteistyösi",
					"title_line_2": "Klarnan kanssa.",
					"subtitle": "Tarvitsemme joitakin perustietoja päästäksemme alkuun.",
					"fields": {
						"email": {
							"label": "Yrityksen sähköposti",
							"field_link": "Eikö kyseessä ole yritys?",
							"errors": {
								"required": "Sähköpostiosoite on pakollinen",
								"invalid": "Kirjoita kelvollinen sähköpostiosoite"
							}
						},
						"email_confirmation": {
							"label": "Vahvista yrityksen sähköposti",
							"tooltip": "Yrityksen sähköposti on pääasiallinen tapa viestiä Klarnan kanssa. Varmista, että se on oikein",
							"errors": {
								"required": "Sähköpostiosoitteen vahvistus vaaditaan",
								"invalid": "Varmista, että olet kirjoittanut saman sähköpostiosoitteen kaksi kertaa"
							}
						},
						"website": {
							"label": "Verkkokaupan URL",
							"errors": {
								"required": "Verkkokaupan URL on pakollinen",
								"invalid": "Kirjoita kelvollinen URL"
							}
						},
						"country": {
							"label": "Rekisteröintimaa",
							"errors": {
								"general": "Valitse yksi saatavilla olevista maista"
							}
						}
					},
					"buttons": {
						"continue": "Jatka"
					}
				},
				"contact_details": {
					"title_line_1": "Jutellaan hiukan.",
					"subtitle": "Täytä tämä lomake ja otamme sinuun yhteyttä mahdollisimman pian tarjotaksemme yrityksellesi räätälöityjä ratkaisuja.",
					"fields": {
						"full_name": {
							"label": "Koko nimi",
							"errors": {
								"required": "Koko nimi on pakollinen"
							}
						},
						"phone": {
							"label": "Puhelinnumero",
							"tooltip": "Sinun tulee lisätä maakoodi, esim. +1 541 754 3010",
							"errors": {
								"required": "Puhelinnumero on pakollinen",
								"invalid": "Virheellinen puhelinnumero"
							}
						},
						"tell_us_more": {
							"label": "Kerro meille hieman lisää yrityksestäsi (valinnainen)"
						}
					},
					"buttons": {
						"back": "Takaisin",
						"submit": "Lähetä yhteystiedot"
					}
				},
				"contact_received": {
					"title": "Jutellaan pian lisää!",
					"message_1": "Myyntitiimimme ottaa sinuun yhteyttä mahdollisimman pian.",
					"message_2": "Tiimimme ottaa sinuun yhteyttä mahdollisimman pian. Olemme lähettäneet vahvistuksen tiedoista, jotka lähetit"
				},
				"we_are_sorry": {
					"title": "Pahoittelut, emme voi valitettavasti hyväksyä hakemustasi tällä hetkellä. ",
					"message_1_unsupported_country": "Klarna ei tällä hetkellä tue valitsemaasi maata:",
					"message_1_sensitive_goods": "Klarna ei tue valittua myynti kategoriaa: ",
					"message_1_platform": "Klarna ei tue valitsemaasi verkkokauppa-alustaa:",
					"message_2": "Pyrimme jatkuvasti solmimaan uusia kumppanuuksia, joten olemme yhteydessä kun voimme tulevaisuudessa jatkaa hakemuksesi käsittelyä. ",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Voit edelleen käyttää"
							},
							{
								"text": "lisäosaa",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "kumppaniltamme Mollielta."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Mitä alustaa käytät?",
					"subtitle": "Valitse verkkokauppa-alustasi ja integroimme yrityksesi tuota pikaa.",
					"custom": "Itse tehty integrointi",
					"other_platform": "Muita integrointiratkaisuja",
					"platform_search": {
						"label": "Verkkokauppa-alusta",
						"no_match": "Vastaavuuksia hakusanalle \"{input}\" ei löytynyt"
					},
					"buttons": {
						"back": "Takaisin"
					}
				},
				"partner": {
					"title_line_1": "Mitä maksupalvelukumppania haluat käyttää?",
					"subtitle": "Valitse maksupalvelukumppani, joka sopii parhaiten tarpeisiisi."
				},
				"account_creation_loading": {
					"title": "Tiliäsi luodaan...",
					"message": "Perustetaan Kauppiastunnustasi..."
				},
				"application_checking": {
					"title": "Tarkistetaan sovellustasi...",
					"message": "Analysoidaan kaupan tietoja"
				},
				"application_review": {
					"title": "Hakemuksesi on käsittelyssä.",
					"title_approved": "Hakemuksesi on hyväksytty!",
					"message": "Tämä prosessi on manuaalinen, joten käsittelyajat saattavat vaihdella. Pyrimme kuitenkin olemaan mahdollisimman nopeita.",
					"email_info_1": "Olemme lähettäneet sinulle sähköpostia aiheella ”{subject}”.",
					"email_info_2": "Kirjaudu sisään ja seuraa hakemuksesi tilaa noudattamalla sähköpostin sisältämiä ohjeita.",
					"email_info_2_approved": "Kirjaudu sisään ja integroi Klarna verkkokauppaasi noudattamalla sähköpostin sisältämiä ohjeita.",
					"email_subject": "Tervetuloa Klarnan Kauppiasportaaliin",
					"resend_email": "Lähetä sähköposti uudelleen"
				},
				"user_already_exists": {
					"title": "Jatka kirjautumalla sisään Kauppiasportaaliin.",
					"message_1": "Tämä sähköpostiosoite on jo yhdistetty toiseen Kauppiasportaalin tiliin. Jos haluat tehdä muutoksia olemassa olevaan tiliin, kirjaudu sisään",
					"log_in": "Kirjaudu sisään Kauppiasportaaliin",
					"forgot_password": "Unohditko salasanasi?"
				},
				"otherPlatform": {
					"info": "Meillä on jo integrointi alustalle {platform}",
					"link": "Aloita integrointi täällä",
					"title": "Smooothia, voit integroida suoraan!",
					"info2": "Hyviä uutisia! Voit integroida Klarnan verkkokauppaasi suoraan alustalta <strong>{platform}</strong>.",
					"link2": "Siirry alustalle {platform} + Klarna-integrointiin"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Otathan yhteyttä suoraan myyntitiimiimme",
							"SE": "Otathan yhteyttä suoraan myyntitiimiimme"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Tarjoatko mitään seuraavista tuotteista tai palveluista?",
					"subtitle_2": "Klarna saattaa määrittää jotkut tuotteet rajoitetuiksi markkina-alueen, lakien, myyntivolyymin, riskinottohalukkuuden ja muiden mahdollisesti sallittavien rajoitusten vuoksi. Näitä tuotteita ei voi käsitellä ilman Klarnan hyväksyntää.",
					"titleV2": "Valitse, mikä jäljempänä mainituista koskee yritystäsi.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Tuotteet, joissa on ikäraja",
							"description_2": "Tupakka, sähkötupakka, sähkösavukkeet, kannabistuotteet, alkoholi, aikuissisältö"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Matkailu, tutustumiskierrokset ja tapahtumat",
							"description_2": "Kuljetus, tapahtumat, lippualustat, hotellit ja majoituspalvelut, vuokraukset, retkitoimistot"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Luvanvaraiset aseet",
							"description_2": "Ampumatarvikkeet, taisteluteräaseet, metsästystarvikkeet, pamput, pippurisumutteet"
						},
						"MARKETPLACE": {
							"title_2": "Vertaismarkkinat",
							"description_2": "Palvelut, joiden avulla kolmannet osapuolet voivat jälleenmyydä tavaroitaan tai palveluitaan verkkoalustan välityksellä"
						},
						"PHARMACEUTICALS": {
							"title_2": "Lääkkeet ja lääketieteelliset palvelut",
							"description_2": "Reseptilääkkeiden jakelu, lääketieteelliset toimenpiteet, myös esteettiset toimenpiteet sekä tatuoinnit"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Jäsenyydet, tilaukset ja palvelut",
							"description_2": "Fyysisten tuotteiden, digitaalisen sisällön, suoratoistopalveluiden, deittisivustojen jne. kestotilaukset"
						},
						"NONE": {
							"title_2": "Tarjoan erityyppisiä tuotteita/palveluita"
						}
					},
					"link": "Lisätietoja rajoitetuista tuotteista",
					"buttons": {
						"next": "Seuraava",
						"continue": "Jatka"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Täytä muut osat osoitteestasi automaattisesti kirjoittamalla postinumerosi",
						"US": "Täytä muut osat osoitteestasi automaattisesti kirjoittamalla postinumerosi"
					},
					"label": {
						"default": "Postinumero",
						"US": "Postinumero"
					},
					"error": {
						"default": "Kirjoita kelvollinen postinumero",
						"US": "Kirjoita kelvollinen postinumero"
					}
				},
				"city": {
					"label": "Kaupunki",
					"error": "Kaupunki puuttuu"
				},
				"street": {
					"label": "Osoite",
					"error": "Virallinen kotiosoite puuttu",
					"tooltip": "Aloita kirjoittaminen nähdäksesi lisää katuehdotuksia",
					"no_suggestion_found": "Ei vastaavuuksia hakusanalle {input}"
				},
				"country": {
					"label": "Maa",
					"error": "Valitse maa"
				},
				"region": {
					"label": "Maakunta/alue (valinnainen)"
				},
				"state": {
					"label": "Maakunta",
					"error": "Kirjoita maakunta"
				}
			},
			"platforms": {
				"custom": "API-integrointi",
				"other": "En löydä alustaani"
			},
			"buttons": {
				"back": "Takaisin"
			},
			"products": {
				"not_available": "Ei saatavilla {reason}:llä",
				"not_available_country": "Ei saatavilla maassasi",
				"not_available_platform": "Ei saatavilla alustalla {platform}",
				"why_product": "Miksi Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Vaihda kauppasi kassa Klarnan kattaviin kassapalveluihin."
					},
					"description_expanded": {
						"default": "Vaihda kauppasi kassa Klarnan kattaviin kassapalveluihin."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Maksa heti"
							},
							"description": {
								"default": "Tarjoa maksua välittömästi kortilla tai pankkisiirrolla."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Maksa 30 päivän kuluessa"
							},
							"description": {
								"default": "Tarjoa 30 päivää maksuaikaa. Ei korkoa."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Rahoitus"
							},
							"description": {
								"default": "Tarjoa maksuaikaa 6–36 kuukautta.",
								"DE": "Tarjoa maksuaikaa 6–24 kuukautta",
								"AT": "Tarjoa maksuaikaa 6–24 kuukautta."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "erään"
							},
							"description": {
								"default": "Tarjoa 3 korotonta erää.",
								"GB": "Tarjoa 3 korotonta erää."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Pilko maksut 4",
								"US": "erään",
								"AU": "Maksa 4 erässä"
							},
							"description": {
								"default": "Tarjoa 4 korotonta erää.",
								"GB": "Tarjoa 4 korotonta erää."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Muut maksuvaihtoehdot"
							},
							"description": {
								"default": "Luottokortit, pankkikortit ja muut"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "Viestintä sivulla"
							}
						},
						"billing": {
							"name": {
								"default": "Automaattinen tunnistautuminen ja laskutus"
							}
						},
						"shipping": {
							"name": {
								"default": "Henkilökohtaiset toimitusvaihtoehdot"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Ostotapahtuman jälkeinen tuki"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Payment Method"
					},
					"description": {
						"default": "Lisää Klarnan maksutavat nykyiseen kassaasi"
					},
					"description_expanded": {
						"default": "Klarna-maksutapojen tarjoaminen nostaa konversiota keskimäärin 30 %, tilauksen keskimääräistä arvoa 41 % ja ostojen toistuvuutta 36 %."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Maksa heti"
							},
							"description": {
								"default": "Tarjoa maksua välittömästi kortilla tai pankkisiirrolla."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Maksa 30 päivän kuluessa"
							},
							"description": {
								"default": "Asiakkaan maksavat 30 päivää oston jälkeen, ei korkoa."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Rahoitus"
							},
							"description": {
								"default": "Asiakkaat voivat maksaa 6–36 kuukauden kuluessa.",
								"DE": "Asiakkaat voivat maksaa 6–24 kuukauden kuluessa.",
								"AT": "Asiakkaat voivat maksaa 6–24 kuukauden kuluessa."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "erään"
							},
							"description": {
								"default": "Tarjoa 3 korotonta erää.",
								"GB": "Tarjoa 3 korotonta erää."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Pilko maksut 4",
								"US": "4 maksuerää",
								"CA": "4 maksua",
								"AU": "Maksa 4 erässä"
							},
							"description": {
								"default": "Tarjoa 4 korotonta erää.",
								"GB": "Tarjoa 4 korotonta erää.",
								"US": "Arvoltaan 35–1 000 $:n tilaukset voidaan pilkkoa neljään korottomaan maksuerään, jotka erääntyvät kahden viikon välein.",
								"CA": "Arvoltaan 35–1 000 $:n tilaukset voidaan pilkkoa neljään korottomaan maksuerään, jotka erääntyvät kahden viikon välein."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Maksa kortilla"
							},
							"description": {
								"default": "Tarjoa maksua välittömästi kortilla tai pankkisiirrolla."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Miten suunnittelet tekeväsi myyntiä?",
					"options": {
						"IN_STORE": "Fyysinen kauppa",
						"TELESALES": "Puhelinmyynti"
					},
					"description": {
						"IN_STORE": "Myynti tapahtuu pääasiassa henkilökohtaisesti, ja asiakas saa tuotteet saman tien.",
						"TELESALES": "Myynti tapahtuu pääasiassa puhelimitse asiakkaan aloitteesta. Asiakas ei saa tuotteita saman tien."
					}
				},
				"country": {
					"label": "Maa"
				},
				"organization_category": {
					"label": "Oikeussubjektityyppi",
					"options": {
						"SOLE_TRADER": "Yksityisyrittäjä",
						"PARTNERSHIP": "Kumppanuus",
						"UNDEFINED": "MÄÄRITTÄMÄTÖN",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "C-yritys",
						"S_CORP": "S-yritys",
						"TRUST_ESTATE": "Säätiö/kiinteistö",
						"INDIVIDUAL": "Yksittäinen",
						"SOLE_PROPRIETORSHIP": "Yksityinen elinkeinonharjoittaja",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Yksijäseninen osakeyhtiö",
						"LIMITED_LIABILITY_COMPANY": "Osakeyhtiö",
						"PUBLIC_LISTED_COMPANY": "Julkinen pörssiyhtiö",
						"PRIVATE_COMPANY": "YKSITYINEN_YRITYS"
					}
				},
				"store_category": {
					"label": "Myytävän tavaran pääluokka",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Vaatteet ja kengät – Aikuisten kengät ja vaatteet",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Autoalan tuotteet – Autoalan osat ja lisävarusteet",
						"BAGS_AND_WALLETS": "Korut ja somisteet – Laukut ja lompakot",
						"BODY_AND_HAIR_CARE": "Terveys ja kauneudenhoito – Vartalon- ja hiustenhoito",
						"BOOK_AND_MAGAZINES": "Viihde – Kirjat ja lehdet",
						"CANDY": "Ruoka ja juoma - Makeiset",
						"CAR_ELECTRONICS": "Elektroniikka – Autoelektroniikka",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Lasten tuotteet – Lasten vaatteet ja lastenhoitotuotteet",
						"CHILDREN_TOYS": "Lasten tuotteet – Lelut",
						"CLEANING_AND_SANITARY": "Koti ja puutarha – Siivous ja puhdistaminen",
						"COLLECTIBLES": "Vapaa-aika, urheilu ja harrastukset – Keräilytuotteet",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Vapaa-aika, urheilu ja harrastukset – Merkkiliikkeet ja sekalaiset",
						"COSMETICS": "Terveys ja kauneudenhoito – Kosmetiikka",
						"COSTUMES_AND_PARTY_SUPPLIES": "Vapaa-aika, urheilu ja harrastukset – Asut ja juhlatarvikkeet",
						"DATING_SERVICES": "Aineettomat tuotteet – Treffipalvelut",
						"DECORATION_AND_ART": "Koti ja puutarha – Sisustus ja taide",
						"DIETARY_SUPPLEMENTS": "Terveys ja kauneudenhoito – Ravinnelisät",
						"DIGITAL_SERVICES": "Aineettomat tuotteet – Digitaaliset palvelut",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Lasten tuotteet – Monialaiset lasten tuotteet",
						"DIVERSIFIED_ELECTRONICS": "Elektroniikka – Monialainen elektroniikka",
						"DIVERSIFIED_ENTERTAINMENT": "Viihde – Monialainen viihde",
						"DIVERSIFIED_EROTIC_MATERIAL": "Eroottinen materiaali – Monialainen eroottinen materiaali",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Terveys ja kauneudenhoito – Monialaiset terveys- ja kauneudenhoitotuotteet",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Koti ja puutarha – Monialaiset koti- ja puutarhatuotteet",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Korut ja somisteet – Monialaiset korut ja somisteet",
						"EDUCATION": "Aineettomat tuotteet – Koulutus",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektroniikka – Elektroniset laitteet ja lisävarusteet",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Eroottinen materiaali – Eroottiset vaatteet ja somisteet",
						"EVENT_TICKETS": "Aineettomat tuotteet – Tapahtumaliput",
						"FOOD_AND_BEVERAGE": "Ruoka ja juoma – Ruoka ja juoma",
						"FRAGRANCES": "Terveys ja kauneudenhoito – Tuoksut",
						"FURNITURE": "Koti ja puutarha – Huonekalut",
						"GENERAL_SHOES_AND_CLOTHING": "Vaatteet ja kengät – Yleiset kengät ja vaatteet",
						"HOBBY_ARTICLES": "Vapaa-aika, urheilu ja harrastukset – Harrastustarvikkeet",
						"HOUSEHOLD_ELECTRONICS": "Elektroniikka – Kodin elektroniikka",
						"JEWELRY_AND_WATCHES": "Korut ja somisteet – Korut ja kellot",
						"KITCHENWARE": "Koti ja puutarha – Keittiötarvikkeet",
						"MARKETPLACES": "Aineettomat tuotteet – Markkinapaikat",
						"MUSIC_AND_MOVIES": "Viihde – Musiikki ja elokuvat",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Vapaa-aika, urheilu ja harrastukset – Soittimet ja varusteet",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Korut ja somisteet – Käsikaupalla myytävät aurinkolasit ja linssit",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektroniikka – Toimiston koneet ja varusteet",
						"OTHER_SERVICES": "Aineettomat tuotteet – Muut palvelut",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Terveys ja kauneudenhoito – Henkilökohtainen hyvinvointi ja kehonhuolto",
						"PET_SUPPLIES": "Koti ja puutarha – Lemmikkieläintarvikkeet",
						"PHARMACEUTICAL_PRODUCTS": "Terveys ja kauneudenhoito – Farmaseuttiset tuotteet",
						"PLANTS_AND_FLOWERS": "Koti ja puutarha – Kasvit ja kukat",
						"PRESCRIPTION_OPTICS": "Terveys ja kauneudenhoito – Reseptioptiikka",
						"PRINTS_AND_PHOTOS": "Vapaa-aika, urheilu ja harrastukset – Tulosteet ja valokuvat",
						"SAFETY_PRODUCTS": "Koti ja puutarha – Turvallisuustuotteet",
						"SEX_TOYS": "Eroottinen materiaali – Seksilelut",
						"SPORTS_GEAR_AND_OUTDOOR": "Vapaa-aika, urheilu ja harrastukset – Urheiluvälineet ja ulkoilu",
						"TOBACCO": "Ruoka ja juoma – Tupakka",
						"TOOLS_AND_HOME_IMPROVEMENT": "Koti ja puutarha – Työkalut ja kodinparannus",
						"TRAVEL_SERVICES": "Aineettomat tuotteet – Matkailupalvelut",
						"UNDERWEAR": "Vaatteet ja kengät – Alusvaatteet",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Viihde – Videopelit ja lisävarusteet",
						"WHEELS_AND_TIRES": "Autoalan tuotteet – Renkaat ja pyörät",
						"WINE_BEER_AND_LIQUOR": "Ruoka ja juoma – Viini, olut ja liköörit",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Vaatteet ja kengät – Nuorten kengät ja vaatteet"
					}
				},
				"currency": {
					"label": "Valuutta"
				},
				"account_type": {
					"label": "Pankkitilin tyyppi",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Paikallinen Ruotsi",
						"LOCAL_US": "Paikallinen Yhdysvallat",
						"LOCAL_GENERIC": "Paikallinen Norja/Tanska",
						"SPECIAL": "Erityinen",
						"BANKGIRO": "Paikallinen Ruotsi Bankgiro",
						"PLUSGIRO": "Paikallinen Ruotsi Plusgiro"
					}
				},
				"person_role": {
					"label": "Rooli",
					"options": {
						"LEGAL_REPRESENTATIVE": "Laillinen edustaja",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Vaihtoehtoinen edunsaaja",
						"ULTIMATE_BENEFICIAL_OWNER": "Tosiasiallinen edunsaaja",
						"OWNER": "Omistaja"
					}
				},
				"business_size": {
					"label": "Yrityksen koko",
					"options": {
						"LARGE": "suuri",
						"MEDIUM": "keskisuuri",
						"small": "pieni"
					}
				},
				"sensitive_good_category": {
					"label": "Tarjoatko fyysisessä kaupassasi mitään seuraavista tuotteista tai palveluista?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Tuotteet, joissa on ikäraja",
						"LICENSED_WEAPONS": "Luvanvaraiset aseet",
						"PHARMA_AND_MEDICAL_SERVICES": "Lääkkeet ja lääketieteelliset palvelut",
						"TRAVEL_TOURS_EVENTS": "Matkailu, tutustumiskierrokset ja tapahtumat",
						"PEER_TO_PEER_MARKETPLACE": "Vertaismarkkinat",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Jäsenyydet, tilaukset ja palvelut",
						"NONE": "Tarjoan erityyppisiä tuotteita/palveluita"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tupakka, sähkötupakka, sähkösavukkeet, kannabistuotteet, alkoholi, aikuissisältö",
						"LICENSED_WEAPONS": "Ampumatarvikkeet, taisteluteräaseet, metsästystarvikkeet, pamput, pippurisumutteet",
						"PHARMA_AND_MEDICAL_SERVICES": "Reseptilääkkeiden jakelu, lääketieteelliset toimenpiteet, myös esteettiset toimenpiteet sekä tatuoinnit",
						"TRAVEL_TOURS_EVENTS": "Kuljetus, tapahtumat, lippualustat, hotellit ja majoituspalvelut, vuokraukset, retkitoimistot",
						"PEER_TO_PEER_MARKETPLACE": "Palvelut, joiden avulla kolmannet osapuolet voivat jälleenmyydä tavaroitaan tai palveluitaan verkkoalustan välityksellä",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Fyysisten tuotteiden, digitaalisen sisällön, suoratoistopalveluiden, deittisivustojen jne. kestotilaukset",
						"NONE": "Tarjoan erityyppisiä tuotteita/palveluita"
					},
					"error_message": "Pahoittelemme. Emme pysty jatkamaan hakemuksesi käsittelyä, sillä emme parhaillamme tue sen kaltaisia tuotteita tai palveluita, jotka olet valinnut."
				}
			},
			"common": {
				"country": {
					"label": "Maa"
				},
				"address": {
					"city": {
						"label": "Kaupunki"
					},
					"postal_code": {
						"label": "Postinumero"
					},
					"region": {
						"label": "Maakunta/alue"
					},
					"street_address": {
						"label": "Fyysisen kaupan osoite"
					},
					"street_address2": {
						"label": "Osoiterivi 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Yrityksen nimi"
					},
					"registration_authority": {
						"label": "Rekisteröintiviranomainen"
					},
					"registration_id": {
						"label": "Y-tunnus"
					},
					"subject_to_vat": {
						"label": "Onko yrityksesi rekisteröity ALV-rekisteriin?"
					},
					"vat_id": {
						"label": "ALV-tunnus"
					},
					"persons": {
						"date_of_birth": {
							"label": "Syntymäaika"
						},
						"first_name": {
							"label": "Etunimi"
						},
						"last_name": {
							"label": "Sukunimi"
						},
						"person_identity_document": {
							"label": "Henkilöllisyystodistus"
						},
						"person_proof_of_address": {
							"label": "Todiste osoitteesta"
						},
						"personal_identifier": {
							"label": "Henkilöturvatunnus"
						}
					},
					"should_auto_capture_orders": {
						"label": "Haluatko aktivoida tilauksia automaattisesti?",
						"tooltip": "Tilaukset tulee aktivoida, kun ne luovutetaan myymälässä tai lähetetään varastolta. Kun valitset automaattisen aktivoinnin, tilaus aktivoidaan automaattisesti asiakkaan vahvistaessa oston."
					}
				},
				"contract_entity": {
					"label": "Sopimusperusteinen oikeussubjekti"
				},
				"contract_onboarding_type": {
					"label": "Liikekumppanin perehdytystyyppi"
				},
				"underwriting_inquiry_email": {
					"label": "Merkintäsähköposti"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Tilinhaltijan nimi"
					},
					"account_number": {
						"label": "Tilinumero"
					},
					"bic": {
						"label": "BIC-koodi"
					},
					"iban": {
						"label": "Tilinumero (IBAN)"
					},
					"is_default": {
						"label": "Käytä tätä tiliä määrittämättömien valuuttojen osalta"
					},
					"routing_number": {
						"label": "Reititysnumero"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "Sähköpostiosoite yhteydenottoja varten"
					},
					"name": {
						"label": "Kaupan nimi"
					},
					"support_email": {
						"label": "Asiakaspalvelun sähköpostiosoite"
					},
					"support_phone": {
						"label": "Tukipuhelinnumero"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Perinteinen irtaimen tavaran myynti",
							"VOUCHER": "Kuponki",
							"MEMBERSHIP": "Jäsenyys",
							"SUBSCRIPTION": "Ennakkotilaus",
							"PHARMACIES": "Apteekit",
							"US_PHARMACIES": "Apteekit Yhdysvalloissa",
							"MEDICAL_SERVICES": "Terveydenhuoltopalvelut",
							"MARKETPLACES": "Markkinapaikat",
							"FIREARM_DEALERS": "Tuliaseiden myyjät",
							"AUCTIONS": "Huutokaupat",
							"ALCOHOL": "Alkoholi",
							"TOBACCO": "Tupakka",
							"HEMP_CBD_THC": "Hamppu, CBD tai THC",
							"DONATIONS_CHARITY": "Lahjoitukset ja hyväntekeväisyys",
							"TRAVEL": "Matkailu",
							"EVENTS": "Tapahtumat",
							"COURSES": "Kurssit",
							"EDUCATIONAL_COURSES": "Kurssit",
							"FOOD_DELIVERY": "Ruokatoimitukset",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Mukautettu ennakkotilaus/Kalusteet",
							"DIGITAL_CONTENT": "Digitaalinen sisältö",
							"GAMING_INDUSTRY": "Peliteollisuus (uhkapelit, vedonlyönti, kasinot ja arvonnat)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "Ehdot",
					"UPSELL_WEBSTORE_TO_KPOS": "Klarna In-storen ehdot"
				},
				"pricing_terms": {
					"default": "Hinnoitteluehdot",
					"UPSELL_WEBSTORE_TO_KPOS": "Klarna In-storen hinnat"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Lisätiedot",
				"bank_account": "Mitkä ovat pankkitilitietosi?",
				"business_size": "Mikä on Klarna Point of Salen kautta saatava arvioitu vuotuinen volyymi?",
				"in_store_get_started": "Liitä yrityksesi liiketoiminta Klarnaan.",
				"in_store_legal_form": "Minkä tyyppistä liiketoimintasi on?",
				"in_store_registered_address": "Mikä on yrityksesi rekisteröity osoite?",
				"in_store_registration": "Onko yrityksesi rekisteröity yritys?",
				"in_store_stakeholder": "Kuka johtaa yritystä?",
				"in_store_stores": "Mitkä ovat kauppasi tiedot Klarna Point of Salea varten?",
				"in_store_vat": "Onko yrityksesi rekisteröity ALV-rekisteriin?",
				"product_channel": "Miten yrityksesi suunnittelee hyödyntävänsä Klarna Point of Salea?",
				"sensitive_goods": "Minkä kategorian tuotteita aiot myydä Klarna Point of Salella?",
				"ads_manager_get_started": "Melkein valmista.",
				"content_store_get_started": "Melkein valmista."
			},
			"subtitle": {
				"additional_data": "Tarkistamme hakemustasi ja tarvitsemme joitakin lisätietoja jatkaaksemme.",
				"bank_account": "Klarna-maksutapahtumat siirretään tälle pankkitilille.",
				"business_size": "Tarvitsemme joitakin yrityksesi perustietoja hakemuksen käsittelyyn.",
				"in_store_get_started": "Tarvitsemme joitakin perustietoja saadaksemme asiat käsittelyyn",
				"in_store_legal_form": "Meitä edellytetään kysymään tiettyjä kysymyksiä liiketoimintatyyppisi perusteella.",
				"in_store_registered_address": "Tämä on paikka, jossa yrityksesi on rekisteröity laillisesti ja näkyy Klarnan asiakaslaskuissasi.",
				"in_store_registration": "Tarvitsemme yrityksesi rekisterinumeron vahvistaaksemme liiketoimintasi tiedot.",
				"in_store_stakeholder": "Rahoituslaitoksena meidän on kerättävä nämä tiedot",
				"in_store_stores": "Käytämme tietoja uuden Klarna Point of Sale -tilisi perustamiseen.",
				"in_store_vat": "Mikäli sinulla on ALV-tunnus, pystymme vahvistamaan yritystietosi helpommin.",
				"product_channel": "Valitse pääasiallinen myyntikanavasi. Voit käyttää Klarna Point of Salea kummassakin kanavassa.",
				"sensitive_goods": "Klarna Point of Salen itsepalveluperehdytys ei salli sinun myydä tuotteita, jotka Klarna on määritellyt rajoitetuiksi.",
				"ads_manager_get_started": "Anna laskutussähköpostiosoite, johon kampanjalaskut lähetetään. Sinun tulee olla ylläpitäjä voidaksesi aktivoida tilin. Ylläpitäjä voi myöntää lupia muille käyttäjille.",
				"content_store_get_started": "Ennen Content Manageriin pääsemistä lue ja hyväksy ehtomme."
			},
			"summary": {
				"title": "Tarkista tietosi ennen hakemuksen lähettämistä"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Käsittelemme hakemustasi. Tämä saattaa kestää hetken.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Odota...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Odota..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Hakemustasi käsitellään, ja olemme luomassa sinulle uutta kauppiastunnusta."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Valmistelemme Ads Manager -tiliäsi."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Valmistelemme Content Manager -tiliäsi."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Onneksi olkoon! Hakemuksesi on hyväksytty.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Kaikki on valmista!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Kaikki on valmista!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Nyt voimme integroida Klarnan verkkokauppaasi. Siirry kauppiasportaalin tilisi Tuotteet-välilehteen ja etsi integrointitiedot ja ohjeet niiden käyttöön."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Perustetaanpa kauppasi nyt, niin voit alkaa saada maksuja saman tien."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Siirry Ads Manageriin ja luo ensimmäinen kampanjasi."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Siirry Content Manageriin ja julkaise ensimmäinen tarjouksesi tänään."
							}
						]
					},
					"second_title": {
						"default": "Saat lisätietoja integroinnista Klarnan kanssa käymällä Klarna-asiakirjoissa.",
						"UPSELL_WEBSTORE_TO_KPOS": "Tarvitsetko apua kauppasi perustamisen kanssa? Olemme täällä apunasi",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Tarvitsetko apua Ads Managerin kanssa? Katso yleisimmät kysymyksemme tai ota yhteyttä yritystukeen. Autamme sinua mielellämme.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Tarvitsetko apua Content Managerin kanssa? Katso yleisimmät kysymyksemme tai ota yhteyttä yritystukeen. Autamme sinua mielellämme."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Parhaiden käytäntöjemme ohjeet auttavat optimoimaan uuden kumppanuutemme."
							},
							{
								"text": "Klarna Checkout -kassa",
								"link": "#"
							},
							{
								"text": "Klarna Payments",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Ota yhteyttä kauppiastukeen. Autamme sinua mielellämme."
							},
							{
								"text": "Ota yhteyttä tukeen",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Käy katsomassa yleisimmät kysymykset.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Käy katsomassa yleisimmät kysymykset.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Aloitetaan.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Aloitetaan",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Aloitetaan",
						"UPSELL_WEBSTORE_TO_KPOS": "Aloita myyminen"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Kiitos! Tarkistamme hakemustasi.",
					"badge": "Noin 5-7 päivää",
					"paragraphs": [
						{
							"text": "Saat sähköpostin, kun tarkistus on valmis tai jos tarvitsemme lisätietoja."
						}
					],
					"second_title": "Sillä välin tarkista sähköpostisi",
					"second_paragraphs": [
						{
							"text": "Olemme lähettäneet sinulle sähköpostin, jonka aiheena on ”Tervetuloa Klarnan kauppiasportaaliin”. Noudata ohjeita sisäänkirjautumista ja tilin aktivoimista varten."
						}
					]
				},
				"SUSPENDED": {
					"title": "Valitettavasti hakemustasi ei hyväksytty.",
					"paragraphs": [
						{
							"text": "Yritystietojesi tarkistamisen jälkeen emme voi viedä yrityksen <strong>{businessName}</strong> hakemustasi eteenpäin."
						},
						{
							"text": "Tässä on joitakin yleisimpiä syitä:"
						},
						{
							"list": [
								{
									"text": "Kauppasi ei ole Klarnan eettisten käytäntöjen mukainen."
								},
								{
									"text": "Asiakaspalveluusi ei saatu yhteyttä."
								},
								{
									"text": "Muut hallinnolliset tekijät."
								}
							]
						},
						{
							"text": "Kiitos mielenkiinnosta <strong>Klarna [In-storea]</strong> kohtaan. Toivottavasti voimme tehdä yhteistyötä tulevaisuudessa."
						}
					],
					"second_title": "Jos sinulla on lisäkysymyksiä",
					"second_paragraphs": [
						{
							"text": "päätöksestämme tai muista Klarna-tuotteista, ota meihin yhteyttä ja autamme mielellämme."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Kuka on valtuutettu allekirjoittamaan sopimuksia yrityksen puolesta?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Yrityksesi on solmimassa sopimuksen Klarnan kanssa. Meidän tulee vahvistaa, kuka on laillisesti valtuutettu allekirjoittamaan sopimuksia."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Onko yrityksessä henkilöitä joiden omistusosuus yrityksestä on yli 25%?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						],
						"default": [
							{
								"text": "Tosiasiallisten edunsaajien tiedustelu perustuu Lakiin rahanpesun ja terrorismin rahoittamisen estämisestä ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), jota olemme luottolaitoksena velvollisia noudattamaan. Yrityksesi muoto määrittelee keitä mahdolliset tosiasialliset edunsaajat ovat.Tosiasiallinen edunsaaja on aina luonnollinen henkilö."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Kuka johtaa yritystä?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Rahanpesun torjunnasta annetun EU:n lainsäädännön ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), jota olemme luottolaitoksena velvollisia noudattamaan. Yrityksesi muoto määrittelee keitä mahdolliset tosiasialliset edunsaajat ovat.Tosiasiallinen edunsaaja on aina luonnollinen henkilö."
							}
						],
						"US": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						],
						"CA": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						],
						"AU": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Onko yrityksessä henkilöitä joiden omistusosuus yrityksestä on yli 25%?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Laki edellyttää meitä rahoituslaitoksena keräämään nämä tiedot."
							}
						],
						"default": [
							{
								"text": "Tosiasiallisten edunsaajien tiedustelu perustuu Lakiin rahanpesun ja terrorismin rahoittamisen estämisestä ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "), jota olemme luottolaitoksena velvollisia noudattamaan. Yrityksesi muoto määrittelee keitä mahdolliset tosiasialliset edunsaajat ovat.Tosiasiallinen edunsaaja on aina luonnollinen henkilö."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Ratkaisut",
					"title_2": "Maksutavat",
					"note": "Kaikki hinnat ovat maksutapahtumakohtaisia.",
					"per_transaction": "maksutapahtumaa kohti",
					"cross_border_notice": "Ylimääräisiä rajat ylittäviä maksuja saatetaan veloittaa",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "katso",
						"link_text": "hintaliite"
					},
					"not_available_for_business": "Ei saatavilla yrityksellesi",
					"not_available_for_country": "Voit myydä vain muilla markkina-alueilla",
					"not_compatible_with_platform": "Ei saatavilla alustallasi",
					"installed": "Asennettu"
				},
				"buttons": {
					"next": "Seuraava"
				}
			}
		}
	}
};